webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/171h2Dg/%3F1731179601044&title=One%20Red%20Bastard&summary=In%20this%20thrilling%20sequel%20to%20the%20highly%20acclaimed%20Snakes%20Can%26%238217%3Bt%20Run%2C%20detective%20Robert%20Chow%20must%20wrestle%20with%20his%20own%20morality%20to%20solve%20a%20murder%2C%20set%20against%20the%20backdrop%20of%20gritty%20Chinatown%20following%20the%20Vietnam%20War.It%26%238217%3Bs%20the%20fal&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/171h2Dg/%3F1731179601044",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=In%20this%20thrilling%20sequel%20to%20the%20highly%20acclaimed%20Snakes%20Can%26%238217%3Bt%20Run%2C%20detective%20Robert%20Chow%20must%20wrestle%20with%20his%20own%20morality%20to%20s%0Dhttps://textcafe.co/books/171h2Dg/%3F1731179601044&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/171h2Dg/%3F1731179601044&posttype=link&caption=In%20this%20thrilling%20sequel%20to%20the%20highly%20acclaimed%20Snakes%20Can%26%238217%3Bt%20Run%2C%20detective%20Robert%20Chow%20must%20wrestle%20with%20his%20own%20morality%20to%20solve%20a%20murder%2C%20set%20against%20the%20backdrop%20of%20gritty%20Chinatown%20following%20the%20Vietnam%20War.It%26%238217%3Bs%20the%20fal",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/171h2Dg/%3F1731179601044&description=In%20this%20thrilling%20sequel%20to%20the%20highly%20acclaimed%20Snakes%20Can%26%238217%3Bt%20Run%2C%20detective%20Robert%20Chow%20must%20wrestle%20with%20his%20own%20morality%20to%20solve%20a%20murder%2C%20set%20against%20the%20backdrop%20of%20gritty%20Chinatown%20following%20the%20Vietnam%20War.It%26%238217%3Bs%20the%20fal&media=https://textcafe.co/books/171h2Dg/tc-custom/9780062444202.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780062444202&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=iXnlCQAAQBAJ&amp;rdid=book-iXnlCQAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780062444202').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/171h2Dg/tc-custom/9780062444202.jpg?1731179601044',
        alt: 'One Red Bastard'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "text/nav", "text/9780062444202_Chapter_1", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/171h2Dg/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_9780062444202_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_9780062444202_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_text_9780062444202_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_love_1__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_text_9780062444202_Titlepage__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_text_9780062444202_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_text_9780062444202_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_9780062444202_Dedication__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_9780062444202_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_text_9780062444202_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_9780062444202_Epigraph__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_9780062444202_Epigraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_text_9780062444202_Epigraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_nav__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_text_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_9780062444202_Chapter_1__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_9780062444202_Chapter_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_text_9780062444202_Chapter_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_9780062444202_Acknowledgments__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_9780062444202_Acknowledgments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_text_9780062444202_Acknowledgments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_About_the_Author__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_About_the_Author___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_text_About_the_Author__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_9780062444202_Also_by__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_9780062444202_Also_by___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_text_9780062444202_Also_by__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_9780062444202_BA1__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_9780062444202_BA1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_text_9780062444202_BA1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_9780062444202_Copyright__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_9780062444202_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_text_9780062444202_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_love_2__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_text_About_the_Publisher__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_text_About_the_Publisher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_text_About_the_Publisher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_last__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_last__);
/*jshint esversion: 6 */





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/text/nav",
    "name": "text/nav",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_text_nav___default.a
  }, {
    "path": "/text/9780062444202_Chapter_1",
    "name": "text/9780062444202_Chapter_1",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_text_9780062444202_Chapter_1___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ed Lin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Ed Lin, a native New Yorker of Taiwanese and Chinese descent, is the first author to win three Asian American Literary Awards and is an all-around standup kinda guy. His books include "), _c('I', [_vm._v("Waylaid")]), _vm._v(" and T"), _c('I', [_vm._v("his Is a Bust")]), _vm._v(", both published by Kaya Press in 2002 and 2007, respectively. "), _c('I', [_vm._v("Snakes Can’t Run")]), _vm._v(" and "), _c('I', [_vm._v("One Red Bastard")]), _vm._v(", which both continue the story of Robert Chow set in "), _c('I', [_vm._v("This Is a Bust")]), _vm._v(", were published by Minotaur Books. His latest book, "), _c('I', [_vm._v("Ghost Month")]), _vm._v(", a Taipei-based mystery, was published by Soho Crime in July 2014. Lin lives in Brooklyn with his wife, actress Cindy Cheung, and son. www.edlinforpresident.com")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/171h2Dg/tc-custom/9780062444202.jpg?1731179601044",
      "alt": "This image is the cover for the book One Red Bastard"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("One Red Bastard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this thrilling sequel to the highly acclaimed "), _c('i', [_vm._v("Snakes Can’t Run")]), _vm._v(", detective Robert Chow must wrestle with his own morality to solve a murder, set against the backdrop of gritty Chinatown following the Vietnam War.")]), _c('p', [_vm._v("It’s the fall of 1976, and New York’s Chinatown is in turmoil over news that Mao’s daughter is seeking asylum in America. Vietnam vet Robert Chow is now a detective-in-training, and he is thrilled when his girlfriend, Lonnie, scores a once-in-a-lifetime interview with the Chinese representative of Mao’s daughter. But hours after their meeting, the man is found dead.")]), _c('p', [_vm._v("Lonnie, the last person to see him alive, is the main suspect. The police are restless to close the case, and as Lonnie is subjected to increasing amounts of intimidation, Robert is tempted to reach into his own bag of dirty tricks to protect her.")]), _c('p', [_vm._v("Will Chow stay on the right side of the law, or will his loyalty to Lonnie provoke him to turn to darker methods? Find out in this exciting and fast-paced mystery, set in one of New York’s most fascinating neighborhoods . . .")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Dedication#_idParaDest-1",
      "id": "r_idParaDest-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Epigraph#_idParaDest-2",
      "id": "r_idParaDest-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/nav"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#_idParaDest-3",
      "id": "r_idParaDest-3"
    }
  }, [_vm._v("One Red Bastard")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Acknowledgments#_idParaDest-4",
      "id": "r_idParaDest-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-5",
      "id": "r_idParaDest-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Also_by#_idParaDest-6",
      "id": "r_idParaDest-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Ed Lin")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Copyright#_idParaDest-7",
      "id": "r_idParaDest-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-8",
      "id": "r_idParaDest-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": ""
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780062444202_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/9780062444202_Chapter_1"
    }
  }, [_vm._v("Chapter 1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "page-list",
      "hidden": "hidden",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Also_by#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Titlepage#page_iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Copyright#page_iv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Dedication#page_v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("v")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Epigraph#page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_16"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_17"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_18"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_20"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_22"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_24"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_26"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_27"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_28"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_29"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_30"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_31"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_32"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_33"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_34"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_35"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_36"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_37"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_38"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_39"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_40"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_41"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_42"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_43"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_44"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_45"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_46"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_47"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_48"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_49"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_50"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_51"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_52"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_53"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_54"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_55"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_56"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_57"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_58"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_59"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_60"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_61"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_62"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_63"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_64"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_65"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_66"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_67"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_68"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_69"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_70"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_71"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_72"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_73"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_74"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_75"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_76"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_77"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_78"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_79"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_80"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_81"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_82"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_83"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_84"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_85"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_86"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_87"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_88"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_89"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_90"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_91"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_92"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_93"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_94"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_95"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_96"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_97"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_98"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_99"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_100"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_101"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_102"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_103"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_104"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_105"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_106"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_107"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_108"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_109"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_110"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_111"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_112"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_113"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_114"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_115"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_116"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_117"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_118"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_119"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_120"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_121"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_122"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_123"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_124"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_125"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_126"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_127"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_128"
    }
  }, [_vm._v("128")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_129"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_130"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_131"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_132"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_133"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_134"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_135"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_136"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_137"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_138"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_139"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_140"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_141"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_142"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_143"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_144"
    }
  }, [_vm._v("144")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_145"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_146"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_147"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_148"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_149"
    }
  }, [_vm._v("149")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_150"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_151"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_152"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_153"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_154"
    }
  }, [_vm._v("154")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_155"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_156"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_157"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_158"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_159"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_160"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_161"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_162"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_163"
    }
  }, [_vm._v("163")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_164"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_165"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_166"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_167"
    }
  }, [_vm._v("167")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_168"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_169"
    }
  }, [_vm._v("169")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_170"
    }
  }, [_vm._v("170")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_171"
    }
  }, [_vm._v("171")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_172"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_173"
    }
  }, [_vm._v("173")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_174"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_175"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_176"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_177"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_178"
    }
  }, [_vm._v("178")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_179"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_180"
    }
  }, [_vm._v("180")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_181"
    }
  }, [_vm._v("181")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_182"
    }
  }, [_vm._v("182")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_183"
    }
  }, [_vm._v("183")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_184"
    }
  }, [_vm._v("184")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_185"
    }
  }, [_vm._v("185")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_186"
    }
  }, [_vm._v("186")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_187"
    }
  }, [_vm._v("187")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_188"
    }
  }, [_vm._v("188")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_189"
    }
  }, [_vm._v("189")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_190"
    }
  }, [_vm._v("190")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_191"
    }
  }, [_vm._v("191")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_192"
    }
  }, [_vm._v("192")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_193"
    }
  }, [_vm._v("193")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_194"
    }
  }, [_vm._v("194")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_195"
    }
  }, [_vm._v("195")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_196"
    }
  }, [_vm._v("196")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_197"
    }
  }, [_vm._v("197")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_198"
    }
  }, [_vm._v("198")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_199"
    }
  }, [_vm._v("199")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_200"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_201"
    }
  }, [_vm._v("201")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_202"
    }
  }, [_vm._v("202")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_203"
    }
  }, [_vm._v("203")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_204"
    }
  }, [_vm._v("204")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_205"
    }
  }, [_vm._v("205")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_206"
    }
  }, [_vm._v("206")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_207"
    }
  }, [_vm._v("207")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_208"
    }
  }, [_vm._v("208")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_209"
    }
  }, [_vm._v("209")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_210"
    }
  }, [_vm._v("210")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_211"
    }
  }, [_vm._v("211")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_212"
    }
  }, [_vm._v("212")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_213"
    }
  }, [_vm._v("213")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_214"
    }
  }, [_vm._v("214")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_215"
    }
  }, [_vm._v("215")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_216"
    }
  }, [_vm._v("216")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_217"
    }
  }, [_vm._v("217")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_218"
    }
  }, [_vm._v("218")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_219"
    }
  }, [_vm._v("219")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_220"
    }
  }, [_vm._v("220")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_221"
    }
  }, [_vm._v("221")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_222"
    }
  }, [_vm._v("222")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_223"
    }
  }, [_vm._v("223")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_224"
    }
  }, [_vm._v("224")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_225"
    }
  }, [_vm._v("225")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_226"
    }
  }, [_vm._v("226")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_227"
    }
  }, [_vm._v("227")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_228"
    }
  }, [_vm._v("228")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_229"
    }
  }, [_vm._v("229")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_230"
    }
  }, [_vm._v("230")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_231"
    }
  }, [_vm._v("231")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_232"
    }
  }, [_vm._v("232")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_233"
    }
  }, [_vm._v("233")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_234"
    }
  }, [_vm._v("234")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_235"
    }
  }, [_vm._v("235")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_236"
    }
  }, [_vm._v("236")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_237"
    }
  }, [_vm._v("237")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_238"
    }
  }, [_vm._v("238")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_239"
    }
  }, [_vm._v("239")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_240"
    }
  }, [_vm._v("240")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_241"
    }
  }, [_vm._v("241")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_242"
    }
  }, [_vm._v("242")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_243"
    }
  }, [_vm._v("243")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_244"
    }
  }, [_vm._v("244")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_245"
    }
  }, [_vm._v("245")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_246"
    }
  }, [_vm._v("246")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_247"
    }
  }, [_vm._v("247")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_248"
    }
  }, [_vm._v("248")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_249"
    }
  }, [_vm._v("249")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_250"
    }
  }, [_vm._v("250")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_251"
    }
  }, [_vm._v("251")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_252"
    }
  }, [_vm._v("252")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_253"
    }
  }, [_vm._v("253")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_254"
    }
  }, [_vm._v("254")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_255"
    }
  }, [_vm._v("255")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_256"
    }
  }, [_vm._v("256")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_257"
    }
  }, [_vm._v("257")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_258"
    }
  }, [_vm._v("258")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_259"
    }
  }, [_vm._v("259")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_260"
    }
  }, [_vm._v("260")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_261"
    }
  }, [_vm._v("261")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_262"
    }
  }, [_vm._v("262")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_263"
    }
  }, [_vm._v("263")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_264"
    }
  }, [_vm._v("264")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_265"
    }
  }, [_vm._v("265")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_266"
    }
  }, [_vm._v("266")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_267"
    }
  }, [_vm._v("267")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_268"
    }
  }, [_vm._v("268")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_269"
    }
  }, [_vm._v("269")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_270"
    }
  }, [_vm._v("270")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_271"
    }
  }, [_vm._v("271")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_272"
    }
  }, [_vm._v("272")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_273"
    }
  }, [_vm._v("273")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_274"
    }
  }, [_vm._v("274")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_275"
    }
  }, [_vm._v("275")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_276"
    }
  }, [_vm._v("276")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_277"
    }
  }, [_vm._v("277")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062444202_Chapter_1#page_278"
    }
  }, [_vm._v("278")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Acknowledgments#page_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("279")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062444202_Acknowledgments#page_280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("280")])])])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "dl",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("ONE RED BASTARD")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold_italic"
  }, [_vm._v("October 18, 1976")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("f course, the Grand Street subway station was out of commission but luckily the uptown 103 bus on the Bowery was right there. I told Paul to get on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I don’t have any change,” he said, frowning at me. He’s a bright kid, but he’s book-smart, not street-smart. I worry about him sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you just get in there? I’ll take care of this,” I said. He should have known by now that his elders would always pay for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pushed Paul ahead of me. I boarded the bus and flashed my shield at the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s for me. I’m going to pay for the boy,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about it,” said the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not taking your whole family out for a day trip in the country. This is a city bus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crossed my arms and studied the driver. He was a white male, probably pushing sixty, possibly five feet eight standing, and weighed about one hundred seventy. His face was as worn out as his uniform and his dead eyes told me he didn’t care about anything or anyone anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached into my pocket and pulled only thirty-five cents in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("change. Dammit, fifteen cents short. If I hadn’t bought these newspapers, I would have had enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pupil fare was eliminated by the Board of Education last month, and Paul would cost the full adult fare. That decision made a lot of sense if we were looking for one more way to encourage our kids to ditch school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Knowing enough not to bother asking the driver, I turned to the passengers sitting in the front.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do any of you have four quarters for a dollar?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two men ignored me completely. One woman shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you’re going to insist on paying, just put in whatever change you have on you,” said the driver. “We have to get moving now.” He slammed shut the door and we swerved away from the curb. I grabbed for the nearest pole and looked back at the corner deli.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had been ready to step off, get a cup of coffee for the extra change, and wait another year for the next bus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can pay the pupil’s fare for the boy,” said the driver. “They’ll probably change it back, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I dropped in the change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s something wrong with you people,” said the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Us people?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. You cops always want to be the heroes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We aren’t heroes. We play by the book. That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s because of Serpico, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, it’s not. He made it seem like everyone with a badge was crooked, but that’s not true at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well then, I salute you, sir.” He pulled in at the next bus stop and threw open the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you very much,” I told the driver. He nodded, pulled shut the door, and pulled away from the curb. “Would you happen to be going all the way up to Columbia University?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("He continued looking straight ahead and said, “Naw, you’re going to transfer to the 104 at Forty-second. That’ll take you up there.” He tore off two transfers and handed them to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks, again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This country has a lot of heart, doesn’t it, pal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked over at Paul. He was holding a hand strap halfway down the bus. There weren’t any free seats, so I stumbled through the moving bus and stood by him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s wrong?” asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, nothing,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have this pissed-off look on your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just something the driver said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did he say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not what he said, exactly. It was what he meant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t answer Paul and swung through some empty hand straps to get fairly close again to the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I told him. “I was born in this country.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So was I. What’s your point?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just wanted to make sure that you knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then how come you were speaking a different language with the boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s Chinese. Cantonese, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come he doesn’t speak English like you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He does!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We pulled up to a red light and the driver turned to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t even know what the hell we’re talking about now,” he said. I turned and saw two seats open up near the rear exit of the bus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that figures,” I said, about to walk away. Paul was already heading for the seats. The driver shared a meaningful shake of the head with an old woman up at the front.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("Paul and I managed to grab the two seats just before the light changed. We came up to the next stop and the bus driver put on the brakes too hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you trying to do, Robert?” asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” I admitted. “I guess I wanted to let him know that people who look like us are Americans, too. Something to that effect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does it really matter what he thinks?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It matters what he thinks because it means he’ll treat the next Asian passengers differently.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean he won’t try to give them a break on the fare?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Agh,” I said, unfolding the pro-Kuomintang Chinese newspaper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A Taiwanese official had opened up a letter bomb that blew off a hand and an eye. Somehow they caught the guy. He was an anti-Kuomintang activist who wanted to have native Taiwanese rule the island, not families from the mainland who were on the losing side of the Chinese civil war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Kuomintang, or KMT, hadn’t lived up to its noble beginnings. They were also known as the Nationalists, the party founded by Sun Yat-sen, the father of the revolution that ended dynastic rule in China. If it hadn’t been for him, we’d still be wearing queues down our backs to show subservience to the Manchus who ran China at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But tragically, Sun died prematurely and the KMT and the Communists stopped working together. After the bloody split, Chiang Kai-shek and Mao Tse-tung rose to power in the KMT and Chinese Communist Party, and there was little for the average Chinese person to do for more than two decades but fight, suffer, and die.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put away the pro-KMT paper and flipped open the pro-Communist one. The lead story was a feature on Hua Kuo-feng, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("who was named as Mao’s successor as chairman of the Chinese Communist Party. He had already been premier since Chou En-lai’s death in January. It was a typical snow-job write-up. His latest and greatest act was signing the order to arrest Mao’s widow and the rest of the Gang of Four, who were set on sabotaging the Permanent Revolution.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Hong Kong–owned newspaper was the editorial lightweight among the three, but it sold the most copies. Some days, half the paper was celebrity news: who was playing patty-cake with whom. But the newspaper was also fanatically pro-business and for free trade, with extensive global-market coverage and analysis of foreign-exchange rates. I guess they expected couples to buy the newspaper and split up the sections between businessman and wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tore through the pages, indifferent to numbers and diet tips. The best section, in my opinion, was the movie listings. The family that owned the paper also owned the film-distribution company that brought in movies from Hong Kong to Chinatown’s four theaters. The theaters weren’t allowed to advertise in the other papers or else they would get cut off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I folded up the paper and checked my watch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything good in the papers?” asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I said. I looked out the window. We were only at Houston Street; we had traveled a grand total of six blocks. “I’ve forgotten how slow buses are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We should have just walked up to Prince,” Paul whined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if that station was closed, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then we would walk up to the next one until we got to one that was open.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great, so by the time we get there, we’re all sweaty and grimy for your interview. We might as well have gone through the scummy subway. You have to think about presentation, Paul.” "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("I pointed at my face. “I don’t do this for just anybody or anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks for shaving, Robert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d do anything to help you. Hell, I even bled a little for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s all for a worthy cause. If I’m admitted to this precollege project, it could help me get into Columbia as an undergrad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled, but inside I was worried. Not about Paul. I was sure he was going to get pretty much anything he ever applied to, no sweat. What bothered me was that I was going to be even more in debt with Barbara. I had grown up with her in Chinatown and we even had a little thing going before I got into a relationship with Lonnie, Paul’s half sister. It was a tiny thing, even microscopic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbara had gotten Lonnie a job at the United Nations office of a newswire service. Now, through another connection of hers, Barbara arranged an “in” for Paul at Columbia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I guess that when you go to Harvard, as Barbara did, you tend to pick up connections. When you don’t go to college, like me, you end up with a dumb government job that no Chinese kid wants while growing up. I sure didn’t want to be a cop, but not because I was opposed to it. I didn’t know what the hell I was going to be. Then the draft came to Chinatown and it didn’t matter if I had made up my mind or not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked over at Paul. He was reading a paperback book he was holding with one hand. Now, "), _c('i', [_vm._v("that")]), _vm._v(" kid had a mind and a future. I like to think that I set him straight when he was hanging out with wannabe gangsters. He lives with me now and I’m comfortable with saying that I’m the brawn of the operation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was growing out his bangs too long in my opinion, but what the hell, I wasn’t his father. I sure didn’t beat him like his father used to. He was Lonnie’s father, too, but she insists he never laid a finger on her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("Paul looked up, turned to me, and said, “Please stop staring at me. You’re making me feel uncomfortable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ran out of stuff to read.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t read the entertainment sections. You never do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have time for fun. I’m an officer of the law. I’m always on the job.” I straightened out my collar to prove it. I nodded to his book and asked, “What are you reading there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sherlock Holmes stories.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are they good?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve never read them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would I read them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because he solves crimes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those stories are old, Paul! What do you get out of them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you were smart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head and went back to reading. I looked out the window. We were stopped at a green light for some reason. I watched an elderly man in a heavy camel coat walking with a cane. He passed the bus as we remained stationary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I picked up the entertainment section from the Hong Kong newspaper. The Rosemary Theater on Canal was going to have a bunch of old Angela Mao films, so there was an interview with the woman herself next to a page-length picture of her in a typical stance with her elbows up at right angles, hands poised to chop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The interviewer told her that she was still beautiful even though she had just had a baby and wondered when Angela was going to leave films to take care of her new family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I folded up the paper, crossed my arms, and waited for something to happen. I watched an open can of Coke roll diagonally down the aisle, hit something, and leak out on the floor right where people walk through when they board.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("I couldn’t ignore it. I guess that made me a good cop.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked over and picked it up. Some drivers have a garbage pail near the front but not this one. I turned back to my seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks, buddy!” said the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat down again and held the sticky can as far away from me as I could. As an added bonus, there was a big wad of chewing gum stuck near the mouth of the can.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s disgusting, Robert!” said Paul. “You should have just left it on the floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So it can pour out even more crap?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forget it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Paul, are you thirsty?” I pushed the can toward his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get away from me!” I saw him smile for the first time today. I knew he was worried about the interview.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Forty-second Street, I shoved the rear-exit doors open and held them for people getting off. I let them go and they closed crookedly. The exhaust pipe blew out an evil black puff as the bus pulled away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we waited for the transfer, I asked Paul if he wanted me to throw him some sample interview questions. He said sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Paul, I’m glad you could make this appointment today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you for having me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, yeah, tell me which project you would wish to work on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m interested in studying the deep-sea sediment cores with Lamont-Doherty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what are those?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The core samples. From the sea floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, and why do you want to study those things?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because I feel that environmental studies are going to become more of a pressing need, especially if there’s a Democratic "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("administration in place next year. By looking at the fossils in the sediment, we can see what kind of life existed under varying climates over the centuries.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a pause because I didn’t know what to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How familiar are you with Mr. Lamont Doherty?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lamont-Doherty is the name of your geological studies extension. It’s in Palisades, across the Hudson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And how do you plan to get there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have a free shuttle bus that goes there a few times every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I threw my hands up. “Okay, you did real good, Paul. One thing I have to tell you, though, is you slouch too much. Make sure you’ve got your back against your chair. Also, you don’t want to look too anxious. If they think you’re too interested, it’s a turnoff. You have to make them want you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 104 came and we got on. I fell asleep early on and Paul had to shake me awake at 116th Street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Columbia University looked like a fortress built to keep out the surrounding blocks of the city. Paul seemed to know where to go, so I followed him to the office that was handling his thing, but I let him go in alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I threw out the Chinese papers and picked up a student newspaper. I sat in the hallway and read it. What a rag. These pampered rich kids saw injustice everywhere and were looking for excuses to cut classes and to burn their bras over nearly anything. Even the student cartoon was too liberal to be really funny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After about fifteen minutes, Paul came out, his face neutral. He walked down the hall toward the exit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("“Well, that was quick,” I said as I followed him. “It’s either very good or very bad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coolly, he said, “I got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hugged him.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("hat night I hopped up the front steps of the Fifth Precinct, an old brick building on the west side of Elizabeth Street between traffic-heavy Canal Street and tourist-clogged Bayard Street. The Five was built in 1881, and is about as well maintained as any tenement-era building. It looked great from the outside, though.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sauntered into the squad room with a smile on my face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Celebrating already, huh?” English asked me. English, whose real name was Detective First Grade Thomas Sanchez, was the head of the detective squad of the Fifth Precinct. He was a light-skinned Latino with a face that was so pockmarked it looked like it had been pounded by a meat tenderizer. English had gotten his name from not knowing Spanish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know about Paul?” I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He got into that program at Columbia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What program?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The precollege thing. I might have mentioned it to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you did, I don’t remember. Well, good for him, I guess. I thought you were celebrating for the overtime coming up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t hear about this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going to like where it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s going to be a State Department–level meeting happening at the Jade Palace. It’s confidential, but they’re worried that word is getting around. Mao Tse-tung’s daughter, Li Na, is putting out feelers to seek asylum here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("“Wow!” Even the suggestion was explosive to the community. The KMT supporters would be rabidly opposed to a relative of Mao’s entering the United States. They would interpret it as another step in the United States switching diplomatic recognition to the People’s Republic from the KMT’s Republic of China on Taiwan.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People’s Republic backers in Chinatown would find something to be angry about. They always did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do they really have to have the meeting here? In Chinatown?” I asked. “It seems like they’re just begging for a riot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It can’t be held on federal property because it’s not an official meeting. Willie Gee offered his place because he had some connection to someone who knew Li Na. Hell, he may have even suggested that she seek asylum in this country. She’s having a hard time now, as I understand it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Li Na was the only child of Mao’s with Jiang Qing. It was like being half divine and half demon. Mao was the leader of the Revolution and the country. Jiang Qing was the head of the hated Gang of Four. Now Dad was dead and Mom was in jail. There was no one left to look out for Li Na and, considering the political environment in China, she wasn’t safe. Nobody with a high profile was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chinese people hate change because there are gaps of uncertainty that come with it. Not knowing an outcome was terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For all Li Na knew, a faction who wanted to wipe out Mao’s legacy could rise up and accuse her of being a rightist, a leftist, or, worst of all, an "), _c('i', [_vm._v("adventurist")]), _vm._v(". She could end up locked in jail for years on no charges, and when she proclaimed her innocence, the guards would laugh and ask, “Then why are you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chinese people aren’t good at comforting each other. Our idioms and morality tales were all about dire warnings and blaming the victims. You can sum up all of them as, “It’s your own fault! You should have known better!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("If you had lost all your money or your right arm, it was because of something you had done, possibly years ago. If your marriage didn’t work out, then you should have been with someone else back at the start.")])]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" nodded to English and then looked around for John Vandyne, my old partner when we were both rookies and now my best friend among the detectives. Vandyne had an actual gold shield while I was still trying to win one. I was on what was known as the detective track—working on investigative assignments while still officially a rank-and-file cop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I found him in the kitchenette making another bland pot of coffee. I was spoiled by the sweet and syrupy condensed milk that Chinatown bakeries liked to mix into their coffees, basically rendering the drink as a hot, liquid 3 Musketeers bar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne was a dark-skinned black man of medium build who used to be slightly taller than me. He had been slumping down to my height in the last several weeks, starting when his wife moved out on him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow,” he said, as we clapped each other on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne,” I said. “Your hands are wet, man.” I pulled at my shirt to move the wet spot on my back off of my shoulder blade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry about that. We don’t have any damn towels in here.” He wiped his hands off on his slacks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That Willie Gee asshole . . .” I started.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne chuckled and shook his head. He knew all about the contentious history between me and the Chinese guy who looked like an evil Roy Orbison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“C’mon, partner, he’s giving us overtime. You can’t hate Willie for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It just bothers me that he’s probably getting way more out of this thing with Mao’s daughter than us. Think of all the publicity "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("Jade Palace will have once word leaks out. He’s exploiting a Communist for the sake of capitalism!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aren’t you blowing this out of proportion? People might not even find out about the meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know how thin the walls are in Chinatown, don’t you? Secrets in the Chinese community get passed around like a jar of hot sauce at dinner, and there’s no way word won’t get out about this. Willie will make sure of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne sighed and turned to pour a cup of coffee, his first for the night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” said Vandyne, “if he does, he’ll realize later when there’s hell to pay that he should have kept his mouth shut.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long have you been studying Chinese idioms, Vandyne?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t didn’t take too long for the story to get out. The next day it ran on the front pages of the papers backed by money from the KMT, the Communists, and Hong Kong. The news had broken so close to printing deadlines, the editorial boards of the papers had no time to weigh in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just to make sure that even the tourists knew about it, the American-born Chinese guy who published "), _c('i', [_vm._v("Inside Chinatown")]), _vm._v(", a paper in English, also had it out that day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the papers sold out immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("KMT supporters put signs in their store windows, reiterating the three No’s of their political party regarding the Communists on the mainland: “No compromise, no negotiation, no contact!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The signage among Communists quoted one of Mao’s many dramatic sayings that were wide open to interpretation: “It’s always right to rebel against reactionaries!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" live away from the commotion and, in fact, outside of Chinatown itself. My apartment is in a Spanish-dominated neighborhood to the east of the Communist section of Chinatown. It’s on the fourth floor of a slouching walkup just past the southeast corner of Seward Park.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cops don’t live in the boundaries of the precincts we serve in, to prevent potential conflicts of interest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s a fairly big apartment for a one-bedroom. It gets hot in the summer and even hotter in the winter so by around later this month, I’ll prop open one of the windows in the living room where Paul sleeps on a convertible couch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though we were far enough from Chinatown, I could still hear some ruckus being stirred up. I did the smart thing and put in earplugs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul woke me up that night because I hadn’t heard the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The offices of the American-born Chinese guy were on fire. Luckily, the building was empty and everything was under control. Even though the guy was a native speaker of English, the detectives down there wanted me on the scene, too, in case the extreme mental anguish would drive him to seek solace in a Chinese face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For kicks, I could just tell the guy that he should have known that Chinese people don’t want outsiders to be kept abreast of community politics, and that the fire was his own fault.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he editor and publisher of "), _c('i', [_vm._v("Inside Chinatown")]), _vm._v(" was a guy named Artie Yee. I had seen him around before. He was an obese man in his fifties who stood at about five nine and weighed maybe 260 pounds. Artie’s black hair was thinning and he combed it tight, making his head look like a spool of thread running low. He had some day job and did the newspaper on his own time, publishing once or twice a month.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("Somehow, a fire truck had managed to wedge itself into the intersection of Henry and Catherine streets. The fire was now completely out and some kids who clearly lacked a minimum of parental supervision had come out to stomp around in the water on the sidewalk. Why not? It was only two in the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It wasn’t a bad fire,” said English. “It’s the water damage you have to worry about.” He put his hands in his pockets. “I’d really like a smoke now, but it wouldn’t look good, considering.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right,” I said. “Is that the guy over there?” I pointed over to two big legs wrapped in tight denim hanging out of the open back door of a squad car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. We’ve already talked to him, but you should go over and do your thing. He says he knows you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked over to Artie and when he saw me coming he rocked his body back and forth. He managed to get to his feet but he almost knocked me down with the forward momentum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Officer Chow!” he said, shaking my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re pretty happy for a guy whose business just burned down!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled hard, pushing his face into a big, lumpy pork chop with two raisin eyes. It was a little chilly out, but he glistened all over with beady sweat. I unzipped my field coat because I was feeling hot from fast-walking all the way over from home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m insured,” he said, “and I moved out my jazz records last month, so I’m all right. How are you, though?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m doing all right, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your girlfriend, Lonnie, is beautiful, by the way. I’m so envious. But I think the last time we talked you were going through a little bit of a rough patch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember, Artie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I interviewed you about two years ago, for our community profile section.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("“It sounds possible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I took you out for some beers and we talked until you fell asleep on the table.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was a bad time for me, Artie. I’m in recovery now. Anyway, let’s talk about who could have done this to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I . . . I get it! Well, about the fire, I told the other cops, I’m not sure who in particular would have done this to me. A lot of people don’t like what I do. The right-wingers say I’m a socialist and the left-wingers say I’m a fascist. I’m a middle-of-the-road guy, just trying to be objective.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you’re in the middle of the road, you can get hit by traffic going either way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a good point. I should be on the shoulder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Artie, this paper isn’t your livelihood, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It makes money, but I work full-time at night managing an offset-printing plant in Long Island City. I get a break on printing my newspaper there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You work at a place that prints the Chinese papers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not only that. We do a lot of corporate literature. I write a lot of it, too. Shareholder communications sort of stuff. Lot of money in that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” I said. I had no interest in asking more about his job. It sounded boring as hell. We watched the firemen gather up their hose and shake hands with the kids.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Boy, this is really something,” said Artie, wiping his face with his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wondered why a newspaper guy didn’t have anything more interesting to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This isn’t the end of the paper, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, when I get the insurance money, I’ll be back at it. They can’t keep this fatso down. I actually have a very intriguing interview set up for the next issue,” he said. “But the time "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("factor on it is pretty immediate. It’d be a shame to cancel it. Unless . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless your lovely little lady Lonnie wants to do the interview.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But your newspaper’s torched.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not for me! She can do it for her newswire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you know she worked at a newswire?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everybody in the media business knows everybody else. Of course, we all know where the chicks are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Artie,” I said as I smiled, “are you trying to get a rise out of me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, you should be proud. You’re with this girl that all these other guys have the hots for. And not just the few Asian guys, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If anyone gets any ideas . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They have ideas, but they’ll never try anything. Journalists cover things, they don’t make things happen. Look at the women they end up with!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who are you with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m still working on it,” he said, rubbing his stomach. “I need to get back down to my college weight, and then I’ll see what comes my way. Problem is, I work at night and women don’t like lunch dates because they think you’re trying to be cheap.” He looked up at his dripping, burned-out office and folded his hands over his crotch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, Artie, who is this interview with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, well, get this, it’s with the representative for Mao’s daughter. He’s not related to Li Na, but he has had a long association with her. His name is Chen Xiaochuan. He is willing to speak after the meeting at Jade Palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Long association? Chen is Li Na’s boyfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("“Oh, no! I think she’s married,” he said, winking at me. “She’s very ugly! Terribly so! Like Mao in a skirt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet that Chen likes beautiful girls. He’ll definitely want to talk to Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shuffled his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t disclose my sources,” said Artie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s Willie Gee, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not telling you anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is, isn’t it? Jade Palace advertises in your paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, do you not want Lonnie to do this? I can find a lot of other people who would want to break an exclusive interview!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, fine. I don’t care who your connection is. I’m sure she’ll be thrilled to do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded, turned his head, and spat into a puddle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, do you think they’re going to find out who did this? I know what the answer probably is, but I was just wondering, for my sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You already know that nobody testifies in Chinatown, right? They’ll more likely talk to reporters than they’ll talk to cops.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Artie nodded. He pulled out a stick of gum and slapped my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, thanks,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to call Lonnie at work,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You need her number?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have it already. See you, Robert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched him leave and then walked back to English, zipping up my field coat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did he tell you?” he asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("“What did you tell him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That we’re working on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Imitating Richard Dawson on "), _c('i', [_vm._v("Family Feud")]), _vm._v(", English said, “That’s our number one answer!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met up with Vandyne in the lobby of a Catherine Street apartment building. We had both come in through a rear entrance so that nobody on the street would see us enter the building. We each grabbed a plastic bucket from the refuse left under the stairs and walked up to a landing between the fourth and fifth floors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The window to the street had been painted over. I turned my bucket upside down and took a seat as Vandyne worked the window open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What . . . kind of . . . idiot . . . would paint . . . over . . . a window?” he grunted as he pounded away at the frame.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Careful, partner, don’t smash the glass there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave a final shove and asked, “Is that good enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One more. Another one. Okay, that’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne rubbed his hands together and sat on his bucket next to me. We had a great view of the sun setting behind the burned-out building that housed Artie Yee’s newspaper office. It looked like a giant gray skull, the headquarters for a bad guy in a comic book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne took a hard look at the building. “Dammit, Chow, you made me do all that extra shoving for nothing! Look at all this viewing space I made.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come on, you have a lot of stress to work out. If you ever want fifteen seconds of my time, they’re yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, I’m going to take more than fifteen seconds. In fact, I want you to check out these Eddie Gale records I’ve been getting into.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("“Who’s Eddie Gale?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a horn player. A jazz guy who’s trying to open the boundaries of the form.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I began to feel apprehensive. Jazz wasn’t my kind of thing. I thought the two of us had that common disinterest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jazz? I thought you hated jazz, Vandyne.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t like the traditional jazz, but this guy Gale has really done something to the whole feel of the music. When you don’t have a woman in the house, you have some extra time and a lot of extra money, so I stopped by a jazz records store and asked what was good. I wanted to hear something new.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you say that, you’re telling the guy, ‘Sell me something you’re trying hard to get rid of.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re wrong and I’m going to prove it to you. I’m going to borrow your ears one of these nights and play you those albums.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure, man,” I said, hoping it was going to be one of those guy promises that never happen and are never referred to again by either party.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shifted around, and the sound was amplified by the mouth of the bucket slapping against the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you can make more noise if you pound it like a drum,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t get comfortable on this thing! It’s all sharp and pointy. You have a nice one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a piece of crap! I’ll prove it. You want to trade?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We switched places. Vandyne’s bucket hurt in all the wrong places, but I gave a big smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing wrong with this one here,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give it a minute,” said Vandyne. He brought a pair of bin"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("oculars to his face and played with the adjustment. I took a newspaper from inside my jacket and shoved it between the bucket and me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any criminal who comes back the night after,” Vandyne said in a distracted voice, “is one stupid jackass.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not dealing with Mensa members here. Setting a building on fire isn’t exactly a plan that comes from a sophisticated mind. You don’t even get anything out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What could you steal from a little newspaper?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’d back up a moving van there and take all the desks, chairs, shelves, and maybe even the sink and toilet. You can resell all that stuff pretty easily. You can make more money than you’d think from used furniture and they don’t exactly have identifying marks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne put down his binoculars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmmm,” he said. “I gotta keep an eye on you, partner. If my wallet disappears one day, I’m coming after you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside, the neighborhood was now bathed in the yellow light of the setting sun. It would be dark in about an hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We didn’t know what to expect, but if there was one thing you could count on, it was criminals fucking up sooner or later. I think it’s a part of human nature to expect to be caught and punished for a misdeed. Even if criminals managed to pull off a clean job, they would loop back and linger in the general area. On the next job, they might intentionally get sloppy to see if they could get the sirens to come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw someone peel off from the crowd, step over the yellow warning tape, and walk close to the charred walls of the building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne, can I see those binoculars?” I asked dimly, not taking my eyes off the figure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("He handed them over without a word. I looked through them at the figure.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a woman,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he woman was standing in a pool of wet ashes, her hands at her sides. She was about five seven but that was with heels on. Her thick black hair cascaded over her ears and shoulders, and she did something to it to make it shiny. A light brown coat stopped above a skirt that stopped midway down two taut thighs in stockings with a dull glow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smirked because I was sure that she had spent some time thinking about how she wanted to look from the rear. To men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this was no time for amusement. I came in close to her forehead and growled under my breath, “Barbara, what the hell are you doing here!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she turned around I saw my head and torso in her two black, sparkling eyes. Her face was long and not too narrow and came down to a chin that fairy princesses had. Her red lips, usually curved like a little blossom, were pulled taut into a wide smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She grabbed my arm and said, “Robert!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a crime scene! Now let’s get out of this thing!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m so sorry!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She continued to hold on to me as we stepped over the tape together, matching leg for leg. I had lost part of my mind in Nam, but she had lost a lot more. Barbara used to be the prettiest girl in Chinatown. Now she was its prettiest widow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know anything about the fire, Barbara?” I looked into her face. There was lightning behind her dark eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. I don’t. Can we stop whispering now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("“Well, I guess it doesn’t matter at this point,” I said in full voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, I didn’t mean any harm. I just had to see the place up close. Artie Yee published my first story, back when I was in grade school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t know about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I brought it into school to show everybody. Don’t you remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How am I supposed to remember that one thing? You always had something to show off in school. If it wasn’t a story you wrote, it’d be a story about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She snorted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you stay in touch with Artie over the years?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d run into him from time to time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were the two of you friends?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no, no. I learned to keep my distance from that one. Did you know that he asked me to marry him when I turned eighteen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wasn’t much better looking back then, was he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He looked like a younger walrus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not enemies with Artie, though, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not one of them, but he has many enemies, you know that,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He did his part in pissing off all areas of Chinatown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Artie doesn’t respect authority. That’s a good thing for a journalist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then how come you didn’t keep writing for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Artie doesn’t respect women.” She shivered and then slapped my arm. “I heard Paul got into that program at Columbia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks to you,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks in part to me, anyway.” She pouted. “Doesn’t that mean you’ll take me to dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("“Maybe Paul should.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get serious. Actually, maybe Paul should come and meet my youngest sister. You know she’s up at Columbia because she got into Barnard early. Maybe she should stick to Chinatown boys, like I should have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Barbara, let’s talk about this later. I have to get back to work here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re going to call me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll get in touch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She walked off and I returned to my post.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Years ago, Barbara and her three younger sisters were the four little princesses of Chinatown. She liked to say that her parents never did get that son, but the truth was her parents learned to love all their daughters to death. They all had beauty and smarts, and because of that you knew they’d get out of Chinatown and never come back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Barbara did return after her husband was killed in Khe Sanh. The oldest, the prettiest, and the smartest of the sisters, she moved back alone into their old family home to find some comfort, I guess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a brief period when I thought she was the love of my life, but it was a while ago and it ended embarrassingly enough. Thinking about it again put me in a bad mood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Sunshine,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was Barbara,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! What the hell was she doing there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wanted to see the place up close. Artie published one of her stories back when she was a smart, little girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seriously, though, could she have had anything at all to do with this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her? No way, man!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know that for sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("“Yes,” I said. “I would bet my soul on it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a trick answer. Chinese people don’t believe in souls, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We believe in many things, Vandyne. But eating good food is at the top, not this afterlife nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I folded my newspaper seat over again to make it thicker and resumed my spot on the bucket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of getting fed, are you anywhere near hungry?” Vandyne asked in a voice that told me he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll just wait a little bit, see if anything starts developing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing happened except it got colder and harder to see. I went back down to a small noodle dive off of Henry Street and brought back two containers of lo mein, chicken for me and beef for Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He ate a few bites and then he gave me a funny look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the problem?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you eating with a fork just to show solidarity with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chopsticks aren’t even an option at this place. Their biggest business is from the jerks on jury duty out for lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I could’ve handled chopsticks in this situation. From the container, I can do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll test you next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We finished up and shoved all the garbage under our buckets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Around 10 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")]), _vm._v(", people came back from their night shifts in the restaurants and passed us in the stairwell. I saw one older man eyeing us on the way up. When he got to his apartment, he loudly warned someone to stay away from the homeless men in the building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s telling everyone there’s a black man out on the stairs, right?” asked Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, he said ‘homeless.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("“Yeah, but they think a black man sitting on a bucket is homeless, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I could only shrug.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next time, we bring chairs,” grunted Vandyne. “With cushions!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _vm._v("y boss is really excited that we have this interview with Chen Xiaochuan!” Lonnie told me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were having breakfast in a place on the Bowery that steamed everything. It was convenient because she could see the bus approaching from downtown. Traffic was usually so bad Lonnie had time to cross the street before the bus made it to the Canal Street stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s great,” I said. “How does Artie Yee happen to know your phone number at work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a 1-800 number, Robert. You can be patched in to any of Presswire’s staff through it. Do you think Artie and I are dear friends?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s your old boyfriend, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She threw a used napkin at my face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached to the table behind us for an open jar of hot chili sauce. It had been emptied and refilled so many times the threads for the lid to screw onto were covered by a hardened black crust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you really need hot sauce in the morning?” she asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These rice-noodle rolls have no taste. They’re just mushy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I really missed eating pastries in the mornings. In fact, Lonnie used to work behind the counter at Martha’s, one of the most popular bakeries in Chinatown. They made a lot of really nice sponge cakes and stuffed buns there. In particular, I liked the hot-dog pastries, the things that look like Viking helmets with the two ends of the hot dogs sticking out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But after she stopped working there, she forced me to stop "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("eating them, telling me how bad they were for me and how everything else there was unhealthy. She could have told me before, right? I don’t see why she had to wait.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, I guess she wanted me to keep going there to see her. I glanced across the table at her and noticed she looked a little annoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you listening?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Paul is doing the project at Columbia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He sure is!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it going to be easier for him to get into the college later on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably. Assuming he doesn’t screw it all up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think they’ll give him financial aid? It’s a very expensive school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure Paul’s going to get scholarships and grants. They love a story like his. Poor little immigrant boy pulling himself up by the bootstraps.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Borough of Manhattan Community College gave me hardly anything, and now NYU isn’t much better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate to say it, Lonnie, but Paul is a little smarter than you, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed and kicked me hard under the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t tell a woman that!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grabbed her hands loosely. “You’re beautiful. You’re very, very beautiful.” She broke free, crossed her arms, and grunted. “Maybe too beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This Mr. Chen that you’re going to interview, I understand he has a thing for pretty girls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So do you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie, the fact that he’s coming over must mean that he’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("a powerful man. Politically, not physically. He probably has the body of one of those eighty-year-olds running the country. He might be like the Blob in a suit. He might ooze all over you if you get too close.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No matter what kind of shape he’s in, I can handle it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drummed my fingers on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a minute,” I said. “Someone torched Artie’s newspaper to stop this interview. Maybe it’s not safe for you to talk to Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Someone might try to hurt you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, Robert. Artie has been making people angry for years with his little newspaper. Whoever’s responsible for the fire has probably been mad at him for a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie, you’re thinking again. Don’t do my job for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She continued anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So they probably weren’t trying to stop the interview with Mr. Chen in particular. It was about stopping Artie.” She picked up her bag. “I see my bus!” She stood up and patted my shoulder. I rubbed her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chinatown couples aren’t openly affectionate, partly because of societal restrictions and partly because the sidewalks are too narrow and busy to accommodate hugging or kissing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched Lonnie cross the street, walking away from me. She was a beautiful sight even in her thick wool coat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie was right. The fire couldn’t have been to prevent the interview. The guy would have had to know that the interview was being set up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I chuckled at the very thought and sipped some tea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I checked my watch. It was time to get out of this place and get something good to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he only reason Paul, the midget, Vandyne, and I watched game four of the World Series together on my television was because the Yankees were already down by three games. I wanted to watch them play like men without hope like the Mets.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This year the Mets had managed to finish above .500, and that was about as close to the pennant as they could come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne went back and forth between the two New York teams and in truth, I was only a mild Mets fan. I saved the soft part of my heart for the Rangers to shit on. I saw fewer hockey games this season on TV because of the detective-track assignments. It was probably for the better that I missed them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, I didn’t want to miss a chance to see two big Yanks fans get an idea of the pain we felt in 1973, when the Mets lost to the A’s. But at least that year we had beaten the Reds and pushed the World Series to seven games.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget had closed his toy store early. He wasn’t going to lose any business because every kid in Chinatown, even the stupid gang kids, was in front of a TV.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The game had been set for Wednesday but was rain-delayed to Thursday. Being a polite host, I took a folding chair and let my guests have the couch. I had a selection of soda cans lined up on the coffee table and bags of chips. I took a handful of Doritos and then spun the opened part of the bag away from me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I waited until the first half of the first inning was over, and the Reds were held scoreless, before dipping back into the Doritos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I was done chewing and swallowing, I said, “I’m so ready for this game.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come Lonnie’s not here?” asked Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s studying for that interview with the Chinese guy. What sucks is that Presswire isn’t going to pay for an interpreter, so she’s getting a friend who’s fluent in Mandarin to come along "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("with her. It’s probably safer. These Chinese fat cats, I don’t care if they’re Communists or KMT, they treat women like they’re objects.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not Madame Chiang Kai-shek. She had the Generalissimo by the balls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget slapped his knee and pointed at me. He said in English, “Same thing with him!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget was one of those Chinese guys with extra fat layers in the eyelids. I think it’s a Mongolian gene that pops up every now and then. Those heavy half-opened lids suited him well because he was the funniest, most sarcastic man in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie and I are equal partners in this relationship,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, come on,” said Vandyne. “The only reason we’re here and you’re here is because Lonnie is busy. Otherwise you’d be off with her, eating something healthy for dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled. It was fine for Vandyne to rip on me if it made my old partner feel better. I’d punch myself in the eye if it would help, but that wouldn’t bring Rose back to him from her sister’s apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re wrong,” said Paul. “They would be here and they wouldn’t let any of us come over because they’d be busy together. I’d have to spend the night somewhere else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The kid’s right,” I said to the grunts from Vandyne and the midget. Thurman Munson, the Yankees catcher, stepped up to the plate with two outs. “Three for three. Let’s go.” The son of a bitch singled. Then Munson scored when Chris Chambliss doubled. The midget slapped hands with Vandyne and Paul. I crossed my arms and squirmed. “If the Reds don’t come back in the second, I’m gonna go read my evening Chinese newspapers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("The Reds promptly went down, with a man caught trying to steal second.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stood up and said, “I’m getting a bad feeling about this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sit down and watch,” said Vandyne. “You don’t know what’s going to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m cutting my losses for now. I’ll check back on the situation if I hear the enthusiasm die down.” I picked up my newspapers and retreated to the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Communist-backed paper called for unnamed people to seriously reconsider their follies that were reactionary in nature. “A child, female or male, should carry on the great struggle of the parents,” read the editorial, an obvious dig at Li Na. I was amused at how Communists were apparently paraphrasing Confucius, whom they had once pilloried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The KMT-backed paper hailed Li Na as a hero of the Chinese people for apparently rejecting Communism. The story took up the entire front cover, both above and below the fold. There weren’t many pictures of Li Na in existence and certainly none that the mainland would make available to the KMT, but that didn’t stop the paper from placing an altered picture of Taiwanese film star Hsu Feng next to the story. “If Miss Li finds that the U.S. is not to her liking, we would be proud to have her as a citizen of Free China,” the report concluded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But there was also an editorial about how President Ford and the U.S. State Department should reaffirm the strength of America’s political ties to Taiwan before even considering Li Na’s case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Hong Kong–backed paper threw cold water on the entire controversy. “How do we know that Mr. Chen legitimately represents Li Na? He seems to be getting a free trip to New York City while also unnecessarily fanning the flames of supporters of both sides of the Taiwan Strait.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("I found myself in the odd position of agreeing with the editorial, or at least not agreeing with the other two.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard my houseguests start up a “Let’s go Yankees” chant. It was going to be a long night.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went to see the midget the next day at his toy store on Mulberry. He was sitting on a stool behind the counter. His head was down, sipping the last of an herb-tea drink through a straw. His combed black hair was so shiny it looked white where the sunlight hit it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glanced up at me quickly and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was a tough loss, huh?” I said. “I think that’s the first time I’ve ever seen you on the losing side of something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was well known throughout Chinatown that the midget had never lost at any game ever. He could whip you at chess, American chess, checkers, and Sorry! Monopoly, too, if you had the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want something fun to play?” he asked. “I think we just got some new four-piece puzzles. You can handle that, right, Officer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I think I can handle that,” I said. “Hey, I just wanted to come by to say sorry about Paul getting that research spot up at Columbia.” The midget looked directly in my face and raised an eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you trying to do to me? I’m running a business here! You can’t take my best people away and expect me to like it. I was supposed to get him back in the evenings and weekends after his summer internship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know he’ll get more experience there. More "), _c('i', [_vm._v("useful")]), _vm._v(" experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you trying to say that working in a toy store is easy? You used to work here and it kicked your ass!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("It was true. I spent my lost years after coming back from Nam working in that same store under the previous owner.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Paul was my best worker,” the midget went on. “He showed no emotion, worked hard, and ate shit without complaint. He would have made a fine Chinaman one day, and now you’ve shoved him through the door of an Ivy League school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you’d be happy for him. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I am,” said the midget, dropping his faked annoyance. He pitched the empty drink container into the garbage can. “But, really, I don’t know how I’m going to get someone to replace him here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about hiring an illegal? They work cheap.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way. Too many cops come in here. I wouldn’t be comfortable with it. Anyway, I’m sort of training a new guy today.” He smacked a pencil a few times against the countertop. “Hey, Drew! Come up here! I want you to meet someone!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard a broomstick drop to the floor and a skinny kid came out from the back. He was about five three and maybe ten pounds too light. At some point Drew had had some bad acne on his forehead; he still had pimples across his cheeks and chin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir?” he asked the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is Officer Chow, a personal and professional friend of mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Officer Chow. My name is Drew.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drew what?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drew Bai.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you born over here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Actually in Queens. We live in Confucius Plaza now.” Confucius Plaza was a new government-subsidized housing project over on Bowery that had just opened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you were born here, then how come you can speak Chinese so well?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("“I learned it. My parents forced me to go to Chinese school.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but where did you learn Cantonese from?” Chinese schools, even the ones in the heart of Cantonese-speaking Chinatown, taught Mandarin, the language of the educated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just picked it up hanging around the neighborhood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you in a gang?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I’m not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re about that age. Fourteen? Fifteen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fifteen. You sure ask a lot of questions. Am I a suspect for something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Officer Chow’s just a very inquisitive fellow,” said the midget. “He can’t help but make you uncomfortable. It’s his job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t mean to interrogate you, Drew, at least not yet. I just want to know who’s working in my pal’s store. That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s all right. If there’s nothing else, I have more work to do in the back.” The midget waved him off and Drew withdrew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow,” I told the midget. “Where do you find these guys who work so hard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was a store regular. I noticed that he would reshelve toys that were lying around and I said to myself, ‘Hire that kid someday. He cares about this place.’ So when I heard about Paul, I did a favor for myself and a favor for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At some point, Drew is going to finish high school, too, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet you, though,” said the midget, crossing his arms, “if he goes to college in the city, he’ll beg me to let him keep working here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure you’ll accommodate him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, I’m a generous guy!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t was cold, crisp day and there was just something in the air—mostly yelling and screaming.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two different groups of idiots who thought that their shouts and sign-waving were going to convert the masses were crammed on either side of Jade Palace. In my experience, the only thing you can convince passersby of is that you have time on your hands or that you’re crazy, or both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The younger, hairier side supported the People’s Republic of China. The people with better coats backed the KMT. They were united in opposing the meeting with Li Na’s envoy, although for different reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The KMT side had convinced itself that despite Li Na’s noble stand against Communism, the meeting itself was another step in the United States phasing out diplomatic ties with the Republic of China on Taiwan in favor of the mainland. The United Nations had voted to expel Taiwan and seat the People’s Republic in 1971, and the United States hadn’t been able to stop it. Maybe the Americans were losing resolve to stand with Taiwan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Commies were opposed to allowing Li Na political asylum in the States—an act of treason against Mao and the Revolution from Mao’s daughter herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Strangely enough, this particular group of Reds was also opposed to diplomatic ties between the People’s Republic and the United States. It was seen as a “sell-out” move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both groups had permits and the Boy Scouts, the auxiliary police, were out to make sure everyone stayed within their blockades. A Chinese auxiliary policeman came up to me and said, “Robert, how are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was about the same height as me, though a few years older with a little less in the girth department. His face was fatter, though. I knew I’d met him before, but I’d forgotten his name. “Hey, man,” I said. “How are you doing, buddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("He looked behind him before saying, “I’m good. Say, do you know how I might get an offer to get on the job for real?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s tough, man. First priority is rehiring the cops who got laid off in the financial crisis. There’s still quite a few.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know all that, but hey, I’m a minority!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hear ya, I know there aren’t a lot of cops who look like me. Or you. But you gotta pay your dues. Right now, it’s a pretty high price. You’re doing the right thing. Auxiliary’s probably the best way to go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“C’mon, man, don’t give me that!” He pulled his mouth to one side of his face. “Didn’t you get your post as a minority hire?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not the whole story. I was hired because of the need for a Chinese cop in Chinatown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For the newspaper pictures.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, for the newspaper pictures. But I’ve moved on. I’m detective track now. Don’t forget, I had seniority over other people out of the academy because of my military service.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t see why that should count. Being a soldier is completely different training from being a cop. I have college credit from criminal justice—that’s relevant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I leaned into his face and said in a low voice, “I never spent a day in college and look at me now.” He shrank back but I gave him a firm slap on the shoulder to let him know I didn’t hate him too much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked over to the Commie protesters to look them over for future reference. A mentor of mine told me to observe the crowds and to become accustomed to faces. Although New York was a huge city, you saw the same people over and over again within five square blocks. Nearly all the crime committed in that area was by only a few individuals. Try to pick out the ones who look too self-conscious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If nobody sticks out, just have someone in the squad car crank "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("up the siren for a few rounds and see who jumps the highest and who runs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t necessary to resort to that measure here, though. I made a careful note of the people holding up signs and the rooster-looking boy on the megaphone hollering, “Crush Li Na and the Gang of Four!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Megaphones weren’t permitted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not allowed to use that!” I shouted at the guy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He lowered the megaphone and I saw that he had a soft, thin face that contrasted with his angry black eyes. He was about six feet tall and weighed about 160 pounds. The guy might have long hair, but it was tucked up into his Mao cap. His vest was covered with Cultural Revolution propaganda badges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” he asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Asshole. You’re not allowed to use that thing here. Put it away or I’ll take it from you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In English he said, “I have a right to be addressed in English.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I accommodated him and asked, “What’s your problem? You memorize slogans in Cantonese but you can’t speak it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t let language become a barrier between me and the people.” He crossed his arms and made a face as if he were trying to bend me like a spoon using his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know your kind,” I said. “You went to college, got your head stuck in some pseudo-socialism, and then you came down here to take a stand with ‘your people.’ Let me tell you something, pal, you didn’t grow up here and you don’t know anybody here. Do yourself a favor. Go back home to the suburbs and study up for law school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I live here now, so this is my home. These people are my friends and neighbors. We all support the People’s Republic over the puppet state of Taiwan and we’re not going to stay quiet over the issue! Our voices will never be silenced!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("“See? You don’t need the megaphone!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at the instrument in his hand and I could see he didn’t have the guts to raise it again. I was walking away to the KMT side when he yelled after me, “I studied Mandarin in school! And my girlfriend speaks Mandarin!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So have some fucking oranges!” I muttered. The usual suspects were here among the KMT protesters: local businessmen, cranky and retired association members, and conservative students.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One clean-cut kid was holding a sign that simply had a cross on it. I recognized him from the membership-drive parades that Lonnie’s church staged from time to time in Chinatown. He was the one swinging the incense vessel around on a chain. I guess that Chinese Catholics knew they had that in common with Chinese Buddhists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he saw me, he came over and waved at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, I’ve been asking Lonnie why we haven’t been seeing you in church.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked down at his black Play-Doh hair. “I’ve been busy with things like this. Every day I have to be on my toes so the bad guys don’t win.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some things are more important than our daily routines.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some things are more important than eating wafers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made a face like I had cursed. “I will pray for you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A kindly old man with more spots on his head than hair handed me a flyer with a smile. It read, “Boycott Jade Palace and traitor of the Chinese People Willie Gee. Beat the Red Bandits into their graves. Support Righteousness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was wrong for me to take the flyer, but he had caught me off-guard. I handed it back to him and said in English, “I can’t "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("read Chinese.” I put both hands in my coat pockets so I couldn’t get suckered again.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the street corner, I connected with Vandyne who was wearing a leather jacket to fight the cold. He looked upon the twin protests with amusement. “Seems like old times, eh, brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right,” I said. Less than a year ago, Jade Palace was swarmed with ex-waiters decrying the management’s practice of taking a percentage out of the tips. “These protests attract so much attention to the restaurant, I can’t help but feel that Willie’s still the one pulling the strings.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That may be so, but he is making some sacrifices,” said Vandyne. “I understand that Golden Peace, the association that Willie formerly headed, has canceled his membership.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a loss for the association, as well. Willie was their superstar. He was the golden boy of Golden Peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Golden Piss,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We both laughed. “So, everything’s okay, right?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah, everybody’s already in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The protesters had naïvely expected all the dignitaries to enter from the front. In fact, Li Na’s man and the State Department brass had entered the restaurant from the storage area of a corner store down the block. Willie Gee himself operated the freight elevator that took them up to a private room that had commanding views of the Manhattan Bridge and none of the protests below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie and her interpreter friend had been snuck into the restaurant also. I wondered how her interview would go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some jerk walking by yelled, “Death to Mao!” and threw a bucket of water on the Communists. He practically ran into me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mao’s already dead, idiot,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a wiry guy, practically part spider. “I hate all Communists!” he yelled. Vandyne went to check on the wet protesters as the KMT side jeered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("“I’m taking you into the precinct for assault,” I said. I cuffed him and his arms were like twist ties.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m proud of what I did!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw Vandyne and, although people were screaming at him, I knew that none of them would follow through and press charges. I knew taking this guy in would just result in paperwork for me but it was worth it to stick a fine on him. I just wanted to try to make everything as much of a pain in the ass for Spider-Man as it was for me. He shouldn’t be able to throw freezing water on people with impunity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked him into a fire hydrant, knees first, and watched him stumble. I pulled him back upright by the handcuffs and said, “Oopsie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked back at the crowd as I pushed my guy onward and caught a mean look from the auxiliary cop who had buttonholed me earlier. I also saw rooster boy yelling at his girlfriend even as she helped him take off his soaked vest. What a jerk.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" was typing away at my desk in the detective squad room. To my left was Detective Second Grade Stuart “Bad Boy” Piccolo, who looked like Lou Costello gone gray, but he was quiet and never made anybody laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my right was Detective Second Grade Anthony “Pete” Risso. “Pete” was short for “Pizza Man.” His light brown hair went down to his shoulders. Pete had an amazing memory and his unblinking eyes recorded everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He got the name Pizza Man because it was a character he played back in his old Brooklyn precinct when they knew where a bunch of drug dealers were holed up. Pete would knock on the front door with a pizza. Whoever was closest to the door wouldn’t be that suspicious because he figured that even if he didn’t order it, someone else might have. A look through the peephole would "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("have shown a skinny white guy with a thick mustache. Pete would lift up the lid of the box to show the hot pizza. It was tough for a hungry idiot to resist.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the drug dealer opened the door, four guys with guns would swing in. The bit worked for years before all the criminals figured it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m not sure why Pete ended up as a precinct detective in Chinatown. He cleared a lot of cases and should have been with a prestigious spot maybe with Manhattan South. I asked him about it once and he just said that he had gotten fucked over. It might have been a political thing, or maybe he had been caught doing something he shouldn’t have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both Bad Boy and Pete had been tied up earlier in the year with a bomb the FALN had set off near Police Headquarters. The Puerto Rican militant group wanted complete independence from the United States, but their methods were repugnant and, worst of all, their spokesman had the same name as Thomas “English” Sanchez, our top precinct detective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The FBI did the heavy lifting on the investigation but they still wanted Manhattan South and local detectives working with them. The bombing did occur within our precinct boundary, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that the media hype was dying down on the case, Bad Boy and Pete were released back to the precinct.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad Boy was probably a decade older than English and he spent most of the day chain-smoking with one hand and writing with the other with the phone wedged between a shoulder and an ear. Supposedly Bad Boy was coordinating with cops in other cities who dealt with tax scams and pirated goods. It was tough to tell. His voice was so soft it was impossible to eavesdrop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Last year, Bad Boy took down an entire block of merchants for charging tourists sales tax that they never reported. The stores settled quickly with the Internal Revenue Service and the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("state and local tax offices. The stores were closed over only one weekend. Maybe justice wasn’t truly served, but what the hell, it made the city money.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete’s caseload was packed with stupid gang kids shooting or beating or vehicular-assaulting each other with zero witnesses. Ever since I picked up investigative assignments, he’d been pushing them on to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About a year ago, a carload of kids was kidnapped by a rival gang. One of them managed to sneak out and called Pete for help. He got a few collars out of it because some of the kidnappers were over twenty-one. It’s tough to build a case against a teen when the system is always bent toward sparing the rod and spoiling the child.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne had helped Pete nail some over-twenty-ones while busting a heroin ring that had operations in the United States, Canada, and Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But apart from that it was tough to say how effective Pete and Bad Boy were. They didn’t seem to be doing anything day to day or night to night. I’m not saying Vandyne and I were any better. We were just four guys at our desks, trying to get through the shift and through the shit, and seemingly getting nothing done. The only times I felt like I was finishing anything was at the end of meals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you manage to close down some crooked stores, they reopen almost immediately. If you sweep up some of those stupid gang kids in a heroin bust, they’re back on the street within hours. If you manage to help stop a human-smuggling ring, like I did, you get a Meritorious Police Duty bar, but no gold shield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This day was no different. After releasing the water-bucket jerk with a fine and warning, I had to type up the day’s proceedings and make it look like I was earning my pay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked over to an empty desk that was the unofficial library "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("and condiment station. The desk had belonged to a guy named Lumpy who had retired early two years ago in a voluntary buyout during the city’s financial crunch. The drawers were crammed with salt, pepper, duck sauce, and hot mustard packets. Outdated "), _c('i', [_vm._v("World Book Encyclopedia")]), _vm._v(" volumes protected the desk surface from getting dusty.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I opened the bottom drawer for my jar of Jif peanut butter but it was scraped completely transparent. Now I had to get by on some steamed rice buns with nothing on them. Each bite sucked all the saliva out of my mouth and they didn’t even taste like anything. But they were healthier to eat than my old standby, the hot-dog pastries. I was hungry a while ago but the rice buns didn’t sound appetizing until I was nearly doubled over in pain from not eating. I took one out of the bag and felt despair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne was already gone and Pete was on his way out. Bad Boy was on the phone and in no rush to leave. He never was. I wanted to go meet Lonnie and see how that interview went.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My phone rang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Detective,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert!” said Lonnie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t meet you for dinner tonight. I didn’t get a chance to really talk with Chen Xiaochuan. Willie Gee wanted to give us a private room for the interview but the FBI guys insisted that we leave. Mr. Chen went back to his hotel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not surprising. It’s a security issue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Mr. Chen asked me to have dinner with him. At his hotel. In his hotel room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I switched the phone to my other ear. “Oh, he did, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what you might be thinking and I was cautious, too. But he said his security detail would be right there. We’re not going to be alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("“Well, I guess that sounds okay. I can’t possibly object to that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The best thing is he can speak Cantonese pretty well. Far better than my Mandarin. I would have never guessed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He probably learned it to meet Cantonese mistresses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not like that at all, Robert. He is a perfect gentleman. You’ll be all right eating by yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Make sure you eat vegetables, too. Don’t just get some over-rice pork dish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I won’t. Do a good interview, Lonnie. Make sure you stick him with hard questions, too. Otherwise you’re just his publicist spreading propaganda. We already have Chinese newspapers that do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I know. I’ve been prepped by the managing editor of Presswire. I’m going to have follow-up questions and everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You call me when you get back to your parents’ place,” I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We said good-bye. When I was done for the day, I decided to swing by the toy store to see if the midget would eat with me.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t was almost half an hour before the toy store would close, so I went to Columbus Park to kill some time. The sun had already gone down and everything was a different shade of blue. A few solitary people perched on the wooden benches, staring at their own cold breath in the air. Anybody who had someone to talk to was already eating with that person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a walk around the handball court near the south end. That place used to be a battlefield, in the playful sense. I remember watching the older kids running around, slapping that rubber ball. The air and the asphalt seemed almost to burst into flames in the summer heat. The boys would roll off their shirts and tank "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("tops, and I remember being surprised at how different their skin tones were even though they were all Chinese.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some had pretty bad scars on their backs, chests, and necks. These were the guys who acted friendly to me and made me feel I was cool when I was a little nobody. They made it real easy for me to join their gang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now the handball court was all broken up, like a team of treasure hunters had taken pickaxes to it. What was left of the chain-link fence around the baseball diamond was rusted and curled, looking like the burned edge of a plate of pan-fried noodles. Yum. That sounded good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though the city’s funds were as strapped as ever, some of it could be allocated to Columbus Park if the residents made a big enough issue out of it. But Chinese people like to complain only to fellow family members or close friends. Taking your criticism to the authorities was useless at best, and at worst you and your family could be singled out for harassment. If there was something you didn’t like about your neighborhood, then save money and move out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a shame, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Startled, I turned around and saw an elderly Chinese man standing behind me. He was wearing a Yankees cap, a dirty white sweater, and jeans. I was surprised more by the fact that he was speaking to me in unaccented English than how he had sneaked up on me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure,” I said. “They really ought to fix this park up. I’m sorry for your loss.” I pointed at his cap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, there’s always next year for the Yankees and I’m feeling good about Billy Martin. He’s been good for the team. But this poor handball court may be finished for good. Problem is, apart from the Department of Parks, the associations don’t want to deal with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("“What do you mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The associations could go to the city government and demand they make repairs and renovations, but they’re too concerned with fighting out the civil war all over again. The Communist associations are trying to get the U.S. to sever ties with the Republic of China on Taiwan. The nationalist associations are trying to sabotage warming ties between the U.S. and the People’s Republic. It’s the poor kids who suffer. They don’t get to have a decent playground.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you’re right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn right I’m right! Throughout the long history of the Chinese people, we’ve always been our worst enemy. Right now it’s KMT versus Communists. Used to be Confucianism versus Taoism. Before that it was Three Kingdoms and all the other states in the periods when China was divided. If you ask me, we should have never united. We should have just left well enough alone and stayed separate countries like Europe. Would have been better for all of us!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds kind of anti-Chinese to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m the anti-Chinese Chinaman. I grew up here and then I committed the ultimate disgrace to my ancestors.” He chuckled a little bit. “I married a white girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At least she wasn’t Japanese.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, ah, you’re right! Ha-ha!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You still live here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, we left this neighborhood a while ago before my kids became teenagers. I don’t know if you’re old enough to remember this but there was a budding gang problem here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, believe it or not. They called themselves the Continentals. These little bastards would break off the metal emblems from cars. I caught some kids going after my car and I chased them off. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("The next night they came back and smashed my windshield. That was when I said we had to leave.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had been in the Continentals, but I got my emblems from tourist cars in a parking garage. “Did you tell the cops?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. What was the use? They couldn’t do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They can’t do anything when crimes aren’t reported. But maybe I’m biased.” I handed him my card.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I should have known who you are, Officer Chow. I will come directly to you if I see anything out of the ordinary. I’m not here that often, though. I’m a widower now. I move back and forth between the kids, New Jersey and Massachusetts. One boy and one girl I had. They both ended up marrying Chinese. Can you beat that? After all my warnings to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you kind of drove them to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sedan at the edge of the park honked its horn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s my boy. We’re going to eat Chinese tonight. Care to join us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry, I have plans already, but I appreciate the invitation. What’s your name, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook hands with me. “Byron Su. That’s my name. I’m sorry you’re busy. Why is it so hard for Chinamen to just get together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gave him a nod and started for the toy store.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he midget was pulling the metal gate across his storefront. “Oh, Robert, I was wondering if you were going to show up for dinner with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What made you think I was going to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I knew that Lonnie had that interview with the Chinese official guy today. I figured that when he got a look at her, he’d make some excuse to have dinner with her tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not eating alone. His guards will be right there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("Talking to himself the midget said, “They can’t eat in the hotel’s restaurant for security concerns, so they have to eat in his room. He’ll find some way to get his guards to leave. . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about, man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, nothing, I’m just trying to annoy you. Next time just give me a ring when you want to do dinner. It will make me feel less like a backup plan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wanted to be spontaneous. I mean, we’re close enough friends that we know we don’t take each other for granted at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget flexed his arms and snapped two large padlocks into place. “I might already be busy tonight, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please have dinner with me. I turned down another invite tonight to eat with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget smiled. “Sure, in that case, let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We went to a noodle-soup shop below the street level at the southern end of Mott. He made sure to order two vegetable dishes on the side. I think Lonnie had gotten to him about my diet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s Paul doing with that Columbia thing?” asked the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seems all right. He never tells me too much about it, and honestly I wouldn’t understand what he’s researching.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ever thought about going back to school part-time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure, I’ve thought about it. In the end, though, I don’t think it’s a good idea. I’ve been out for too long and I was always a crappy student anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sucked down a mouthful of soup. “Would probably help with promotions, job security, and better assignments.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It might.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would probably help you and Lonnie have a better future together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll light up some incense at the Buddhist temple and pray for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("“God helps those who help themselves. Besides, libraries don’t smell nearly as bad as those temples.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ever use the bathroom at the library?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget put his elbows up on the table. “I never tell you to do anything, right, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go to college and get a degree. This GI bill isn’t good forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll think about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Think about what school and what major.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went back to my apartment and Paul showed me a bulletin from NYU. The descriptions of the classes all sounded interesting, but so did food on a menu, and I wasn’t sure that I could eat the same meal for an entire semester.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you think I should study?” I asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That depends,” he said. “Are you going to stay a cop or going to get a different job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m in for the twenty years, Paul. I made a commitment to the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In that case, you should probably enroll at John Jay and get a degree in criminalistics.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know about that. I met this guy who studied criminal justice and he’s doing worse than me. He’s not even a real cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about studying business and leaving the force? You could make a lot more money and not have to put your life on the line.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laughed all the way to the refrigerator. I popped open a Yoo-hoo and drank some. “I like my pretty little gun too much, Paul. I also like Vandyne too much to leave.” I could quit the NYPD, no problem, but I could never let my old partner down. If "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("anything ever happened to him on or off duty, I could never forgive myself for it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I finished the Yoo-hoo and then hooked it into the garbage can in the kitchen. “Oh, did you see that?” I asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did.” He was trying to read something now and I was bothering him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you do today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I cataloged some more core samples.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of job can you get after you study these things?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can go work for an oil-exploration company and make a whole lotta money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like how much money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want to think about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just give me a rough idea.” It was going to be so embarrassing when Paul starting making more than me, and it wouldn’t be that long from now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The phone rang and Paul told the ceiling, “Thank you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I checked the time. Twenty-two minutes after ten. It was safe to answer the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When people have something bad or negative to tell you, they tend to wait until the hour or the half-hour as a deadline to help force themselves to make the call. I don’t answer the phone on the hour or half-hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyway, I knew who it was calling me. “Lonnie,” I asked, “how did it go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, it was very interesting! The Plaza is an unbelievably beautiful hotel! It’s right out of a Cinderella story.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me about Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chen likes to joke around a lot. He’s very funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he try anything with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh no, his guards were there most of the time. They left "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("near the end. He was sort of touchy-feely. Nothing bad. You know those kind of men? They like to grab you to make a point.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gritted my teeth and tried to chuckle. “Does it look like Li Na is going to be allowed over?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He thinks the chances are pretty good. You wouldn’t believe how things are in China now. The political environment is absolutely poisonous. But, Robert, I should go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? We just started talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but I have to transcribe my tape. Usually we have people doing transcriptions at work, but because this is in Cantonese and not English, I have to do it myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see. Well, make sure they count this as your work hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not going to do that, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not fair at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, I know. Robert, I have to get to work now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, Lonnie. Don’t work too hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I already am!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t go to sleep too late. I let Paul beat me at two games of Quickopoly. That’s when you deal out the properties to Monopoly at the beginning of the game to make sure that things keep moving. I let him beat me because if I actually tried to win, I know I would have ended up so frustrated I’d be up all night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At some point in the morning the phone rang and I picked it up, although I wasn’t awake until the receiver hit my ear. Body. Older Chinese man. Possible mug victim. Eastern part of Chinatown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m coming,” I croaked.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _vm._v("y head was freezing from the cold morning and my inability to dry my hair properly. My ears were numb by the time I had walked the few blocks from my apartment to where Hester Street ran across Chrystie Street into Sara D. Roosevelt "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_vm._v("Park. The man’s body was curled on one of the park’s splintered benches. He was wearing a collared dress shirt and wool slacks. His socks and shoes were gone and his bare feet looked waxy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The caved-in part of his skull was most likely the cause of death, though it was always dangerous to assume anything. Hell, he might have been poisoned and dumped, and then had his head caved in by someone testing out a sledgehammer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was 0700 and English was already smoking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came up and touched his shoulder. “I thought you were going to quit, man,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He folded his arms and puffed out his cheeks before exhaling. “Whenever I get enough willpower together to stop, some bullshit like this happens,” he said. “I’m probably going to go through two, three packs today. There really should be a law against murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who found him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t know. Phone tip. Probably gonna be a pain in the ass to identify, as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me get a good look at the face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the spirit, Chow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After enough pictures were taken and the man was officially declared dead, the paramedics rolled the body away with the same casual disregard they would have with a securely packed side of beef.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a second,” I told them. I craned my neck and stared hard. There was a very strong resemblance between the victim’s blood-colored face and Chen Xiaochuan, aka Mr. Chen, Li Na’s representative from the People’s Republic. I wasn’t sure. I hadn’t met the man in person. But Lonnie had.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went back to English. “I think I know who that is,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glared at me. “I’m in no mood,” he warned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the envoy from Mao’s daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("“You sure?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pretty sure. Won’t be too hard to find someone to positive ID him. Lonnie just interviewed him yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His cigarette wagged in his left hand. “Can you have her at the Bellevue morgue this afternoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’ll be there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We watched the medics lift the man’s body into the wagon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say, Chow,” asked English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What time did Lonnie interview him last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They had a late dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What restaurant they go to? Right around here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, they actually ate up at his hotel in Midtown. Um, in his hotel room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gave him a hard look. “She had nothing to do with this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t say she did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even if that is him, I’m ruling her out as a suspect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever you say. Just make sure she IDs the body today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I hope you know that if it is in fact the guy, we’re going to have to take down a statement from her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait, let’s have an idiot test right now. Someone should call the hotel and see if he’s there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Assumed name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ask the FBI.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have a contact there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does Lonnie know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went back to my apartment to call Lonnie. It was almost time for her to get up, anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She answered the phone, talking slowly like she was underwater. “I was up all night, Robert. I can’t believe it takes so long to transcribe and then translate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you finished?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I am. I have to read it one more time. There may be some more corrections I have to make.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, make sure you get it right. That interview may be pretty damned important. I think Mr. Chen’s been murdered.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She dropped her receiver on the floor, sending a hard clunk into my ear. “What!” I heard her yell. Then she picked up the receiver and yelled “What!” again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, we had a body down here. I think it’s him, but you would know for sure. Do you happen to know the name that Mr. Chen was staying under?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. One of his security guards met me in the lobby.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What room number was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember, I was so nervous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What floor was it on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ten. No, wait, twelve, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie! Do you realize what kind of fix you could be in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t yell at me, Robert! If Mr. Chen is really dead, that would really terrify me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If we can’t figure this out, you could be the main suspect, Lonnie!” I blurted out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I got into the squad room, I called The Plaza and bullied the manager. After waiting a while I learned that Mr. Chen wasn’t in his room although his belongings were. If he was at breakfast, that son of a bitch better choke down his oatmeal and come back to the hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("ecause I am usually right in being paranoid, I met Lonnie in the anteroom of the Bellevue morgue.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert,” she asked, “why are you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just want to make sure you’re going to be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re okay with seeing a dead body?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure I am. I mean, I have to see one sooner or later, right? I’m a journalist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We walked through the doors and nearly ran into English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Chow,” he said, smoke rolling out of his nose. He tossed his cigarette into a metal ashtray stand that looked like it had been pulled from a serious house fire. He turned to Lonnie and said, “As I mentioned, we would have been happy to pick you up and escort you here, but we’re glad you made it just the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you very much, Detective Sanchez,” said Lonnie. “We are actually very close to my office, so it was no problem. I didn’t know Robert would be here waiting for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("English smirked. “I didn’t know, either, Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stepped back and then I noticed two guys from Manhattan South, one black and one white. I studied them and we all nodded to each other. Two lamps hanging from the ceiling illuminated the dust in the air and a body under a sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I touched Lonnie’s shoulder. “Are you ready?” I asked. She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mortician, a husky young white man, stretched his fingers in his gloves and gently lifted the sheet and folded it below the shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie came around to the other side and gasped. “It’s him,” was all she could say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pulled her back and pressed her to me. “It’s all right,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” she said as she pushed gently away from me. “I’m okay. I told you I’d be okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_vm._v("“You got that?” I asked English.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, we already know it’s him. The Chinese U.N. delegation already identified him.” English grimaced. “Now we just need to follow up with Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean, ‘follow up’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s the last one who’s seen Mr. Chen alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One of his security guards saw him after!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not what we heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie, didn’t his men come back into his room?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked at me and then English. “I assume they did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They say they didn’t,” said English. “Lonnie, I’m going to ask you to come down to Manhattan South and tell us what happened. Don’t worry. You’re not a suspect, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She came here voluntarily!” I said, glaring at English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We appreciate volunteerism. It’s the spirit of America.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie looked worried. “I need to be back for the edits to my interview, and I guess to write about this. Will I be out by three?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("English smiled. “You’ll be out by one thirty at the latest, I promise. This is just a formality in a murder investigation.” Looking at me, English added, “You’d be doing the same thing if it wasn’t her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I need a lawyer, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think so, Lonnie. They know better than to mess with a reporter!” I yelled the last word loud enough to make the Manhattan South guys wince.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he later editions of the Chinese newspapers reported Mr. Chen’s death. The Taiwan-biased paper declared that Communist agents had gotten to him. The Hong Kong–biased rag lamented how unsafe Chinatown had become ever since those lowlifes from Fujian province started coming into the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_vm._v("The pro-Communist paper did not say one word directly about Mr. Chen. The People’s Republic had likely imposed a news blackout on him. But there was yet another article criticizing the Gang of Four, noting that counterrevolutionaries sow the seeds of their own demise.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came home with all three papers folded under my right arm. I was surprised to find Paul. “What are you doing here? What about your job at Columbia?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many times do I have to tell you?” he asked. “Wednesdays and Saturdays. Wednesdays and Saturdays. Two days a week!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got bigger things on my mind!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then get a bigger mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I noticed there was a wave of static coming out from my stereo. “If you don’t know how to use my equipment, ask me how or don’t turn it on. You left the receiver between stations, that’s why all we have is noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not noise. I’m playing an album.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a record? What is this crap?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He showed me the record cover. The Ramones. They looked like four white dirtbags who should have their hands against the wall and their legs spread out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who the hell gave you this, Paul? A drug dealer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My boss at Columbia lent it to me. She wanted me to hear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your boss?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does she look like the tall one on the cover here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me know when you’re ready to talk about something serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, I am, Paul. Have you heard from Lonnie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Is there something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_vm._v("“There could be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t do anything!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then what did you forget to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Paul, did you hear about that older man that was found dead in Roosevelt Park?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure I did. A homeless guy, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wasn’t a homeless guy. That was a brief we put out to mislead the American press until we were sure. It didn’t work with the Chinese press, though. The dead man was the guy from the People’s Republic—the one Lonnie interviewed!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was he murdered?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Lonnie may have been the last one to see him alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul got up and took the needle off the awful record. He turned to me and asked, “Can she prove she’s innocent?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do believe she’s innocent, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I think she actually interviewed the guy, killed him, and then dumped his body in the park.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Mr. Chen interview was Lonnie’s big coup. It could really help her career, and his murder will only raise the profile of this piece.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your sister has to prove she’s innocent first!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How hard could that be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never know. Manhattan South took her in for questioning and then let her go back to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why is Manhattan South involved?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because this could be a politically sensitive case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you talk to Lonnie after she got out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_vm._v("“I did, but not for long. I didn’t want to take up too much of her time because she had to finish a story.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If they had any evidence, they would just plain arrest her, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but she’s the leading candidate for the murderer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember reading this story about a reporter who went around killing people to get exclusives on the serial murders going on around town.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s your sister, man! Don’t talk about her like that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine. So then, how are you going to prove she’s innocent?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not a lawyer! Damn, maybe she needs one.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("rtie Yee, the guy whose newspaper office burned down, came by the precinct to see me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My insurance company is giving me a hard time, Robert,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? I thought it was ruled an accidental fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The FDNY has determined that it was an electrical fire. A wire in the wall I couldn’t have known about. But my insurers have hired a private investigator to see if I could have possibly set it off. Can you help me out on this one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a tough break, Artie, but I don’t see what I could do,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I get it. You’re blaming me for that trouble that Lonnie’s in because I got her the interview.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not blaming you for anything. You actually gave her a big break, but maybe you can help her out of the jam she’s in now. Just tell me who killed Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Artie laughed and looked around the squad room nervously. “Jesus, I don’t know, Robert. How could I know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry, Artie. We’re the only ones here who know "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60",
      "title": "60"
    }
  }, [_vm._v("Cantonese. Now tell me who got you in touch with Mr. Chen to begin with.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put his hands in his pockets. “I came in here looking for help and now I’m being interrogated!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you feel more comfortable talking outside?” Not waiting for an answer, I stood up and put an arm on him. “Let’s go to Hop Won.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only tourists go there!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hop Won on Lafayette Street is the kind of place you’ve seen in every television show when they need a Chinese restaurant. It’s got bowing, smiling waiters in silk outfits, and paper lanterns everywhere—even on top of the tables. The numerous gaudy paintings of rivers and mountains on the walls were mirrored in the free-flowing duck sauce and mounds of crispy noodles. Hop Won’s menus were in English with marked-up prices that only a tourist would pay. And Hop Won actually took credit cards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most important, the restaurant kept up a din of piped-in cymbals, drums, and flutes that foiled eavesdropping waiters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hullo and welcome!” the restaurant greeter chimed as we walked in the door. He was a thin man about five feet tall and probably got his job because of his light-colored skin and cheek-to-cheek smile. When he saw Artie and me up close, his forehead creased and his eyebrows puffed out with worry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In English I said, “How about that table by the speaker?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without a word he yanked out two menus and stomped over to the booth. Before we took our seats, he swatted the table with the menus and left without looking at us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("See, the only reason we were there, he thought, was to mock the décor, the food, and the greeter himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We flipped open the heavy menus. They were thicker than "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_61",
      "title": "61"
    }
  }, [_vm._v("usual because every item was accompanied with a picture, requiring more pages.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They shouldn’t have used a flash,” Artie remarked. “It makes everything look even more greasy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It gives the pineapple chunks a nice sheen, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our waiter approached our table with much trepidation. He’d already been forewarned. “You want forks or chopsticks?” he asked in Cantonese.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chopsticks are fine,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want tea or water?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want a Coke,” said Artie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want a Coke, huh?” said the waiter. He was only slightly less contentious when we ordered. For four-dollar dishes in this economy, he should’ve been giving us shoulder massages. Instead, we only got silence and sugar-laden sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While we ate, I asked, “Artie, who hooked you up with Mr. Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wiped his mouth with his fingers, smearing a dab of orange gunk across his bottom lip, leaving a thin streak. “It was this girl who used to work for me. I think you know her, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait, not Barbara.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, her! Apparently she had contacts with the Republic of China who put her in touch with him. I was glad she thought of my paper first, even though it didn’t turn out that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her Taiwan contacts put you in touch with Mr. Chen from mainland China?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See, it’s an embarrassing story to the People’s Republic, that some private citizens in Taiwan were quietly sponsoring some of Li Na’s efforts. They took care of Mr. Chen’s airfare from Hong Kong and put him up in a hotel here.” Artie looked thoughtful for a moment. “The FBI took care of his security, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_62",
      "title": "62"
    }
  }, [_vm._v("“What a nice job they did, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe the Taiwanese had flown in Mr. Chen to kill him and embarrass the Communists. I played around with my rice. The rice grains weren’t sticky at all—in other words, not chopstick-friendly. I picked up the bowl, put it to my lips, and shoveled some of it in. What was this? Minute Rice?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who were the people that Barbara talked to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head. “You have to ask her. She gave Mr. Chen my info and he called me.” Artie took a swig of tea and shrugged. “Well, that’s not terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not even going to try,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t know it, but I’ve known Barbara her entire life. My dad used to own this little grocery store on Mott Street just below Canal. I worked there until my early thirties. You remember that place, right, Robert? It was called Ginny’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rubbed my chin. That was the place all the kids in my gang, the Continentals, used to boost stuff from. I picked up chocolate bars there like my coat sleeve was a vacuum cleaner hose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I don’t remember it all that well,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My dad died pretty early on. He was a hardworking guy who put his shoulder to the wheel every morning. The results were definitely on the moderate side but nobody put in more effort than him. His problem was that he was too honest. All the other grocers were pushing their suppliers for kickbacks and other discounts, but not my dad. They all told me he was stupid for not asking for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Getting a discount isn’t illegal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you don’t report it on your income, it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So Artie’s dad instilled a principled foundation in him. They had probably spent a lot of time together in the store. My father didn’t try to instill much in me, apart from the idea that being a "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_63",
      "title": "63"
    }
  }, [_vm._v("cop was stupid, and I would find that out on my own soon enough. But we hadn’t had as much money as Artie’s family, and Dad certainly wasn’t very good with the money that passed through his fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” I said, “your family had the money to put up a store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, not exactly. I know what you’re thinking,” said Artie. He pushed back in his seat and leaned his face into mine. “We didn’t have very much money at all. Tell you the truth, Dad’s brothers and sisters all put their money together for us to run the store. We made money, plenty of money, but not enough to keep my uncles and aunts from accusing us of skimming from the top. They said that what I ate alone was costing twenty dollars a day.” He patted his gut. “I was always big, but that was a hell of an exaggeration.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I cringed. The Continentals would easily sweep out twenty dollars’ worth of merchandise on a regular basis from Ginny’s. I nodded and let him continue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the end, they came down on us and forced my dad to sell the store to get their money back. It killed him, you know. He was a man of honor, but he was also too proud to go work for someone else. He wasn’t much older than me now when he had a heart attack and passed away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But believe it or not, I remember only good things about the store. All the customers who would come in and the stories they would tell. I remember when Barbara’s dad brought her in, she was this little baby girl all wrapped up like a little squash. He was showing her off like he was taking bids.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet he became less and less enthusiastic with each baby girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can say that again! He didn’t even bring the fourth girl in when she was a baby! Of course, it wasn’t much longer after that when we lost the store. But didn’t Barbara turn out nice?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_64",
      "title": "64"
    }
  }, [_vm._v("“Sure, she did.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You two were together for a little while, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t work out, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re still friends, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah, of course! We’re just both really busy people. We don’t see each other much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you two ever in love? I mean, ever serious about getting married?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to fish for anything anymore, Artie. Your newspaper’s gone so there’s nothing to report.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, you don’t have to get like that. I’m just saying, you know, as men, we can agree that Barbara is very attractive, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can agree on a lot of things, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know if I should tell you this, but a number of years ago, I could have made a play for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I don’t like to brag. But, anyway, have you heard anything about the second sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s in medical school somewhere in California, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s so far away,” Artie said. “She is a real looker, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They all are beautiful women.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think I should try calling the second sister? Do you think she’d remember me? With my paper gone, I could be free to move out there and settle down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t comfortable with the way the conversation was bending. I did a drumroll on the table with both hands and said, “How about we get that check now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. Our keenly attuned waiter took that as a cue to come over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_65",
      "title": "65"
    }
  }, [_vm._v("“Not really,” I said. “But we got what we expected.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The waiter tore off our check and placed it on the table. “Next time, don’t go where you’re not wanted,” he said with a big smile.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("onnie called me late that night. She assured me that Presswire had its own legal team and that they would protect her legal rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, her interview with Mr. Chen was making the rounds. She had scooped the Associated Press, and newspapers all around the country were running the interview with a sidebar she had written about his untimely death. The top editor of Presswire had embarrassed her by making everyone in the newsroom stand up and clap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guys at Manhattan South hadn’t given her a hard time. They had only asked a few questions and then let her go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie was going to be working overtime the next few days to write follow-ups, but we made plans for the weekend. Nothing big. Just dinner and a movie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After hanging up, I put on my coat and pulled a rain hat low over my face. I went by Lonnie’s apartment and walked around the block.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("V")]), _vm._v("andyne came back from time off and we met up early in the morning to eat in a crappy diner by my apartment. I caught him up on the murder and Lonnie’s situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw two Manhattan South motherfuckers parked outside Lonnie’s apartment last night,” I said. “I could hear them eating even with the windows up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne shook hot sauce all over his eggs. “Don’t get too worked up about it. They’re just doing their jobs. They think it’s bullshit, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_66",
      "title": "66"
    }
  }, [_vm._v("“You think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, man. I bet if there wasn’t someone checking up on them, you would’ve heard them snoring.” Vandyne pulled his mouth to the left and looked out the window at nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m better now. Had a long talk with Rose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did it go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honestly? It was infinitely depressing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am really sorry to hear that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just to think that this woman you’ve already promised to spend the rest of your life with is like a stranger again. Actually, worse than a stranger, because a stranger doesn’t expect anything from you. I feel like I have something to prove to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have anything to prove to anybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. I have half a mind to just let it all go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you don’t want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.” He put more hot sauce on his eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne, you’re going to set your plate on fire there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, shit,” he muttered. “How am I supposed to eat this now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about it. You can have half of my pancakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, man!” I took the saucer from under my coffee cup and dragged two pancakes onto it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, you and Lonnie, whatever happens, remember to stay young.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“ ‘Young’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, man, ‘young’! When you get older, you forget how to forgive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re scaring me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m just trying to share knowledge with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ever do anything to piss you off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_67",
      "title": "67"
    }
  }, [_vm._v("“You forgive me, though, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could I hold anything against you, Chow?” he said, smiling for the first time in a while. “Just keep the pancakes coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take the rest of my butter, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n the squad room, I went over to English. “I see that Manhattan South is staking out Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s not the murderer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Prove it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at me and shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can have an attitude as long as you don’t stop working. Check in with Pizza Man. I’m sure he’s got something to keep you busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grumbled and shuffled over to my desk. When I was walking a foot-post, I was really envious of Vandyne because he had picked up investigative assignments. When he got the gold shield and the official promotion to detective, that old green devil hardened into jade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that I was trudging through investigative assignments that ranged from hopeless to thankless, I found that maybe a beat cop didn’t have it so bad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I helped put an end to that human-smuggling ring a few months ago, I think I would’ve gotten more official credit for stopping a purse-snatcher. I did get a Meritorious Police Duty bar and a nice letter from Mayor Abe Beame, though. It seemed to be actually signed, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe things got better with that gold shield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow,” said Pete. He held out a manila folder to me. “Maybe I have something for you to check out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_68",
      "title": "68"
    }
  }, [_vm._v("“Something good I hope.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I save all the good ones just for you, man.” He chuckled, assaulting me with coffee breath. “Three guns found in an apartment mailbox on Henry Street two days ago by the building super. Two were cheap Saturday night specials but one was a nice .32 revolver with a fancy walnut handle. I’m surprised nobody’s come up to claim them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A thirty-two’s not a big gun,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but the great thing about the gun is that the shell casings don’t pop out when you fire from it. I guess that makes it environmentally friendly, in addition to not leaving evidence. You don’t have to clean up after it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come City Wide Anti-Crime isn’t handling this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These guns weren’t recovered at a crime scene. Might not even have been involved in a crime yet. They’re at ballistics now, but they’re not on the priority list. There are pictures of the guns in the folder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want me to frame them or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“C’mon, Chow! Just go to the address on Henry and talk to people and figure out who left the guns.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re giving me another dead-end assignment here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was a dead-end for me, but I think people will be more amenable to talking to you because you know the language.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll understand what they’re saying when they’re cursing me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("English called over, “Just give it your best shot, Chow. Let’s see what happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took in a breath and held it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is what you wanted, I thought to myself. Show them you’re not going to let the bullshit get to you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hot dog,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_69",
      "title": "69"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" was about a block away from the precinct when my newfound spirit slipped away, probably off to cheer up some sick kid in a hospital bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put my hands in my coat pockets and kept walking. It all seemed like a funny joke. Send the Chinese cop on a wild goose chase while you try to pin a murder on his girlfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I hit Bowery, the sunlight hit me full in the face, bright white and warm. I shaded my eyes but I couldn’t help smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie would be exonerated, eventually. Maybe she was even getting something out of being followed—a sharpened reporting instinct.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man who had found the guns had either given his name only as Mr. Wing or the responding officer hadn’t been able to write down the rest of his name. I guessed the latter happened because there was a question mark written after the name. But the apartment number was clearly marked 5F.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t have to buzz his apartment because the building’s front door was unlocked and the foyer door was propped open with a splintered wood wedge. Hopefully he was home. Maybe he would talk to me. It’s harder to ignore a knock at the door than a buzz from downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I started up the stairs and cursed the fact that apparently nobody ever lives in the ground-floor apartments. The corners of each landing were filthy. I’d like to see them shoot a commercial for one of those tile-and-grout cleaners here. Goddamn sponge would probably dissolve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Wing’s door had several Wacky Packs stickers slapped on it. Some were ripped in half while most were merely torn at the edges. I heard a radio through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knocked lightly by the bolt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh?” called someone inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m looking for Mr. Wing,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_70",
      "title": "70"
    }
  }, [_vm._v("Someone came shuffling to the door and asked, “Who are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the police,” I said. “My name’s Robert Chow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighed in response and then unlocked the door. He swung open the door and pointed at it. “I call you for this,” he started, “and you don’t come. When I find guns, you’re here in five minutes. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Wing was in his mid-sixties and stood at about five feet two. He had withered a bit to about 140 pounds or so. His silver-rimmed glasses were lopsided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Finding guns is a big problem, Mr. Wing. I actually have some more questions about them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a minute. It’s not a problem when my personal property is defaced?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These stickers aren’t that big a problem. They probably aren’t that hard to get off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On cue, he reached behind the door and handed me a paint scraper, its wood handle blackened with years of sweat. “Not that hard to get off, huh? Well, put some muscle into it, pal. I’m not talking to you until that door is clean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked into his eyes. He wasn’t fooling. How hard could this be, anyway? This may very well be my good deed for the day. I crouched slightly and scraped away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was right. It actually was sort of easy, but I still broke a sweat. Five minutes was all it took. “At your service,” I said as I handed the scraper back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I have some more odd jobs around the apartment for you,” Mr. Wing mumbled. He took off his glasses and wiped them on his shirt. With his head still down he asked, “You wanted to ask me something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About the guns. How did you find them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_71",
      "title": "71"
    }
  }, [_vm._v("He slid on his glasses and scowled at me. “I told my whole story to the cop, already. White people never listen, never give respect to Chinese people! You know that, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever you say, Mr. Wing. So what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I was opening my mailbox downstairs. I saw that my neighbor’s box was broken into. The metal door was all bent back, like someone had pried it open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I opened the mailbox because I thought I could be helpful and bend the door back the right way. Then I saw a brown bag in there, all wrinkled up. Of course, I had to take a look. There were three guns in there! I called the cops right away!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did the right thing, Mr. Wing. Tell me, do you have a lot of teenagers hanging out in this building? Especially ones who don’t live here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at me hard. “Who do you think put all those stickers on my door! Everybody who lives in this building is old. Nobody under fifty, I guarantee!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then where are all these kids coming from?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where do you think? Stupid kids! They’re a part of those Fukienese Commie groups that are infiltrating our country.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I already knew the answer but I had to ask. “Mr. Wing, would you be willing to come to the precinct and look over some pictures to see if you recognize any of these possible gang members?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way in hell. I would be seen going to the precinct and then those same kids will come back and harass me. I’ll ask you for help and then you’ll say there’s nothing you can do because they haven’t actually killed me yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you’re exaggerating quite a bit, Mr. Wing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I’m not! Everybody here has eyes. Word gets around. I don’t have to tell you. At least I shouldn’t have to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_72",
      "title": "72"
    }
  }, [_vm._v("“Well, enjoy your new clean door, now. I worked hard on it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you enjoy your new sobriety, Mr. Chow.” He closed the door in my face.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went through the photo albums of Polaroids that we kept of suspected gang members. “My Beautiful Vacation” had photos shot secretly from Columbus Park. “Happy Memories” covered Bayard Street, East Broadway, and part of Pell. “Those Were the Days” covered Mott. We were supposed to pretend that these were the individual detective’s personal photo albums on our desks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the D.A.’s office had ever gotten wind of these books, our asses would be on the line because they were illegal. Something about the presumption of innocence until proven guilty and how these binders amounted to unofficial “mug” books of innocent kids being treated as convicted criminals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, there was no other way we could keep tabs on the young wildlife that some of Chinatown’s youths had become. Sure, a lot of good kids were mixed up in there, too. I made a conscious effort to weed them out. A few months ago, I tore out a picture of Paul because he didn’t belong there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Honestly, if the department had been equipped with Polaroid instant cameras back when I was a teen, my picture should have been in the photo albums.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I flipped through “Live, Laugh, Love” as I sipped from my dirty coffee mug.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s it going, there?” asked English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s all right,” I said. “Any word on those guns?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Check in with Pete when he’s in. He was keeping tabs on them. Knows someone at ballistics, so he can get a priority review. Won’t matter, though, if we can’t figure out whose they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_73",
      "title": "73"
    }
  }, [_vm._v("I stopped on a page with two photos that were sloppily shoved under the plastic cover sheet at jaunty angles. “I’ve seen that guy.” I pointed at a guy in his twenties who was shot from the side.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not him!” exclaimed English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I don’t. I was just messing with you. Where did you see him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s rooster boy. He was a jerk who had a megaphone during the protest in front of Jade Palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Photographed on Henry Street, too, huh? He might know the kids that dick around there.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t was no wonder that the guy was photographed on Henry Street. The permit for the Commies to assemble was in the name of the Union of the Three Armies, which had a below-sidewalk-level address right next to Mr. Wing’s apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I leaned over the railing and tried to look in, but the windows were covered with blinds and even though they were crooked there weren’t any gaps. I could tell the lights were on and not much else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The last step on the wooden stairs down to the office door was broken in half and rotting. The steel door itself was bland corporate gray. I tried the handle and found it open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went in and immediately a loud and continuous whistle went off. A middle-aged woman came into the room with her hands over her ears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She jumped when she saw me and screamed something. I screamed back that I couldn’t hear her. She shook her head and went behind an office desk and ducked down behind it. The alarm suddenly stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought the alarm had malfunctioned again,” she said, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_74",
      "title": "74"
    }
  }, [_vm._v("smiling. “We have a doorbell for a reason. You really shouldn’t go barging into places.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You shouldn’t leave your door unlocked,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Officer, my name is Sunny Chu. How can I help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I chuckled. “My fame precedes me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you’re the guy who stopped that smuggling ring. That was terrible what those people did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sure was. Right now, though, I’m looking for the guy who had the bullhorn at your protest at Jade Palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our protest?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, this is the Union of the Three Armies, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh,” she said, rolling her eyes. “You must mean Lincoln.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lincoln Chin. He’s supposed to be our English coordinator.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is this place?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is the BDC After-School Program. We’re a quasi-government agency that provides programming and services for kids through high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you guys basically babysit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes, yes, it does come down to that. I also like to think that we keep our kids out of trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This place doesn’t have room to hold that many kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is just our administrative office. We operate facilities in the schools themselves when the day is over and let them do arts and crafts in a cafeteria or dance around in a gym.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does BDC stand for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She blinked and tilted her head. “It’s the initials of someone who gave a lot of money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you do here, Ms. Chu?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m the Chinese coordinator. I schedule the directors—that’s what we call our teachers—and make sure they continue to perform well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_75",
      "title": "75"
    }
  }, [_vm._v("“What does Lincoln do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, he’s "), _c('i', [_vm._v("supposed")]), _vm._v(" to be writing grant applications and being the liaison with the city agencies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does he actually do, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not too much. I have half a mind to complain to our board of directors but they wouldn’t do anything about it. Besides, I do like him. He has a good heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the wall above Sunny’s head hung a picture taken in the 1950s, judging by the clothes. A younger version of her stood in the middle, in front of a crowd, handing a trophy down to a smiling kid with a bow tie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is Lincoln supposed to be here now?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He went to lunch a while ago. Sometimes he doesn’t bother to come back. It’s supposed to be the two of us here, but since I end up alone in the office so much my brother installed the security alarm. You know that son of a gun has a master’s degree?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Figures. You spend that much time in college it’ll make you a Communist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha, you know what the Union of the Three Armies is, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was when the Communists regrouped after the Long March.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you know your history! So nice to see that in a young man. Maybe you should replace Lincoln here. All he does is loaf around. What he does work hard at is trying to get the high-school students to come to his socialist meetings and events.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t see any kids at the protest at Jade Palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even young children are too smart to follow an idealistic daydreamer like Lincoln. But would you believe that some of the girls think he’s cute and dashing?” Sunny dropped her voice. “You know something? He treats his girlfriend like dirt. Who does he think he is? Chairman Mao?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_76",
      "title": "76"
    }
  }, [_vm._v("“I don’t think so. He told me he knows how to speak Mandarin.” I saw Sunny laugh. The Chairman had spoken his native Hunanese and butchered the national language when he tried to speak it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“People from Hunan!” she said knowingly. “You know what they’re like. Hot-tempered and impulsive. Communist or not, he was the wrong guy to lead China.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of Chinese is Lincoln?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From Jersey. So he’s got a chip on his shoulder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should I wait here for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could go to OK Noodle over on Division Street. At least that’s where he told me he was going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know where that is. Thanks, Sunny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you married, Officer Chow?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Girlfriend. Do you have kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I haven’t got anybody,” she said, trying to smile.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("nly two of OK Noodle’s tables in the front were occupied. The back was completely empty. Lincoln wasn’t around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There isn’t really a lunch rush in Chinatown in the restaurants that are far from the crowds stuck in jury duty. The good restaurants always had fairly steady traffic throughout the day. The bad ones struggled. OK Noodle, as a merely decent place, was appropriately named.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had launched fairly recently. The press-on tiles hadn’t been scuffed too badly yet and the manager didn’t know who I was. Also, the ceiling above the Guan Gong shrine high up on the wall wasn’t stained yet by constantly burning incense sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, Lincoln was there earlier but he had left about an hour ago. They called him “that foreign Chinese guy” because he couldn’t speak Cantonese, couldn’t really speak Mandarin, and couldn’t eat organ meats. I handed my card to the manager and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_77",
      "title": "77"
    }
  }, [_vm._v("when he read my name he mentioned that someone had come looking for me there, a certain Mr. Song.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I played with my collar and bought a Coke on the way out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song had had it in for me because he thought I was after his college-aged daughter back in the summer. More like the opposite was true, but fathers don’t know their daughters any more than men know women, so there was no use in arguing it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, there hadn’t been any use in me even seeing Mr. Song. I had been sort of dodging him and the front door of his umbrella group, Together Chinese Kinship, for the past few months. Mr. Song, as chair of the organization, lobbied on behalf of and mediated among Together Chinese’s dozen members, which were all associations aligned with the People’s Republic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song had landed in hot water for being suspected of aiding the smuggling ring that I had stopped. I had never said anything about him. But someone had shown the INS my notes and they pulled a full-on daylight raid on Together Chinese. The only illicit material they uncovered was pirated volumes of Lin Piao’s works that were now banned by the People’s Republic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The INS had issued a press release that exonerated Together Chinese, but the Chinese papers didn’t bother running it to counter their dramatic photographs of white and black agents carrying out boxes from the group’s office. There were shots of Mr. Song being restrained by two agents, his face wild and rabid like Old Yeller near the end of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I chucked the empty Coke can and headed for Together Chinese’s office on East Broadway with leaden feet. I wondered why he would want to talk to me, after he thought I had tried to stick it to his group and his daughter. It must be something serious that required a lot of help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_78",
      "title": "78"
    }
  }, [_vm._v("Maybe it had something to do with Mr. Chen’s murder. Something that would prove Lonnie innocent.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took my hands out of my pockets and picked up the pace. Despite everything, Mr. Song and I did have a common denominator in that we were both alcoholics and that he had been in recovery far longer than me. Would our mutual condition be enough to turn him back into a friendly acquaintance, if not a friend?")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("ogether Chinese’s office building was made of brown crumbling brick that would probably get soggy in milk. A blackened scar two floors up marked where some KMT supporters allegedly tried to burn the flag of the People’s Republic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two thin guys shivered on either side of Together Chinese’s front door. One was in a tan sports jacket while the other one, a real youngster, wore an unzipped black padded coat and had spiky hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You looking for something?” the tan-jacketed man asked me in Mandarin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spiky Hair cut him off. “That’s the cop, asshole!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry! So sorry!” said the first man. “Mr. Song’s been looking for you! Please come in!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No offense taken,” I said as they opened the doors for me. I stood in the middle of Together Chinese’s modest foyer. Before the doors were closed behind me, I heard thumping footsteps on the stairs. I took a deep breath and decided to let him do as much of the talking as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched a man step down the last flight. He wore eggshell-blue twill slacks and a white, buttoned shirt with a jacket that matched his slacks. His hair was parted like Richie Cunningham’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert,” he said, pronouncing my name like he was giving me detention. We always spoke in English because my Mandarin wasn’t great and he didn’t know Cantonese.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_79",
      "title": "79"
    }
  }, [_vm._v("“Mr. Song,” I said. “I understand that you’re looking for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you’ve heard right. The truth is . . .” he paused to cross the floor and shake my outstretched hand. “The truth is that I need your help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad to offer it. Assuming that I am able to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He motioned that we enter a side room. We had sat in that room when we first met. We went in and took adjacent seats at a round table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He rubbed his mouth vigorously with both hands before talking. “Robert, I have to say that I’ve unfairly blamed you for a number of woes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve already forgotten what’s happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I haven’t, of course. I know what happened was completely not your fault.” Mr. Song was doing that old Chinese trick of a too-humble apology to get me to meet him nearly halfway in the blame game.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was supposed to say, “I was also wrong,” or something like that. Instead, I said, “That’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He narrowed his eyes and smiled at my snub. A young man with a tea tray came into the room. As Mr. Song and I looked at each other in silence, the man set two green ceramic cups and filled them with jasmine tea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chow,” said Mr. Song, “this is our intern, Daniel. He goes to Hunter College in Midtown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned to get a good look at Daniel. Seemed like your average kid with limp black hair and instinctive shyness. “Hello, Mr. Chow,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Call me Robert, Daniel. I feel old when people call me Mr. Chow.” He nodded. “What are you majoring in, Daniel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He opened his eyes wide. “I haven’t declared one yet. I’m only a freshman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Daniel, don’t worry about it,” said Mr. Song.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_80",
      "title": "80"
    }
  }, [_vm._v("“I didn’t go to college, myself,” I offered.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to go to college to become a policeman?” asked Daniel. “How is that possible?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chow is gifted in many other ways,” Mr. Song said curtly. He tilted his head to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel placed the pot on the table, nodded to both of us, and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song sipped his tea and swallowed hard. “He’s a very curious boy,” he said. “Daniel didn’t mean to question your intelligence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t take it that way. He asked about college, not about my brain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure. Anyway, I do have a rather urgent matter that you could help me with.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those two guards at the door sort of tipped me off that it was urgent. They’re armed, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They are contractors trained and licensed to carry firearms, just as I am.” Mr. Song had received death threats for his Communist affiliation. “They’re just a precaution for now, in the wake of this latest news.” He brought his teacup to cover his lips. “You know those KMT bastards are already claiming that Communist agents killed Mr. Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That seems like the logical thing to think. Someone trying to flee the country probably isn’t a friend of the regime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a setup!” growled Mr. Song. “In fact, we had nothing to do with the protest of Li Na at Jade Palace. Together Chinese is the only organization in Chinatown that has official ties with Beijing. That group that supposedly represented the People’s Republic was a sham, a front, and did nothing but embarrass our political cause.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is the position by the People’s Republic on Li Na?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have no position and no comment, whatsoever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_81",
      "title": "81"
    }
  }, [_vm._v("“How do you feel about the death of Mr. Chen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s tragic but not to be unexpected in a dangerous town like New York. He probably shouldn’t have been out unescorted so late at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know he was out late at night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, he was being interviewed by your girlfriend until late that evening. I assumed he went out after it was over. That is, if I remember the interview I read correctly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, that’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That interview really got around. It was a coup for Lonnie. You’re very proud of her, I’m sure. The timing of it was unfortunate, though. I’m sure she hadn’t planned to capture his last interview.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The whole thing is a mixed blessing for Lonnie,” I said. “But, wait, are you familiar with the Union of the Three Armies?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat back and crossed his arms. “You want to test "), _c('i', [_vm._v("my")]), _vm._v(" knowledge of Chinese history?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me clarify. It’s sort of a made-up group based here. They were the ones protesting at Jade Palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For a group to name themselves that is an insult to the sacrifices made by the men and women of the People’s Liberation Army. I wouldn’t be surprised if this wasn’t some puppet group of the KMT to make us look bad. Does anybody seriously think we would give any publicity to Li Na and her counterrevolutionary clique?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“People only know what they see. And they saw Commies protesting Li Na.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, you’ve got to sort this out. Consider it a personal favor to me. Beijing has been a little distant from me after the whole goddamned INS debacle but now that the leadership seems solidified after Mao, they’ve asked me to quiet down this whole mess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_82",
      "title": "82"
    }
  }, [_vm._v("“ ‘Quiet down?’”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what I mean, give it a lower news profile. What would really help is if you could discover that it was a common mugging gone wrong. At least you could help defuse the political implications of the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How am I supposed to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me more about this fake Communist group. I can pass on the details to contacts at the newspaper backed by the People’s Republic. They’ll take it from there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m looking for the guy in charge of it, myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s his name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t tell you that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song smiled. “You’ve already told me the name of the group. Wasn’t that a little unscrupulous of you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all. It’s a matter of public record. Look it up if you want more information. One of the best things about a "), _c('i', [_vm._v("democracy")]), _vm._v(" is that our government is accessible and accountable to the people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t forget, Robert, that this little democracy of yours killed Mr. Chen. But let’s not argue about the merits of one system against another.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good, because I didn’t go to college.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I also realize there’s little you can do but pursue this case to your fullest powers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, Manhattan South is handling the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song covered one hand with the other. “So this case really is a big deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It could be.” In actuality, Manhattan South handled thousands of murders that were off the press radar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you could still contribute any findings you make, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They sure wouldn’t turn away help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Am I right in assuming that your girlfriend is a natural suspect?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_83",
      "title": "83"
    }
  }, [_vm._v("“No, you’re wrong.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s just that based on television shows, they always go after the people who last saw the victim.” He smiled. “Aw, don’t listen to me, I watch too much TV.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sipped at my tea for the first time. It had a light, elusive taste, which meant that it was probably pretty good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drink up that tea,” said Mr. Song. “It’s not expensive, but it is difficult to get.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t have that much. I’ve just had a Coke.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What a shame. Well, that’s more for me. Are you drinking, um, anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. I’ve been sober the whole time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad to hear that. I was actually worried about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could have dropped me a line.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could have, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were mad at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I was. But, still, I was worried.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How is Stephanie doing up at Yale?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song gave a hard half smile. “Oh, she’s doing well. And her male roommate is doing well, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew better than to ask any more about his daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("ssociations and groups loyal to the KMT and the Communists were in general under the respective umbrella groups of the Greater China Association and Together Chinese Kinship. Each umbrella group lobbied local city politicians for their own political causes as well as mediated disputes among members.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Together Chinese Kinship was far smaller than the Greater China Association, but it was riding a wave of momentum. The People’s Republic had displaced Taiwan from the United Nations. High-profile visits of the mainland by Nixon and Ford had melted down the American public’s perception of evil “Red "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_84",
      "title": "84"
    }
  }, [_vm._v("China” into a genuine curiosity. Once they found the mainland on the map and traced their finger around its grilled-pork-chop shape, Americans could see for themselves how insignificant the “Free China” of Taiwan was. It wasn’t even a French fry next to that pork chop.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every October 1, the national day of the Communists, Together Chinese Kinship held a parade in its section of Chinatown. The celebration was undeniably growing in size and area with each year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On October 10, the national day of the KMT, the Greater China Association held its parade. In recent years the umbrella group had boosted the number of flags that were waved. It even regularly flew in from Taiwan thousands of cheap plastic flags of the Republic of China to hand out to the sightseers snapping pictures. These Americans would examine the flags with quizzical looks on their faces. “What flag is this?” they would ask each other. “Doesn’t the flag of China have five stars on it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the apparently fervent rivalry between Together Chinese Kinship and the Greater China Association, there were unofficial fringe groups on both sides of the divide that saw the two umbrella groups as secret collaborators. In this scenario, representatives of the two umbrella groups met in secret to carve up Chinatown according to their own business interests while setting fixed prices for wages, restaurants, and even the Bruce Lee memorabilia for sale on both sides of Bowery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rumors of these secret meetings were completely unsubstantiated by evidence, but both sides did, after all, maintain that there is one China and that Taiwan is a part of China. It was in the interests of both umbrellas groups to have open communication lines should the People’s Republic of China and the Republic of China someday reunite, even if such an idea was as likely as bitter rivals East and West Germany getting back together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_85",
      "title": "85"
    }
  }, [_vm._v("Of course, there was a small fringe group that was vehemently opposed to Taiwan “reuniting” with the mainland because Taiwan was its own country. After all, before the Qing Dynasty collapsed on the mainland, it had officially ceded Taiwan to Japan in 1895. Taiwan had been a colony of Japan until the end of World War II. When the KMT lost to the Communists in the Chinese civil war, the remnants of those armies retreated to Taiwan and took out their frustrations on the local Taiwanese by imposing martial law and brutally suppressing any dissent. Supposedly. The pro-KMT newspaper reported nothing but a continuing economic miracle on the island.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln’s group, the Union of the Three Armies, didn’t qualify as a fringe group. Protesting in public was a stupid idea. Even dumber was having a name and identifiable principals in the group. The underground extreme right and left wings were small, efficient, and operated internationally. They made the triads of old look like a lemonade-stand racket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When night fell in Chinatown, stupid gang kids did their best to bullet-graze each other’s foreheads while trained and disciplined operators walked in the shadows. They apparently broke into offices and stole Rolodexes, and paid homeless people to bring them bags of garbage from businesses and associations. The fringe groups didn’t operate gambling dens or pross houses or deal in drugs; their trade was in selling information, blackmail, and, apparently, assassination. When you read about killings or disappearances of right- or left-wing agitators in Taiwan, Singapore, or Chinese communities throughout East Asia, you can bet their hands were in it. Funny how these stories never made the American newspapers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though their reach included North America, they hadn’t noticeably killed anyone here until a few months ago. Out in Vancouver’s Chinatown they had shot a guy twice in the back of his head. He was an ex-cop from Hong Kong who had freelanced as "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_86",
      "title": "86"
    }
  }, [_vm._v("a security guard for Jade Palace. I had met him and he actually turned out to be a decent guy. They had never found his killers and the story faded away, as according to plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These fringe groups, and not the Greater China Association, were what worried Mr. Song.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" called Lonnie from a pay phone at Canal and Eldridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, I can’t talk too long now!” she said. “I have to finish another story I’m doing and I’m doing all these interviews on the side.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What interviews?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, other news sources from all over the world want to talk to me. My interview has been published by so many newspapers!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m worried, Lonnie. Manhattan South has been staking out your apartment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry. Our lawyers say that if the police had any evidence at all against me, they would have arrested me already. I’m sure I’m going to be cleared.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’m sure they know better than me. I’ll let you go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She said bye and after we hung up I punched in the number of a guy I knew at Manhattan South.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("nspector Izzy Rosenbaum met me at his office door. He clapped me on the back and said, “Chow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy was an average-sized man, but there was a gentle menace to his demeanor and his dull brown eyes alone could pin you to the wall. He kept his gray hair in a crew cut so that it looked like a light fungus growing on his muscled and veiny forehead. Izzy hated wasting time and never said more than was necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Lefty,” I said to Izzy. He had gotten the nickname from "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_87",
      "title": "87"
    }
  }, [_vm._v("punching out a jerk years ago when he was back in the academy. That jerk was now the commander of my precinct.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can I stop your guys from shadowing Lonnie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her boyfriend is a cop. Doesn’t that give her a pass?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t trust cops.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have a single shred of evidence against her. All you have is that she met him for an interview and then she left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We heard more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much more?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They left together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean Lonnie and Mr. Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy nodded. “Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They left the hotel together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure she was just going home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was probably going to get a magazine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, you can’t honestly believe Lonnie killed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t believe anything at this point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who told you they left together, anyway? Some drunk on the street?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lobby cameras.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you ask Lonnie why they walked out the door together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lefty stretched out his jaw and rubbed his chin. “We already did, at the original interview. I guess you didn’t know about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I knew,” I said. “He just wanted to see her off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come he didn’t come back?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_88",
      "title": "88"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("hat night I was on the phone with Lonnie.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why the hell didn’t you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t talk to me that way, Robert!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because it doesn’t matter, that’s why.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You told me you left by yourself after the interview!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I forgot that Mr. Chen came down after! I was waiting in the lobby for the limo service and he chatted with me for about a minute. He asked me if I wanted a ride from his security detail, but I said no. The car came right after and he walked me outside. I got in, he chatted with the driver in Mandarin, and then he said good night to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He and the driver were chatting in Mandarin? What limo driver speaks Mandarin?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, I hired a Chinatown livery car, Heavenly Horse. Presswire was paying for it and I wanted to bring some business to the community.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You talked to Heavenly Horse on the phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I walked into their office. It’s close to home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good. Since they saw you in person, they’d probably remember you. You came home alone, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard her sigh. “Yes-ss-s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t do that. You sound like Paul when you do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then don’t treat me like this. You’re meaner than the Manhattan South guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you see Mr. Chen go back into the hotel? Maybe through a side door or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t. When they told me he didn’t come back in it was a surprise to me. He wasn’t ready to go out. He didn’t even have a coat on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You told the detectives all this, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, of course!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_89",
      "title": "89"
    }
  }, [_vm._v("“That’s good, then. I’m glad you told them everything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me, too. How are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, you know me, I’m fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sound really worried!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am! You don’t know how much of a jam you’re in!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The lawyers say I’m completely in the clear! Please relax, Robert!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I knew better than to let up. When you relax they slip the noose over your head and drop the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" had a late dinner with Vandyne. We met up at a place downstairs from the sidewalk where Mott runs into Bowery, a busy intersection. Tourists don’t go there because the stairs down are usually covered with blown-in trash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The best thing about the restaurant was that it was one of the few that actually had booths running from the floor to the ceiling. It used to be a speakeasy, according to the midget, but he might have been pulling my leg when he said it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a good thing they no longer served alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A waiter in his fifties came over, leaned against the booth wall in his black T-shirt, and asked us what we wanted. I ordered greens in garlic sauce and roasted chicken for both of us. The waiter turned to Vandyne and asked in English, “You want tea, Detective?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne’s eyebrows shot up. “Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The waiter smiled and went away. When he came back he flipped our ceramic cups over and poured tea, Vandyne first. Vandyne rapped his first two knuckles against the tabletop, making the waiter chuckle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, you know,” said the waiter. After he put the teapot down he added, “My first English teacher was black man!” The waiter gave Vandyne a thumbs-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_90",
      "title": "90"
    }
  }, [_vm._v("Vandyne smiled and said, “I can tell he was a good teacher.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very good, very good!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After he went away, I said, “He had to make it a point with you that he knows another black person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s racism.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not racism, Chow. Racism is coming in and being seated in the back or not being seated at all. He’s just trying to reach out across cultures. That’s a beautiful thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So is my ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So when I tapped my knuckles when he was pouring the tea, was I being racist or was I sharing some cultural knowledge?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grunted and took a sip of my tea. “He poured it too early. It hasn’t had time to steep, yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This poor waiter can’t do anything right, can he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He can shut up and bring our food without the chitchat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the Lonnie thing that’s bugging you, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re goddamned right it is! Am I the only one really worried about the whole thing? She’s not even taking it seriously!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just lay off of it, Chow. Let the investigation run its course. The public doesn’t trust us but we should at least trust each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at him sideways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, man,” Vandyne continued, “these aren’t fuckups handling this. It’s Manhattan South. They’ll do a good job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Izzy wouldn’t tell me who was handling the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good thing, too. You just stay away. How would you like it if you had someone telling you how to investigate those guns in the mailbox? That so-and-so was innocent and that so-and-so was guilty?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right, Vandyne.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_91",
      "title": "91"
    }
  }, [_vm._v("“See? If you try to interfere, you’re just going to make things worse. A lot worse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The waiter swung in with our greens, chicken, and two bowls of rice. He poured us more tea and smiled, which nudged up the bags under his eyes. He wasn’t such a bad guy after all.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" felt restless at home. Paul played both sides of the Ramones record and the back of my brain was pulsing, the lizard part. I couldn’t stop thinking about those two jerks who were tailing Lonnie around town. They were probably parked outside of her apartment now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There likely wasn’t much that I could do about the Manhattan South guys, so I set my mind to other things. I thought about those guns stuffed in the Henry Street apartment mailbox. What if a little girl had opened that box instead of old Mr. Wing?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I zipped up my heavy black coat, the one with the blanket lining. I had to be ready to stay outside for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you going, Robert?” asked Paul. He was sitting on the couch reading a book, seemingly undisturbed by the racket coming from the stereo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You really want to know?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He closed the book on his left index finger and stood up. “It’s about Lonnie, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pulled on my gloves and didn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, what are you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t just go over to the guys staking her out and start swinging!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am not going there, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put on a Rangers cap and pulled the brim low, almost over my eyes. “I’m going out now on official work, if you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_92",
      "title": "92"
    }
  }, [_vm._v("“I don’t mind. I just don’t want to see you get hurt doing something stupid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t do anything stupid. Anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chinatown is deserted at night for the most part. The halfway decent restaurants start closing at nine at night, creating dim blocks of rolled-down metal grating with garbage bags sagging in the gutters. They never have pictures of Chinatown like this for the tourist pamphlets and postcards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rumor was that the restaurants closed that early to avoid roving bands of idiot gang kids looking to score a free meal. What the kids typically do is go into restaurants and eat up complete meals—with alcohol when possible. When the check comes, they sign their gang name on it and split. The nicer gang kids would leave a tip for the waiters, because their parents are waiters. Gang kids typically wake up in the afternoons and wouldn’t be set to eat dinner until close to midnight. Restaurants that closed at nine at night didn’t have gang kids pawing their lazy Susans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another rumor about the early closings was that there was a deal with the Little Italy restaurateurs, just north of Canal, so the Italian places wouldn’t have to compete with cheap Chinese food with the late-dining and after-theater crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe they were both true. The only people walking around the neighborhood now were people coming back from work or those going out now to the garment factories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But at least one restaurant was still open—OK Noodle on Division Street, where Lincoln Chin might be hanging out. The manager there had told me that Lincoln would stay late and not order very much at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked up to the restaurant and pretended to read the reviews taped to the window. I saw Lincoln, all right. He was sitting at a table with four other Asian guys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went to the corner and looked around. Thankfully, on the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_93",
      "title": "93"
    }
  }, [_vm._v("other side of the street there was a phone booth. Drafty as it probably was, it would be better than standing around in the cold. I went across and shut the door on the booth. The windows were all scratched up but I had a pretty good view of Lincoln and his buddies, at least until a guy walked up and stood in front of the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you making a call?” he asked in English. I looked at the man. He was the same guy I had met in Columbus Park the other day, the one who had moved out of Chinatown to get his kids away from the gangs. I hoped his eyes were bad enough so he wouldn’t recognize me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He cupped a hand to the glass. “Hey, you’re Officer Chow, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled and waved. “Yes, that’s me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s me. Byron from the park, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, officer, I hate to be rude, but are you done with this phone? I need to place a call and I had to walk all the way here from Bowery to find a pay phone that works.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were still talking through the glass because I didn’t want to give up the spot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m actually waiting for a call,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You expect it soon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Could be soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you mind if I waited here until you get the call?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See, the thing is, I have an informant who’s going to be calling and it has to be a private conversation. No offense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do apologize, Officer Chow! I’m interfering with police business now.” He moved away and I saw Lincoln and his friends were now standing outside the restaurant. “I’ll see you again, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swept the phone-booth door aside and said, “On the other hand, I need to respect my elders. Here you go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_94",
      "title": "94"
    }
  }, [_vm._v("“Are you sure?” he asked me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I kept my eyes on the back of Lincoln’s army surplus jacket. “Yeah, I’ll catch up with him and see where he goes,” I said absently. I watched across the street as I followed a parallel path.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Officer Chow!” the man called to me. “There’s no mouthpiece on this phone!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!” I said, not breaking my stride. Lincoln turned a corner onto Henry and I jogged across the street. He was a fast walker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I made it around the corner and saw him talking with someone on the sidewalk. I bent down and pretended to tie my shoes. As their conversation dragged out, I stood up and leaned against the low stone fence by some garbage cans as if I were waiting for someone. I looked up to watch the D train rattle by on the Manhattan Bridge overpass. It slowed to an unscheduled stop and I could almost hear the collective groan of the passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The conversation ended and the guy who had been talking to Lincoln passed me on the other side of the street. I recognized him as a former associate with some gang kids. Somehow he had managed to save himself. I think he ended up going to college.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned and saw Lincoln jog up the steps to a building near the end of the block. I walked toward it slowly until he went into the building’s front door. I continued at the same pace and walked by, noting that it was number 91. I cursed the fact that I had left my radio at home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I made a left when I went around the block and I wrote the street address in my notes. I also took off a glove and wrote it in permanent pen on the back of my hand. Just in case my body was found, I wanted to leave a clue. If only all our corpses were so considerate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went to Lincoln’s building. It wasn’t tough to find his apart"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_95",
      "title": "95"
    }
  }, [_vm._v("ment. There was only one Chin in the building, at 2R, and the nameplate was split with someone named Lee who didn’t bother to write an English translation for the Chinese character. That had to be his girlfriend’s name. I added the apartment number to the back of my hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rang the buzzer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello?” a man asked in English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the police. I’m looking for Lincoln Chin. I just want to ask you a few questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have a warrant?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want to search your place. I just want to talk. You can come down if you don’t want to let me in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s pretty goddamned late, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure, but we’re both up, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made a growling sound and then buzzed the building door open. I went up one flight and knocked on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two locks clicked and a chain rattled. The door opened and I was staring into the face of a woman who had full chipmunk cheeks, thick black hair, and dark eyes. Although she wasn’t pretty, she looked well fed and healthy. I pictured her on a Communist propaganda poster with her fist in the air, one arm holding a bushel of bitter melons with a speech bubble reading, “Let’s have a bountiful harvest to feed the never-ending revolution!” She was Lincoln’s girlfriend, all right, the woman he was yelling at back at the protest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello,” I said to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly Lincoln shouted from somewhere in the apartment, “Teresa! Don’t say anything to that goddamned cop!” He came up and shoved himself in front of the woman. “I remember you from back at the rally!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_96",
      "title": "96"
    }
  }, [_vm._v("“I’m Robert Chow,” I said. “Still playing with your megaphone?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smirked and moved to block my view of the apartment. “Well, what’d you come up here for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wanted to know a little bit more about the Union of the Three Armies, an organization that apparently only exists in your mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are a real group!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not registered as an organization, business, or charity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t need the recognition of the capitalist establishment. We only need to declare that we exist! Anyway, if it’s a question of being a legitimate group, then why did the NYPD cash our money order and give us a permit?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was a matter of poor oversight on our part.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I managed a little laugh and showed him my teeth. “Well, Lincoln, the reason why I wanted to see you was that I was wondering if you knew anything about a small cache of guns that were found in a building on Henry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His face crumpled a little. Was it from guilt or confusion? “I don’t know what you’re talking about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Union of the Three Armies must have guns, right? That was one of your little stashes of handguns in that apartment mailbox next door, wasn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No! We are unarmed but well informed. We seek change through education and demonstrations.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you let me in, we can sit down and talk. Like real Chinese people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln gave a slight nod and opened the door. “No tricks, now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about me, I’ve got slow hands,” I said, stepping in. “Is this a shoes-off kind of place?” I asked, looking around the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_97",
      "title": "97"
    }
  }, [_vm._v("living room. Mr. Revolution actually had a nice TV, a nice stereo system, and even a nice coffee table. Nary a hammer-and-sickle icon in sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, don’t worry about it,” he said. Teresa stood by, apparently awaiting instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you Teresa Lee?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Teresa,” said Lincoln, “why don’t you go in the bedroom while we talk?” She did what he said and shut the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I take your coat, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like it on. I won’t be long.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sat down on the far ends of the couch, which was nicer and bigger than mine. There was enough room for both of us to swing our legs up onto the cushions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lincoln,” I said, “you’ve been seen associating with known gang members on Henry Street. That’s where you work and that’s also where a cache of guns was found.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you say ‘associating’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. It’s polite for ‘engaging in criminal planning and activity with.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look here, cop. You know what my job is?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what it’s supposed to be. You’re apparently a big no-show at the after-school program offices.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m having a tough time adjusting. Do you know what it’s like working with someone who cramps your style just for the hell of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I actually do, Lincoln.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m there for every important meeting. Haven’t missed one yet. You ask any of the kids if Lincoln Chin is there for them and they’ll all say yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’ll they say if I ask them where the guns are?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled. “I doubt they’ll tell you. They won’t tell me, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_98",
      "title": "98"
    }
  }, [_vm._v("that’s for sure. There are some troubled kids, Robert, but I’m trying to engage them—even more so than the kids that don’t give anybody grief. Our programs are meant to keep kids out of trouble and to rope in the ones that have strayed too far.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve heard you’ve been trying to pull the kids into the red and indulge yourself in a Communist fantasy romp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A number of boys and girls have expressed interest in the Chinese Communist Party, but I’m trying to show them the true path. You know, with Mao dead and Deng Xiaoping back in power, China’s moving towards a market economy. The party itself is in danger of becoming as Communist as West Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you care what happens in China? You’re an American.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess you don’t get it, Robert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve seen what a failure capitalism’s been for America, and now China wants to follow in those same footsteps! They’re going to be Communist in name only. Just like that Together Chinese Kinship. More like Together Chinese Bullshit. They’re only about money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell you something else, too! That traitor of the people, Li Na, disgraced her father and now her nation. She was looking for asylum here but I will never stay silent on that issue!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would even kill her representative to stop her from coming over, wouldn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get it. Trying to get me to incriminate myself. Nice. It would be funny if it weren’t so obvious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shifted in my seat, turning to face him dead-on. “I’ve been wondering something, Lincoln. You don’t really understand spoken Chinese so well and I seriously doubt you can read characters, so how do you know what’s going on in China?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I read the newspapers for him.” We both turned to look at "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_99",
      "title": "99"
    }
  }, [_vm._v("Teresa, who was standing in the hallway, leaning against the far wall.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln stood up with a hurt yet angry look in his eyes but Teresa didn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told you you were asking for trouble,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go back and stay in the bedroom!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Teresa,” I said, “how was he asking for trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He had to go do his stupid protest!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln crossed his arms and didn’t say anything. Teresa also fell silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I brushed off imaginary dust from my lap and stood up. “You folks look like you want some privacy now. Lincoln, I’ll visit you again . . . at work sometime. Be there for a change.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("zzy asked to meet me in a nondescript diner on the West Side the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said you had something bad,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do. The bill from Lonnie’s livery-cab ride. It says two passengers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? No, there’s some mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No mistake. Two passengers from Midtown to Chinatown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Chinese characters for ‘one’ and ‘two’ are very similar. ‘One’ is one horizontal line—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And ‘two’ is two. Like this.” He held up a copy of the voucher. “We got the original from Heavenly Horse. There’s the ‘two’ and there’s Lonnie’s signature.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The driver probably added the second line later to get more money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For two lousy bucks?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s two hours of Chinatown waiter or sweatshop work. Two dollars for just adding a line. I wouldn’t be surprised if that happened all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_100",
      "title": "100"
    }
  }, [_vm._v("“This little second line also shows Lonnie could be a murderer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, it’s about race. You’ve singled her out because she’s Chinese.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s your final argument? Here’s mine: She was the last one to see Chen alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He could’ve been killed by anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That narrows it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s the representative of Li Na. She has a number of enemies in the Chinese community and, therefore, so did Mr. Chen. One of these fringe groups could have killed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“After Lonnie lured him down to Chinatown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bullshit!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My outburst cued a big and tired man to refill our coffees without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy stirred sugar into his cup. “We’re under a little pressure,” he said flatly. “Very light pressure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pressure from whom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He licked the spoon dry and balanced it on the saucer. “Republic of China. Taiwan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The KMT wants this murder solved?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy nodded and turned his coffee cup clockwise by fifteen minutes and pointed the handle out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the pressure of an index finger through the State Department. Not bad on the NYPD at all, but it is there. It’s strange that a country on the way out is trying to get us to solve the murder of a guy from a country the U.S. doesn’t officially recognize as existing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I poured some milk into my coffee and watched it billow and churn. In the face of overwhelming facts, the U.S. still recognized the KMT on Taiwan as being the legitimate ruler of the Chinese mainland. As such, the Republic of China was pushing for the investigation of the murder of one of its “citizens.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_101",
      "title": "101"
    }
  }, [_vm._v("“Have you heard anything from the People’s Republic?” I asked Izzy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not a peep. You?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you going to take the word of the boyfriend of your suspect?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you have?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t withhold evidence. You wouldn’t like to see me mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s get this straight. You’ll take into account anything I give you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can work on this case, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t show you this slip so I could get my jollies watching your face. It’s obvious to me my boys can’t move through Chinatown as smoothly as you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did something happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Heavenly Horse wanted them to pay for using their Xerox machine and there was a scuffle. My guys should have paid the lousy nickel. I think they didn’t want to give money to a little yellow bastard for something they thought they had a right to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, Christ.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No sense in them going now to apologize, right? It’s over now, any potential for a good cooperative relationship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pretty much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You might have an easier time moving through this neighborhood. Your manners are better informed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re giving me a green light to work on this case, Izzy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will work on this case. But not directly. Everything you get goes through me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If The Brow finds out, he’ll have a shit fit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_102",
      "title": "102"
    }
  }, [_vm._v("The Brow was the Fifth Precinct’s C.O. The guy Izzy had punched out back at the academy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “Don’t worry about him finding out, Izzy. I have a personal interest in keeping The Brow in the dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, what do you have?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand that the People’s Republic wants the murder to be solved to prove that it wasn’t one of their agents.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what the KMT wants, too. They swear it’s a Commie that did it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If he was assassinated by someone who knew what they were doing, then why wasn’t he shot? Why would someone get up close enough to bash his head in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe it was a caveman.” Izzy slurped some coffee. “You heard about the body?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw the body. I saw the hole in Mr. Chen’s head.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you think of the hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about the hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a finger missing. Left index finger. Mean anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was chopped off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“After death.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember hearing about that part.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kept it away from the press.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I find anything I’ll let you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded and stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Izzy, thanks a lot for letting me horn my way onto the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not let you? You’ve got the motivation for solving this murder, not racking up overtime.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hen the lawyers at Presswire found out that the voucher from Lonnie’s livery-cab ride showed that two people shared a ride to Chinatown, they recommended that she be given a leave of absence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_103",
      "title": "103"
    }
  }, [_vm._v("Her editors had protested and then they reached the compromise that Lonnie would be allowed to continue working but from outside the newsroom.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With such a substantial piece of circumstantial evidence uncovered, Lonnie was, by my guess, a security risk for the organization as a maybe murderer. It wasn’t nearly enough evidence to charge Lonnie with anything—the driver himself hadn’t even given a statement yet—but those skittish lawyers were always good at saving their own skins. I can’t remember the last time one had been shot in the line of duty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie swore that the voucher had only one line in the passengers blank for “one” when she signed it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I visited Lonnie at her temporary desk at the general press office of the United Nations. All the reporters there took turns to type out their stories on three Teletypes that would transmit their stories back to their newsrooms all around the country and the world. Lonnie was the only one submitting a story just two blocks away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The press office was loud and smoky, like the Off-Track Betting joint on Bowery, only nobody had even a glimmer of hope in his eyes. In fact, their eyes were either on the floor or on Lonnie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What a crappy place,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad you like it as much as I do,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie, I am very uncomfortable with the fact that you’re the only woman here.” I opened up a paper bag and gave her a tuna on a hard roll that she was craving. “They think you’re like this exotic sex doll.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t say that, Robert. Look at all the people here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t know what the hell we’re saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know. They could have studied Chinese in college.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but colleges don’t teach Cantonese, they teach Mandarin, the language of the learned.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_104",
      "title": "104"
    }
  }, [_vm._v("“You can’t be sure until you ask everybody. A good journalist never makes assumptions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that’s all a cop has. At first, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not a cop, Robert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded and unwrapped my pastrami on rye. I glanced around the room before picking up half of the sandwich. “Which one is the guy who asked you out to lunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter. Don’t make a big deal out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think I’m just going to let some asshole ask out my woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She frowned and signaled with her hand that she wanted a drink. I pulled the tab off a 7UP and handed it to her. “You didn’t get straws?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never bother. You can drink faster right from the can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie sighed and then drank. “This means I have to reapply my lipstick later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You better look good so that guy asks you out to lunch again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you stop, Robert? I have so many other things to worry about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m shut out of my own newsroom like I have leprosy, just because of that driver’s mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was also thinking that the guy did it on purpose so that he could charge your company extra for two passengers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All they need to do is ask the driver in and I’m sure he’ll clear it up. He’ll admit he faked it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did this guy look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He had an unshaved face, a big mole on the right cheek, had a hat on, and smelled like a cigar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds like every Chinese livery-cab driver, Lonnie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t they get his name from Heavenly Horse so they can question him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_105",
      "title": "105"
    }
  }, [_vm._v("“The cops already have the voucher. They probably won’t contact him until they have more evidence or if they don’t have any more. Wait, how do you know Manhattan South hasn’t talked to the driver yet?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The two detectives told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They called you or you called them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just went up to them this morning when I was leaving for work. They weren’t waiting in their car. They were standing on the sidewalk and their badges were out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a big bite of my sandwich. Too big. I took some effort to chew with my mouth closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The open-surveillance method by the detectives was an escalation in the pressure they were putting on Lonnie. They didn’t have enough to initiate a conversation with her but they were there if she wanted to volunteer new information. Such as a confession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I finally got my food down, I said, “Lonnie, don’t go up and talk to them. They can twist around what you say and use it against you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just want them to get the story straight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else did you tell them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told them to ask the driver! That’s all! They said they were sorry to hear that I had to work out of the office and then they smiled! What a couple of jerks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s it, that’s it,” I muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I leaned back and cracked my neck. I finished my sandwich and grabbed Lonnie’s hand. “I’m going to fix this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your left eye is all bloodshot!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_106",
      "title": "106"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went to bed late but I woke up at six in the morning without the alarm. I took a shower and dressed in ten minutes. I tried not to wake Paul on the way out but he’s too sharp. Must’ve been all that wild-animal alertness he’d gleaned from being in a gang. I had been in a gang, too, but being a punk is a young man’s game. I couldn’t beat him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The light from the stairwell came in when I opened the apartment door and I could see his one open eye watching me. I winked at him and stepped out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went to the three dispatch-car companies on Allen Street huddled next to each other for maximum customer confusion. They all looked like little lean-to shacks built with cinder blocks. I went to Heavenly Horse in the middle first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man behind a glass window had his back turned to me. Two idle drivers behind open newspapers sat on benches to my left and right. I went up to the reader with black herringbone slacks first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pardon me,” I said. “Have you got the time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a clock on the wall,” he said without lowering his paper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have really bad eyes. Could you look at your watch for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m reading a story right now and you’re breaking my flow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, I just need to know the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then wear a fucking watch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that I pulled down the top of the newspaper to get a look at his face. He had a beak like a turtle and looked ready to snap my fingers off. Instead, he folded up his paper and swatted my face. No mole, though.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get away from me, you weirdo!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man behind the window stood up. He was tall, pushing six feet, and probably weighed 190 pounds, in his late forties and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_107",
      "title": "107"
    }
  }, [_vm._v("nearly bald. “Officer Chow, right?” he said. I heard him through the wall vents near the ceiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well what do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked over at the other reader who had also put down his paper. I smiled. There was no mole but it was a mean face, eyes close together, small mouth, and a wrinkled forehead. He scowled at me and picked up his paper again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked familiar, but from where, I wasn’t sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went over to the window and asked, “What can you tell me about a driver with a mole on his face?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged and stared at the floor. “You want a driver with a mole? That’s no problem. Where do you want to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t need a ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man shuffled to the side, took a handful of nuts and shoved them in his mouth. “Then why the hell are you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know I’m a cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know I’m Lonnie’s boyfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who was her driver?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. I won’t know until I pay him,” he said as peanut pieces ricocheted off his side of the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Calm down, all right? I don’t mean to upset you. I’m trying to help Lonnie, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know Lonnie very well! I know her parents, too. They are good people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. Her dad was so good he couldn’t help beating Paul. “Anyway, if you could tell me one thing, anything, that would help Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is Lonnie’s boyfriend?” asked the turtle. “This one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” I said. The turtle shook his head slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_108",
      "title": "108"
    }
  }, [_vm._v("The man behind the window twisted his mouth up and rubbed his forehead. “I’m telling you this because it’s for Lonnie, not for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These drivers have no loyalty to me whatsoever. If someone pays them a higher rate, they’re gone. If I raise my rate, they come flying back like migrating pigeons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pigeons don’t migrate,” said the turtle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but you did. You’re lucky I took you back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pardon me, Uncle,” I asked the boss. “About Lonnie’s driver. The one with a mole. Have you seen that driver around anywhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“ ‘The one with a mole.’ That’s a good one. Almost all my drivers have a mole.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These two don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If they don’t already, they will soon. You know where it comes from? Too much smoking and too few girls. That’s the life of a driver!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The turtle coughed while Mean Face wrestled his paper into a pile of crooked folds. In five seconds he was exhaling smoke from a newly lighted cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said you don’t know who drove whom until you pay your drivers. How do you assign rides?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I fill out a voucher form and hand it to somebody here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I notice the vouchers have one original form and one carbon copy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When a driver picks up a voucher, do you keep the original?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t separate them. I give the whole thing to the driver.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t keep a record of what rides drivers are assigned to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t bother because a voucher is worthless until a customer "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_109",
      "title": "109"
    }
  }, [_vm._v("gets a ride. Actually, it’s worthless until a company pays for it. When the driver is done for the night, he fills in his name and then I separate the vouchers. I take the originals and he takes the carbon copies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When do you pay the drivers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I pay them after the voucher is paid. They come back with the carbon copy and if the check has cleared, then I pay the drivers. I usually get a check within a week and then it takes a few days for the check to clear, so a driver usually gets paid two weeks after the actual ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The turtle grunted. “Sometimes it’s three weeks or a month. Sometimes not at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” said the boss. “I can’t help it when companies pay late or dispute the tab. A lot of times, it’s the driver’s fault.” He pointed at the turtle and said, “Customers don’t expect to ride in a car that is filled with trash.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should pay the drivers the night they hand in the vouchers,” I said. “They shouldn’t have to bear the risk of the companies paying up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t tell me how this business works. If these guys were paid automatically, there would be no incentive to give the customer a decent ride. They would just drive recklessly to get as many vouchers as they could.” Again pointing to the turtle, he added, “They also wouldn’t bother to clean up the inside of the car between rides!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One time!” cried the turtle. “It only happened one time and this guy never shuts up about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I stopped talking about it, you might forget.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, what’s the big deal? I ended up not getting paid. Nothing happened to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The company did pay for the gas,” I pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_110",
      "title": "110"
    }
  }, [_vm._v("The turtle blinked. “"), _c('i', [_vm._v("We")]), _vm._v(" pay for the gas, Policeman Chow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should pay for it,” said the boss. “It’s expensive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is each driver assigned a car?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s first come, first served every day. We have a fleet of about twenty Continentals.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know someone won’t drive off with one of your cars?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to see them try. They wouldn’t get too far.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The cars would probably fall apart before you made it past Jersey,” said the turtle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The boss ignored him and said to me, “We’re owned by a very connected individual. It wouldn’t be any good crossing him. Believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t this very connected guy find the man with the mole on his face?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am sure the driver will be back with his carbon copy to collect his fee. It should be a few days from now. I’ll tell you what. When he shows up, I’ll call you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure he’s going to show up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’d be a fool not to. Nobody would work without getting paid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not making any money now,” muttered the turtle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s slow right now,” said the boss. “After the morning rush, business doesn’t pick up until night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You call that a morning rush?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t like your job very much, do you?” I asked the turtle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I don’t. It sucks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t you do something else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He can’t do anything else,” said the boss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why do you keep giving him work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The turtle put his newspaper down and crossed his arms. “Because I’m a very connected individual!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_111",
      "title": "111"
    }
  }, [_vm._v("“There are some particular customers who want him as a driver,” said the counterman. “Because they like to go to whorehouses and they need the local pimp to point them out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can say anything you want,” said the turtle as he leaned forward and rubbed his kneecaps. “I was here before you and I’ll be here long after you’re gone. The gods give long healthy lives to the just and sickly, phlegm-filled existences to the dissolute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You call me when that guy comes in,” I said to the boss. “Call me before you pay him.” Mean Face looked at me as I left. I didn’t like him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went to the two other dispatch-car offices to see if they knew anything about Lonnie’s driver but had no luck finding the mysterious mole-man. But I made sure to keep an eye on the street in case Mean Face popped out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie was right in saying that the businesses were hurting. They were doing their part in keeping air pollution down by not running their cars. Customers don’t need to be driven anywhere when they don’t have jobs, meetings, or flights to catch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The drivers used to look down on the waiters, table bussers and dishwashers. The guys in greasy clothes were laughing now. People always have to eat, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came out on the sidewalk and peered into Heavenly Horse’s window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The turtle was sitting there by himself, picking his nose with his knuckles. Mean Face was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" stood on the curb where Mr. Chen’s body had been found and looked at the dirty, twisted warning tape that wound around chain-link fence posts and two dented garbage cans. It was sad. A barren place in Sara D. Roosevelt Park that squirrels avoided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t as familiar with this park as I was with Columbus Park. I looked around carefully in all directions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_112",
      "title": "112"
    }
  }, [_vm._v("To the north, someone had raked piles of dead leaves but nobody had bothered to bag them up. Maybe the city had canned that particular person.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the south, there was a scary little brick building that hummed. I had no idea what was inside, but it was the right size for a witch who liked to eat children. The door had several padlocks on it. I walked around the building to see if there was anything more to it, but the other three sides were sturdy brick walls tagged heavily with spray paint.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the west, across Chrystie Street, was a short block with three storefront apartment buildings. The southern end of the block housed a Fukienese church that was painted white, which was usually a bad color because Chinese wear white for funerals. But in the context of Christianity being a foreign religion, it was acceptable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The middle of the block was a small dumpling wholesaler and the north end was occupied with a kitchen-supply store that had chained down samples of its shelving and standing sinks as if they might run away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crossed Chrystie to the north side of the block. I examined a metal three-shelf rack. A short, heavyset guy in a gray sweat-suit came out of the store.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, my friend,” he said, tipping me off that he didn’t know I was a cop. “I’ve got everything you need. You like those shelves?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re crooked and dented,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s because they’re defective. I keep the perfect ones inside. Come in and have a look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should have your best stuff outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then someone would rip it off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe, but I don’t understand why you bothered to lock up these ugly shelves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“People will steal anything and everything! I used to have a "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_113",
      "title": "113"
    }
  }, [_vm._v("broken cinder block to prop open the door and someone stole that. You don’t know how it is. I’ve been in this business almost twenty years. I know this guy who put his scummy fryer outside to air out. It was all covered in clumps of brown and black stuff, looking like someone had diarrhea in it. Somebody stole that, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unbelievable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is. Say, can I set you up with a new sink? I have to move out last year’s model, so I’ve got my best price for you. You look like a nice and smart guy. I won’t waste your time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have a restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can install it in your home. It’s great. I have one. I live upstairs. You want to see it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You live upstairs?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, second floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you here when a body was found across the street?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was I what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you here the night before the body was found?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was here,” he said, suddenly cautious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you remember seeing or hearing anything unusual?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He crossed his arms. “Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I should have gotten around to this earlier. My name is Robert Chow. I’m with the Fifth Precinct. NYPD.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure? You seem to be a pretty observant guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. When I sleep I’m a rock. I snore louder than the traffic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I handed him my card. “In case you remember anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He quickly countered with his own card. “I know you’re going to need new shelves someday.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('b', [_vm._v("I")])]), _vm._v(" stood at the window to the dumpling wholesaler. Most of the dumplings served in Chinatown restaurants were bought frozen and in bulk from a place like this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_114",
      "title": "114"
    }
  }, [_vm._v("Making dumplings isn’t difficult but it is labor-intensive. It also takes up a lot of space to roll out the dough and store the finished dumplings.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teams of two people were crammed in each of the two back corners, scooping meat filling from plastic tubs and swaddling them in dough. Finished dumplings were set off to the side on a bamboo tray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The counter was manned by a woman in her fifties wearing a hairnet. Her arms were caked in flour past the elbows. She stood in front of two vertical freezers. As soon as she saw me her eyes narrowed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi there,” I said. “How are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Robert Chow with the Fifth Precinct. I was wondering if you or anybody who works here remembers seeing—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t remember anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand that you’re open at five in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, we are not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what it says on your sign.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s dark when we come in. We don’t see anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t bother to leave my card with the flour lady. Nothing good could have come from it. I wondered if I had offended her at some point in the past. Maybe I had ticketed her van. Maybe she had a son who was one of those stupid gang kids and I had taken his picture. Maybe, maybe, maybe. Some people simply don’t like cops and that’s how it is.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he Fukienese church had so many coats of white paint over the brick walls it looked like the side of a Carvel ice-cream cake. I stepped through a metal gate to get to the main entrance. A glass-enclosed signboard noted that services were held in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_115",
      "title": "115"
    }
  }, [_vm._v("Fukienese except for one sermon each in Spanish and English on Sunday afternoons.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seemed quiet from my side of the wooden door, so I opened it and eased my way in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was surprised to find about twenty men crowded in the lobby, wearing cheap sports jackets, and smoking as if they were hanging out at an Off-Track Betting facility.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked around to the side and looked up a stairwell. I thought I spotted someone I knew and went upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello,” I said in English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, Robert,” said Mr. Song. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was in the neighborhood, examining recent murder scenes, and figured it was time to get it right with God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean one murder in particular, right out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Together Chinese Kinship is conducting English-language classes in partnership with the church. We’re just taking a break right now. Let’s go into an empty classroom where we can talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He led me up another flight and found a small room that had windows only slightly above the floor level. There was still enough sun coming in that we didn’t need to turn the light on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My contacts with the People’s Republic say they’re glad the news has died down a bit about Mr. Chen, but they want to know what progress has been made. If it turns out that a KMT-backed person or group was behind this, then I have to warn you that there could be a retaliatory hit. Not anything sanctioned from the mainland, of course, but there are left-wing agents who would take it upon themselves to mete out justice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The pro-KMT paper keeps calling for a bigger investigation,” I said. “How do you figure that they’re behind the murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Typical dirty Nationalist trick. They know who killed Mr. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_116",
      "title": "116"
    }
  }, [_vm._v("Chen. They might have even killed the guy to cover their tracks. This way they can step up the anti-Communist rhetoric in their media and justify their own brutal tactics in Taiwan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The last time I checked, the Taiwanese economy was booming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For the rich.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know a Communist didn’t kill Mr. Chen? Wouldn’t a hard-core Maoist want to strangle him for betraying the motherland?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t care about people leaving China. If they want to go, they can go. Together Chinese Kinship members all left China, yet we have a dialog with Beijing. They wouldn’t bother to talk to us at all if they thought we were traitors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course they want to be in touch with you. How else could they check the KMT’s influence in New York?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song only gave me a tight smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to ask you something,” I said. “Just on a person-to-person level.” I felt like I could ask for a degree of privacy from him because of our common bond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Promise you won’t tell anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Swear to God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I swear to God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you people didn’t believe in God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We believe in God to the capacity that the idea embodies the brotherhood of man and the common goal of all workers and the fact that it brings a degree of comfort to the masses. Now, Robert, what is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would someone chop off a man’s left index finger?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mao didn’t advocate such a thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_117",
      "title": "117"
    }
  }, [_vm._v("“No, never.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do Communists do to enemies of the state?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We wouldn’t cut off fingers. We would send reactionaries to the gallows or to labor camps. We would want to punish the entire body, not just a part. We’re Chinese, not Japanese.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chen’s finger was cut off. After he died.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The press doesn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They won’t find out from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think it’s something one of these fringe groups would do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not sure. Do you want me to ask people from the mainland?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no. I want as few people as possible to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right, Robert.” With a meaningful look in his eyes, Mr. Song added, “We also hold open meetings in this church, in the basement. If you’re ever interested.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll keep it in mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met the midget the next day for lunch. I brought soup noodles from a cart. The extra one was for the kid who worked there, Drew. I unpacked the plastic containers on the counter, away from the register.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Drew pulled up a chair but the midget reached out and touched his arm. “Hey, how about you go eat yours in the back? We have some man talk to do here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I should have realized,” said Drew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop with the sorry! You couldn’t have known!” said the midget with exaggerated weariness. The kid smiled. “Now, go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Drew had reached the storage room in the back, the midget said, “How’s Lonnie holding up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine on the outside, but she has to be worried.” I leaned in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_118",
      "title": "118"
    }
  }, [_vm._v("and said in a low voice, “I’m actually going to be helping out on the case. Just not officially.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget nodded and slid out bamboo chopsticks from their paper sheath. He rubbed them together to get rid of the splinters. “Have you thought about hiring a private lawyer for her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not going to be cheap,” I said. I prepared my chopsticks also and then used them to haul up a tangle of glistening egg noodles into my mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s cheap, anyway? How much would you pay to have that open surveillance stopped and get Lonnie’s life back to normal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wiped my mouth with the knuckle side of my left thumb and trawled through the soup for a chunk of chicken. “How can I put a price on that?” I asked, sighing. “This stupid system forces us to pay to live our little lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well spoken, comrade,” said the midget. “When we’re done eating, let’s give three bows to the Chairman’s portrait to thank him for helming the nation so well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pointed the chopsticks at the midget, sending soup droplets flying. “I fought Communism, pal. I’ve killed Communists.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess that means you won?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shook my head. “Don’t joke around about this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I kid because I care. Anyway, I can get a lawyer to look at this and maybe take on the entire thing free of charge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A real lawyer? I don’t want some stuttering kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, a real lawyer—a "), _c('i', [_vm._v("criminal")]), _vm._v(" lawyer. He owes me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you meet this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the usual way. He saw me in Columbus Park and he wanted to learn how to play Chinese chess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What favor did you do him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember. But I do know that he’s a principled kind "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_119",
      "title": "119"
    }
  }, [_vm._v("of guy and helping a beautiful and vulnerable reporter is right up his alley.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The kid called out from the back. “I’m done eating now! Should I just stay here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, hang out there a few more minutes!” yelled the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m gonna go. I feel bad about making him sit back there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t feel bad for him, he’s getting paid for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget threw his head back sharply and cracked his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("onnie came over to my apartment about three hours later than scheduled. The Teletype was acting up and it took several tries to get her story through. Then she had to wait for the late editor to come back from a meal break to edit her story and ask questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those detectives are really wearing me down,” she said, closing her eyes “They don’t even really do anything. They’re right behind me whenever I turn around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached out my right hand and rubbed both her temples with my thumb and middle finger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I might know someone who can help,” I said. “The midget told me about this lawyer he knows who will work for free.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If we don’t pay him anything, how hard is he going to work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lawyers do this all the time, Lonnie. They work to build up their reputation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, I don’t want to hire a lawyer. Even for free.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I hire a lawyer, the people will think I’m guilty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t do the stupid, superstitious Chinese thing, Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t call me ‘stupid’!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_120",
      "title": "120"
    }
  }, [_vm._v("“Do you think you’ll get cancer if you see a doctor or that you’ll die if you walk into a funeral home?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I don’t. It’s my parents, really, not me. If I hired a lawyer do you know what people will say about them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know what could happen to you if you don’t have adequate legal representation?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She counted off points on her fingers. “I am innocent. I have not been charged with anything. I have nothing to hide. The police will find the killer. My parents’ reputation must be protected.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s so great about your parents that you worry about their reputations?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t always get along with my dad and my stepmom. But I do believe that children need to respect their elders to a certain degree.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have to respect them, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, how serious are you about us?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went over to see Lonnie at her parents’ place on the south side of Bayard Street. The ground-floor storefront sold souvenirs including a fan that folded out to read "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I LOVE CHINATOWN")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had brought over those traditional Chinese treats: a bag of oranges, a box of Almond Roca, and a tin of Danish butter cookies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the first time I was meeting her father and stepmother, who was Paul’s mother, and the circumstances were far from ideal. But it would have been awkward at any point. One reason why Paul lived with me was the poisonous cycle of his dad beating him and Paul hanging out with wannabe gang kids to get away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_121",
      "title": "121"
    }
  }, [_vm._v("I was a little taken aback to find that Lonnie and Paul’s dad was a fairly small guy, barely five feet tall. In my imagination, he was a hulking linebacker brandishing a belt. In reality he was a thin man in his late-fifties and his hair had thinned out to black streaks smeared over the top of his head like skid marks. The stepmother was in her early forties and wore too much makeup. It was her perfume that you could smell in the hallway. Lonnie hovered in the background as the hallway was too narrow for her to squeeze through.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you, Mr. Chow?” Lonnie’s dad asked as I took off my shoes. “We finally meet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shook his hand and it wasn’t that strong. I realized then that Paul had taken all those punches and belt whips without fighting back. He could have knocked his old man flat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I brought these,” I said, transferring my bags from my left hand to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You shouldn’t have!” he said, even before he saw what I had brought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have too much food, already,” called Lonnie’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I only brought over a few snacks,” I said. “It was the least I could do.” All of us were wearing socks on our feet, and we made dull thumping sounds on the hardwood floor while walking to the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I got close enough to Lonnie, I gave her a little half hug and she rubbed my arm. It’s a Chinese thing, this restraint from showing affection in front of others. I personally don’t really go for it, but I’m always aware of what other people would think. Besides, kissing Lonnie in front of her parents would only convince them that we were sleeping together, and there was no need for them to know that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whenever she stayed over with me, she told her parents that she was studying with a female friend. She had to. Lonnie was "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_122",
      "title": "122"
    }
  }, [_vm._v("already a grown woman, but older Chinese people think the “Americanized” younger generations are degenerates who have orgies, shoot up heroin, and, worst of all, don’t say “thank you” fast enough to relatives.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now if we were at my place, Lonnie and I would have been practicing our hand-balancing act about now. We wouldn’t have gotten around to eating until much, much later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie’s stepmother came over and grabbed my shoulder, sticking me with her fingernails. She gave a knowing little smile and said, “I’m so glad my daughter has such a strong and handsome friend!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad, too,” I said. We all sat down at the table. Lonnie and her stepmom were on either side of me as I faced off with her dad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The square table was crammed with a number of dishes, including pork, sautéed spinach, a pile of sticky noodle ovals with bean sprouts, and a crispy fish. Lonnie’s father picked up his rice bowl and started piling morsels into it with his chopsticks. Whenever he had gathered five items, he would bring the bowl close to his lips and noisily shovel food into his mouth. He made a sucking sound like an old Hoover. My dad had done the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie always works too hard,” said her stepmom above the din. “I worry about all the hours she puts in. I think it is affecting her looks!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chinese people have to work hard in America,” I said. “I have to do twice as much in order to get equal treatment. Look how ugly I’m turning!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be so funny,” the stepmom said. “Of course you are good-looking. That’s why you represented the police department in so many pictures. Lonnie used to show us in the newspapers!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled. Those were the days when I was little more than a "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_123",
      "title": "123"
    }
  }, [_vm._v("cardboard cutout for the NYPD at various Chinatown functions. I was used by the cops and by the community groups to give each other face. If I had a dollar for every restaurant opening, Boy Scouts of America dinner, and birthday celebration of supposedly important community dignitaries that I had to sit through, Internal Affairs would be on my ass so hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am not attractive,” I told the stepmom. “I was only in the newspapers because I didn’t have enough work to do. Lonnie is the one who is beautiful.” I had to force myself to smile before adding, “And so are you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She put her hand to her mouth and giggled. I looked at Lonnie. Her face remained blank but she rubbed her foot against my leg in a gesture that meant “You’re scoring points” and “I wish I could go home with you tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her dad, the steam-shovel operator, continued working away without interruption. “Why did you beat Paul?” I wanted to ask him. “Don’t you know your son is a great kid and a genius?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This food is incredible,” I said. “What amazing restaurant did you get this all from?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re joking!” said Lonnie’s stepmom. “You know I cooked with some help from Lonnie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I only did a little bit,” spat Lonnie. “But Mom handled the fish all by herself.” I’m sure that Lonnie did at least half of the dinner. I’m also sure that she told her stepmom that I was allergic to seafood, yet it didn’t register that she shouldn’t prepare a fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please try the fish,” said the stepmom, tapping my arm. “You might not think it’s that good, but it is the only specialty I know how to cook! The recipe has been in my family since before the Manchus came down upon us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you mean the Ming Dynasty, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, yes! You know your history. Young people today, they don’t know where they come from. Not only here, but in Hong "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_124",
      "title": "124"
    }
  }, [_vm._v("Kong, too. They don’t want to know their own culture and their language. They way they all dress is a disgrace to the Chinese people!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie’s dad grunted, startling all of us. “Yes,” he said. “A big shame.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Knowing her eyes were on me the entire time, I reached out for some more pork while telling the stepmom, “I am so sorry. I can’t eat your fish because I’m allergic to seafood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh my gosh, I didn’t know!” she said, trying to magnify the horror quotient. “I had no idea!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie nudged me with her toe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what you need to do,” said the stepmom. “You have to eat a lot of fish and then you will be fine.” There we go again. The Chinese solution to everything was bringing everything back into some alleged balance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allergic to seafood? You’re not eating enough of it!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Can’t swim? Spend more time in the water!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Is your son running around with wannabe gangsters because he hates you for beating him? You’re not beating him enough!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry that I can’t eat your fish,” I said again. “I’m sure that it’s the best and most expensive plate on the table. I really am truly very sorry.” One can never apologize enough with Chinese people. Saying it just once meant you weren’t sincere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, she looked hurt. Lonnie took it as an opportunity to speak up. “Robert got a promotion recently.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not really a promotion,” I said. “I was given more responsibilities.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They pay you more money?” asked the stepmom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a little bit more,” I said. “Not enough to get nice things for Lonnie, I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie doesn’t need nice things,” said the stepmom. “She’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_125",
      "title": "125"
    }
  }, [_vm._v("not the kind of girl who has expensive tastes. She’s a modern girl who wants to do the same work as a man. That’s something she’s learned from being in America.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a good thing,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, the problem is, if women want to be the same as men, then it means they don’t want to be women anymore. They don’t even want to have children. Now, who is going to fall in love with them? Who is going to marry them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A spitting sound from Lonnie’s dad interrupted the discussion and yet articulated my thoughts perfectly. With his chopsticks he scraped fish bones from his tongue and into his bowl and then turned it 180 degrees so he wouldn’t sweep the bones back into his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I started tuning out of the evening. I remember Lonnie pushing an orange onto me and me peeling off its skin. Between the chatty stepmom and noisy dad, Lonnie didn’t say very much and I felt annoyed at her for being so quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet this was the fate of Chinese kids. At family gatherings they were expected to be quiet and do little more than answer questions as briefly as possible without expressing opinions. What was the payoff? Once a year, you get this red envelope of money to buy your silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie wasn’t a kid but she was still a child. You remained a child until you were married. That’s when the red envelopes stop and you can say whatever the hell you want at dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("fter putting my shoes back on and endlessly promising that, yes, I would come back to “play” again, as Chinese people like to phrase nonbusiness meetings, I went down the stairs to the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the light rain, the Manhattan South guys were inside their "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_126",
      "title": "126"
    }
  }, [_vm._v("plain sedan. It was a lousy disguise. Having the only tinted windows on the block made the car stand out. Someone in the back-seat rolled down the window and spat out of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That pissed me off. If I was going to allow these guys to lean on my girlfriend, I was going to make sure they did so in a respectful way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came up from behind the car and knocked on the right rear window with my knuckles. Nothing happened, so I slammed my hand on the roof. The front passenger door opened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Chow, knock it off!” said BB Gun, a Manhattan South guy. He had made a name for himself in buy-and-bust drug stings. He was good at making people talk after.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Keep your spit in your mouth when you come to Chinatown,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’re you talking about? Chinese people spit all the time!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not just spitting. We have a cultural belief that we have to get rid of bad fluids in our systems.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pizza Man had to get rid of bad fluids, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rear window rolled down. Next to Pete I saw Bad Boy, who held a dull metal flask with both hands in his lap as if it were a prayer book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you two doing here?” I asked Pete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re acting like the local guides to Manhattan South. They need us to show them the short cuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about I show you a quick way on to Internal Affairs? Drinking on the job!” The universally reviled rat patrol only grew by adding members of service who had disgraced themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not on the job, but if you want to make a stink out of it, these guys could take it out on your dearly beloved.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("BB Gun said, “I might have to cuff her father, too. I think I saw him make a threatening move toward me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_127",
      "title": "127"
    }
  }, [_vm._v("I stood straight up and crossed my arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey listen, Chow,” said Bad Boy. “Don’t take it too hard. You don’t have a gold shield yet, but by the time you do, you’ll know how it is. All we have here is a bad situation. These guys know Lonnie is innocent. They’re just doing their job. You don’t have to give them shit over it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Their job is finding the murderer!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you know by now how good it looks in the report that they’ve been staking out the only apparent suspect? C’mon, now. Something else is bound to turn up and then they won’t have to do this anymore. They’re not going to be here forever. Say, how about a few nips of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t drink anymore. I’m sober now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goddamn, I didn’t know. I thought you just had it under control.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at Pete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry I had to spit,” he said. “I had to get rid of the gum.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, hey, he’s all right. Everyone’s all right,” said BB Gun. He patted my elbow and shut his door. I walked off and heard the rear window shriek as Pete wound it back up.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went to see Izzy again. He was so preoccupied he wouldn’t even sit back down after letting me into his office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you’re getting fed up with how long this is taking,” he said. “You can’t fight how this works by coming over here.” Izzy picked up a folder from his desk and thumbed through it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I happened to come across your detectives last night,” I said. “They were associating with two members of the Fifth Precinct squad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you trying to interfere with the official investigation, Chow?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_128",
      "title": "128"
    }
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These boundaries were drawn up before we were born and you’re going to respect it. We don’t go on your turf and you stay out of Manhattan South cases. You don’t contact the guys in the field. Ever. You want to help, you come to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now what were my guys doing with the Fifth Precinct guys?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were drinking in the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He dropped the folder on his desk and sank into his seat. “All of ’em were drinking?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m only sure about our guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you meet Plutarch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which one was he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s got bags under his eyes and a long face. He’s the driver.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t meet him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good. You make doubly sure to stay away from him. He’s a sadistic son of a bitch. His specialty is breaking into the cars of suspects and spraying Mace into the ventilation system. When the car starts up, it’s like a tear-gas raid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We both had a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy wiped his forehead. “He’s not going to pull any dirty tricks on Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Apparently they all know she’s innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not her they’re watching, per se. They expect the real guy to swing by and observe. In theory, the actual murderer is a little miffed that someone else is taking the credit—and a woman at that. I know the Chinese culture looks down on women.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It looks down on cops, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who doesn’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy looked over his hands and talked to his knuckles. “Remember, don’t let The Brow find out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s no way that could possibly happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_129",
      "title": "129"
    }
  }, [_vm._v("“You’d be surprised. These hard-boiled types gossip like girls at a sleepover when they get together.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Izzy, are there any details left that I don’t know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else is there? Last seen walking out with Lonnie. The car voucher. Killed by blunt object close to midnight. Missing finger.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did Mr. Chen have any visitors at The Plaza?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one ever visited him, apart from Lonnie. The last time he was seen alive he was walking out of the lobby with her. Mr. Chen never made any calls from his hotel room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he have any incoming calls?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“None the entire stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were there fingerprints in the hotel room?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about Mr. Chen’s effects?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Books and clothes and a jar of smelly medicine. We had a native Chinese speaker go through the entire thing and there was nothing for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I stopped by the livery-cab office. They don’t know who the driver is yet. When we find him the first thing he’ll do is probably admit he added the extra line for the money, trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The evidence isn’t really coming together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is Lonnie also looking like a better suspect to you, now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smirked. “I’ll find something out. I don’t know how, but I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure you will, too. Oh, and by the way. Everything you find belongs to us. I can’t guarantee that you get credit for any of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not just doing this for credit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That girl better marry you and carry your sons. You like sons, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_130",
      "title": "130"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("n top of figuring out who had stuffed those guns into the apartment mailbox on Henry Street, I was supposed to be making a case on some gang kids who were extorting merchants. They would show up at a store with one of those little trees in a pot as a present and then ask the owner to give them some “lucky money” or “tea money” in return.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This scam works best on newly opened businesses. A guy with a new restaurant doesn’t want any trouble right off the bat, so he’ll pay up, hoping they won’t come back. But they always do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The average Chinese merchant is a frightened and superstitious creature. He thinks that the merchant association, family association, and region association that he belongs to can and will handle all the problems he has. After all, he did get loan references through them to start up his business. But if he complains about the fact that he has to make these monthly payments, he’ll be met with amusement and veiled threats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you know that’s the price of doing business? You pay even less than the guy before you! Hey, if you think this is bad, you know how much you’d have to pay in Hong Kong? If you tell to the police, the white people are going to send an inspector from the Department of Buildings and condemn your property! You want that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I talked it over with English and convinced him that I would have to use a substantial amount of time trying to dig up evidence to clear Lonnie or at least come up with another suspect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was cool about it because he knew how hopeless my caseload was. I also think he felt bad that Pete piled this dead-end work on me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told him I would always be on the prowl for merchants who would step forward and tell their story, but of course, I would probably have to threaten them with extortion to get them to testify that they were victims of extortion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_131",
      "title": "131"
    }
  }, [_vm._v("I told him I wasn’t even going to put in for overtime until I had Lonnie off the hook. For the first time ever I saw the look of surprise on his face. A cop not taking overtime was like skipping seconds at a buffet.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was assumed that Vandyne would be with me on a lot of the work because he was my old partner. They often say that partners couldn’t be closer if they were married. You spend more time with each other, that’s for sure, and whether you love or hate the other person, you understand each other and that understanding goes beyond emotions that are subject to change. At the funerals the ex-partner cries as hard as the widow because they both lost a part of themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, this investigation wasn’t going to end with a funeral. Not for the good guys, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" spread out a subway-route map on top of a bus-route map already on my desk. I traced my finger from The Plaza Hotel at the southeast corner of Central Park all the way down to Sara Roosevelt Park. I couldn’t make sense of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even a seasoned New Yorker would have been foolhardy to take public transportation that late at night. A newcomer to the city wouldn’t have been able to negotiate the late-night track work that rerouted the subways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor would he have been able to manage the multiple bus transfers to get down to Chinatown. If that had been his choice of transportation, he would still be waiting for a transfer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe Mr. Chen never did go to Chinatown. Maybe he was killed close to his hotel. He had left the lobby without a coat and didn’t return. Did assassins get him as he left? Or maybe he did himself in on his own by trying the F. Scott Fitzgerald thing and jumped in the fountain but he cracked his head?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, that was a terrible idea. I scratched my face and stretched "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_132",
      "title": "132"
    }
  }, [_vm._v("out my legs. It was a little after 0200. I was in the squad room on my own time. Bad Boy was at his desk talking in a low voice to someone on the phone. He was a seasoned detective with a lot of good work under his belt. If he were me, what would he be looking for in this case?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked back to the maps. It probably wasn’t too hard to have gotten Mr. Chen at his hotel. It would have had to be planned, though. But then why was his corpse lugged all the way to Chinatown and then dumped? Maybe the killer was trying to send some sort of message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What exactly was the message, though? Surely, it was nothing personal against Mr. Chen. It was meant as a warning to Li Na. Yet the meaning wasn’t entirely clear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was this move against Li Na meant to target her for being her mother’s daughter and thereby an accomplice to the Gang of Four? Or maybe it was an anti-Mao job. The killer or killers may have even been trying to send a shocking and confusing message to sow chaos on the mainland. In that case, were they KMT agents or Communist agents?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I yawned and crossed my arms. I looked over at Bad Boy again. He was still talking with no expression on his face, eyes dead. I couldn’t hear a word of what he was saying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was so unfair that he could simply do his job in Chinatown and not take personally all the political crap. But as an Italian American, he had other stuff to deal with. Both of those "), _c('i', [_vm._v("Godfather")]), _vm._v(" movies had enforced the image of lawless Italians upon the consciousness of the country. I enjoyed them and I know Lonnie did, too. But if someone non-Chinese came up and told me how much they loved Charlie Chan and Fu Manchu films, I’d probably be pretty annoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad Boy hated the two movies. He complained when a Mid"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_133",
      "title": "133"
    }
  }, [_vm._v("town revival theater showed them as a double feature. That was actually the run that Lonnie and I had caught. Bad Boy had given money to an Italian American organization to fight the stereotypes in the films, and when a cop gives money to something, it’s a cause that he would want to die for.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pizza Man, who was also Italian American, actually liked the movies and he told Bad Boy that they proved that criminals get theirs in the end. Besides, there was no sense in getting worked up about it because there could never be a "), _c('i', [_vm._v("Godfather: Part ")]), _c('i', [_vm._v("III")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For me, the "), _c('i', [_vm._v("Godfather")]), _vm._v(" movies were about family. Maybe Chinese people read family themes into everything they do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Did Mr. Chen have family in Chinatown?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No. He had a wife and kids in Beijing. He apparently was able to rise in the political machine precisely because he didn’t have any family abroad, least of all in Taiwan or America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned back to the subway-route map and smoothed out the folds. I patted the area where The Plaza was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I closed my eyes and tried to picture him leaving the hotel with Lonnie and what he did after her car left. I had seen psychics do this on "), _c('i', [_vm._v("In Search Of")]), _vm._v(" . . . to much success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Could he have gone to a diner? No. If he was hungry, he could have ordered room service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe he wanted to see what Central Park was like at night. Highly unlikely. He wouldn’t have gone into a park that had an international reputation for being prime mugging grounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Porn. Mr. Chen had heard of capitalist New York’s decadent reputation and he wanted to see live strippers. Or maybe even a pross house in Chinatown. This idea was also shot down by the food argument. He could have had room service. I don’t care that it was a really nice hotel. That only means the freight elevator "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_134",
      "title": "134"
    }
  }, [_vm._v("operator brings up the girls from the loading dock so they don’t have to go through the lobby.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Chen knew that he was risking a lot politically by strolling out of the hotel, so it must have been something he had wanted to do pretty badly, perhaps desperately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I thought about it, there’s nowhere else in the city a Chinese guy would want to go to apart from Chinatown, and Mr. Chen was no exception.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why and how, though?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe he had hailed a cab. But if he did he couldn’t have explained in detail where he wanted to go. He would have said, “Chinatown,” and been dropped off somewhere on Canal. Mr. Chen didn’t know Chinatown, though, so it doesn’t make sense that he would come all the way down to wander around in the streets. Maybe that is what happened, and a mugger got him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Chen couldn’t have come here to admire the architecture and the metal pagoda hats on the public telephones, though. Something in particular made him come down, a person or a group of people. If his trip was planned out, Mr. Chen could have given a cabbie a piece of paper with an address on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that didn’t make sense, either. Most of Chinatown was already closed. If he and his unknown party had gone to a twenty-four-hour restaurant, Mr. Chen’s appearance would have caused a ruckus. Also, if an association or person had really wanted to see him, they would have simply come up to The Plaza and Mr. Chen could have cleared them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had to be a party who didn’t want to see Mr. Chen! That’s why he had to go to Chinatown to find him or her or them!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ll bet that someone at the meeting with the Department of the State may have slipped Mr. Chen an address or something. Possibly a second rendezvous for asylum talks. But not for Li Na—for him!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_135",
      "title": "135"
    }
  }, [_vm._v("I looked back and forth at the two maps. I wasn’t getting much else from them except a pair of tired eyes. I folded each of them up the wrong way and chucked them into the top drawer of my desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sighed. I knew what I had to do. I had to go to Jade Palace and talk to Willie Gee. I’m sure that he had kept a close watch on Mr. Chen during the event. I should get Vandyne on this thing with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why the fuck did you leave, Mr. Chen? Why couldn’t you have just stayed in your goddamn hotel room? It would have been better for all of us.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("J")]), _vm._v("ade Palace had never been busier. A certain grim fascination had taken ahold of Chinese living in the tri-state area and everyone and their newly born son wanted to eat where Mr. Chen had dined not so long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Willie Gee had smartly brought back in the KMT flags to adorn the entrance and the main dining rooms. He knew those loyal to the Nationalists would want to have a celebratory feast where a representative of the mainland had had one of his last meals. Willie didn’t worry about alienating Communist sympathizers. Commies never bought the expensive dishes or best liquor, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, I couldn’t imagine that Mr. Chen would be murdered,” said Willie. Vandyne and I were standing in his personal office, which had only one chair and it was for him. “I feel terrible for his family, friends, and supporters. But it was the best possible outcome I could have hoped for, in terms of my business. I had worried that there would be some short-term negative feelings about Jade Palace hosting the meeting. Now that’s not a problem at all!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Gee,” said Vandyne, “you seem almost happy that Mr. Chen was murdered.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_136",
      "title": "136"
    }
  }, [_vm._v("Willie tilted his head and held up a finger to correct Vandyne. “Not happy about the actual murder, but happy about the benefits from it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re a sick man, Willie,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m actually very healthy, physically and mentally,” he said. “I just read an article in "), _c('i', [_vm._v("The Harvard Business Review")]), _vm._v(" about compartmentalizing. I’m able to separate my personal life from my work life. My emotions from my reasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know from your own experience, Mr. Vandyne, that many Chinese are prejudiced against people of your color. But when I look at you, I don’t think of muggers, murderers, and rapists! I think, ‘Hey, here’s a hungry customer and I can sell him some food.’ In fact, in the last week alone, I had three black people eating here—and they loved it!” He crossed his arms and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Willie,” I said, “nobody here doubts your strong commitment to racial harmony. I just want to know if you noticed anything unusual during the meeting or if there were some suspicious people walking around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged. “I’ve already told the other detectives everything I knew. The federal government was handling security, so they cleared everyone in attendance. Even all our staff that day was carefully screened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did anything strange happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The whole thing was strange! There were armed men at every entrance and every window. You saw that protest outside, too? It made me feel like I was inside a castle while some barbarians were trying to break in!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne asked, “Where were you during the meeting?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was on my feet the entire time, walking around, making sure everything was perfect from the food to the service. I told all the FBI men that they could come back anytime and bring "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_137",
      "title": "137"
    }
  }, [_vm._v("their family and friends and I would give them the business rate. There were even some black ones, too!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On behalf of all Chinese people, I apologize for his behavior,” I told Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to be sorry,” said Vandyne. “Willie is his own man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did I say something rude?” Willie asked, his eyes wide-open and questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing more than usual,” I said. “Let’s get back to that day, Willie. Did you receive any threatening phone calls?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the days leading up to the event, yes I did. But I unplugged the phone the day before. It got pretty bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t tell the police about it,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know why I didn’t? There wasn’t anything you could or would do. Were you going to trace phone calls because people call my staff and yell at them for being Commies or fascists? What would you charge them with, even if you did catch them? It was better to simply take the phone off the hook. It made the restaurant seem busier, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any calls since?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, the only calls now are for reservations. This is the hot restaurant right now. It will probably remain so as long as the murder and the subsequent trial stay in the news. You are going to find the guy, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll find him,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand your girlfriend, Lonnie, was the last one to have seen Mr. Chen alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Except for the murderer, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. You know, you should really be asking her questions instead of me. I’m sure she must know quite a bit.” Willie rose. “If you’ll excuse me, I need to get back downstairs. People tend to slip up when they’re not being watched.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_138",
      "title": "138"
    }
  }, [_vm._v("He came around his giant rosewood desk to our side and opened the private elevator with a key. We all stepped in. As the doors were closing, Willie asked, “Have you all eaten?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to offer both of you lunch at the business rate,” said Willie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’d take it too personally to eat here for business,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door opened, and Vandyne and I left Willie, who looked like he was trying to figure out if he should be offended or not.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" had heard about David Ong and saw him in the Chinese newspapers before meeting him. I understood that this rookie was in a way my replacement to handle community celebrations and dinners. He was the new token NYPD face for Chinatown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a part of my life I wasn’t too proud of when my life as a whole was nothing to be proud of. I would shine up my shield, nurse my alcoholism at the dinners, and make a little smile for the cameras. David was doing a good job of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m not really complimenting him. If you just showed up and got through the evening without pissing your pants, you’d be doing a good job of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David came up to the squad room to see me and introduced himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard you don’t speak Chinese,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You heard right.” He closed his eyes and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t that a bit of an impediment to the job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not so much. Frankly, if I can find just a few people to talk to, usually the younger people, I do just fine. It’s the kids who tell me who’s who and what’s going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked David over carefully. He was tall, about six feet, and sort of storklike. Those gangly arms were meant to cradle books, not women. The kid had a sweet face, though.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_139",
      "title": "139"
    }
  }, [_vm._v("“Do you like what you do?” I asked him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean the job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I mean is that you have the job and then going to banquets and stuff is extra work. That could be a major pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s so tough about sitting around and eating? It doesn’t seem like extra work to me. It’s like being at my relatives’ houses. I just relax and daydream a little. It’s a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, basically, you wanted to be a cop to have a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. I wasn’t sure what to expect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet you’re happy with it now, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should I be unhappy? What are you getting at?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came in close to him. “Let me tell you, David, I’ve heard some of the other guys calling you ‘Ong Kong Phooey,’ and it pisses me off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why should you be pissed off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re making fun of you, man, and it’s racist!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re just joking around, Robert. I don’t take it as racism. People have funny nicknames for each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t mind being compared with a dog that does bullshit kung-fu and karate moves?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a nickname. It doesn’t even matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It does matter, and if you don’t stop it now, it’s just going to get worse. You’re going to be ‘Fu Manchu’ next.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m new to the job and I know you’ve been through a lot. But even I know it takes a sense of humor to get through the day. When was the last time you had a laugh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When was the last time people had a laugh at your expense?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head. “You are really something. The Brow warned me about you. I think I can see why.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He warned you that I was a no-good alcoholic, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw. He told me you’d try to make me feel bad about myself for helping out the community.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_140",
      "title": "140"
    }
  }, [_vm._v("“Let me tell you, man. These people you’re eating with, they don’t give a damn about you. They just want a picture with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That part is true. Almost everyone I meet doesn’t exactly have the nicest things to say about you. They say they’re glad that you’re gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The feeling’s mutual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still, though, you gave up the easiest job in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("obody hates meetings more than me,” English said to everyone in the squad room. “So I’ll just call this a series of announcements. When you’re typing up reports, remember to punch hard. You’ve got to get through to the carbon duplicate. We don’t have a budget for fancy electric typewriters, so put some manly muscle into it. Some of you are typing too soft. We’re dropping letters and sometimes even whole words. Nobody wants to read, ‘Found out the murderer is garble garble.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No names now, but Vandyne, you got a light touch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t help snickering and neither could Pete or Bad Boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not a secretary,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then don’t type like you wear a skirt! Get mad if you have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m getting there right now. Anyway, it’s not my fault. The stupid springs are old or something else needs to be adjusted. If you could dig out the manual, I’d fix it myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The manuals are gone,” said Bad Boy. “I think they needed to burn them for fuel in World War Two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We heard boots in the stairwell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The struggle makes you stronger, Vandyne. Next. When you bring someone in who has pissed their pants, you don’t have to pull him all the way up here and lock him in the squad cell. You can leave him downstairs in one of the common cells. Pete, you ruined my lunch the other day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_141",
      "title": "141"
    }
  }, [_vm._v("Someone was stomping down the hall to the squad room.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Last . . . Yes, sir!” English stood at attention as The Brow walked into the room. All four of us stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At ease,” The Brow called out. He was a small man and he looked up hatefully at everyone else in the room. His pretty blue eyes, windows into his glacier soul, sparkled above his indignant frown, which grew deeper with each step as he paced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The commanding officer’s real name was Sean Ahern, but because of a bare patch in his right eyebrow, everyone called him The Brow. Not to his face, of course, and not even to his back. He was in his late fifties and was thin and mean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His hair was short, reddish brown, and looked like moss, the kind that liked to grow on tundra rock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy and The Brow had a major falling-out years ago, back when they were both in the academy. Over the years, Izzy rose through the ranks of Manhattan South, which oversaw the Fifth Precinct, among others. Izzy was my pal now, so I wasn’t as frightened as I used to be by The Brow’s scare tactics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Brow favored heavy boots that he liked to stomp for emphasis, sometimes for every word he said. On top of that, he’d pound his fists into his hands while focusing the hate beams from his eyes at you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand that some of you have been associating with the fine boys of Manhattan South,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to look at an interesting spot on my forehead close to the hairline. All of us had had direct contact with Manhattan South except for Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Manhattan South is investigating a case under their jurisdiction that happens to be in our precinct territory. I can understand how you may be confused by the situation. You probably think that you can hang out in their cars when they’re doing a stakeout or that you can even help with the investigation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_142",
      "title": "142"
    }
  }, [_vm._v("He stomped his right foot and the entire building seemed to shake.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s get something straight! You stay away from this case as if it were a whore stricken with oozing lesions! Do you understand that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Brow pointed the second and third fingers of his left hand at Pete and Bad Boy and said, “I don’t care how senior you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pointed at me and said, “I don’t care how new you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally he pointed at Vandyne and said, “I don’t care how black you are.” He turned to face us all head-on, fists shaking at his sides. “You’re going to obey me or I’ll have you walking a beat on the Manhattan Bridge on a cold and icy night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nobody said anything as The Brow stomped out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hope you enjoyed the floor show, folks,” said English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne and I absently shuffled into the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are getting it good tonight,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That little bastard,” muttered Vandyne. “I don’t miss the patrolman days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rinsed out a cold pot of coffee and changed the filter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not going to last,” I said. “Dictators never do. He’s done like Castro’s going to be done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Castro’s not done yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It couldn’t possibly be much longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The coffee machine lurched into action. We took two seats at the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are we going to keep messing around with Mr. Chen’s case?” asked Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Brow’s not going to stop us. He couldn’t hate me any more, and anyway if he could have fucked me over, he would have by now. I’ve got Izzy in my corner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_143",
      "title": "143"
    }
  }, [_vm._v("Pete strolled in. “White guys allowed in the kitchenette?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never,” I said. He sat down with us at the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think he knows how corny he is with that stomping act. He’s a real live Napoleon,” said Pete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That guy used to make my life hell,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We could take him down. All of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne said, “I’d rather see him trip over his own laces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("English poked his head in. “Who poured out the cold coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goddammit, I was saving it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then pour it into a mug next time,” said Pete. “Where’d Bad Boy go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Went to Happy’s,” said English. “I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going, too, then. How about you two?” Vandyne and I both passed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("English walked over to the sink and stared at the drain. “Goddammit,” he said again.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went to break up an illegal protest that amazingly was not at Jade Palace. It was at the midget’s toy store.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A group of mothers were staging an impromptu siege against the midget’s store. Apparently they were locking arms and blocking the entrance. But none of them were tall enough to cover up the "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GIMME JIMMY")]), _vm._v(" poster in the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget should have known better. Or maybe he didn’t care. The fact that his store was solidly within the boundaries of pro-KMT Chinatown meant that he was in the middle of Gerald Ford Land. Hell, he was in the middle of Joe McCarthy Land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sure, Ford had gone to the People’s Republic. He had shaken hands with Mao just like Nixon had. But Mao was dead, and so was any implicit agreement made with the handshake. Mainly, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_144",
      "title": "144"
    }
  }, [_vm._v("though, the pro-KMT Chinese remembered Ford’s most recent actions. How he thundered against the International Olympics Committee after they barred Taiwan from competing in the 1976 Summer Olympics in Montreal.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, they weren’t exactly barred from the games. Taiwan had wanted to compete once more as “The Republic of China,” but ended up boycotting the games when they were told they had to compete as “Taiwan.” The People’s Republic was boycotting the Montreal games because it was still pissed off that Taiwan had been allowed to compete in 1972 as “The Republic of China.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the next games came in 1980 Ford was going to stand up again for the Republic of China, which the United States recognized officially as the legitimate ruler of all of China. It was a given that Ford was going to maintain those ties. One more disastrous cultural revolution on the mainland might even give the KMT a chance for a sneak attack, backed by U.S. dollars and aid. The Ford Motor Company had built B-24 bombers in World War II. Surely a President Ford would lend some aircraft for the purpose of recovering the mainland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carter, on the other hand, was a pinko. KMT supporters had three firm pieces of evidence to prove that. One, he was a farmer. Two, his family had practiced integration in the South and treating everybody as equals is the first step in brainwashing. The final straw was that he gave an interview to "), _c('i', [_vm._v("Playboy")]), _vm._v(", a decadent magazine that was offensive to all upstanding people.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('b', [_vm._v("B")])]), _vm._v("y the time I got to the toy store, the linked arms of the five ladies had slipped to holding hands. Their chanting remained spirited, though.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mao’s dead!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t buy toys from bandits!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Little red book! Little red man!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_145",
      "title": "145"
    }
  }, [_vm._v("“Hello, there,” I said. “I hate to tell you this, but you have to stop this right now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah?” said a five-five toughie with a smelly perm. She seemed to be the leader. The woman pointed a calloused finger at my right eye and said, “You are a Communist, too!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m a cop. This is an illegal gathering and it’s gonna stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not going to stop until this store is out of business!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is this all you understand?” I rattled loudly the handcuffs on my belt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t scare me!” said the woman, but the four behind her backed away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going to leave, huh?” I broke open my handcuffs and the woman with the perm moved away so fast she was in danger of straightening her hair all over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A little boy and two girls came over to me and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to go in now?” I asked them. “Let’s all go.” They didn’t say anything, but I pushed the door open and let them in first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget was in front of the counter, testing the drawer on a tiny beat-up desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you insane, putting up the Carter campaign poster in your window?” I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Freedom of speech, baby,” he said without looking up. He put his chin on the top of the desk and reached under with his right arm. “A little tangled up back there,” he muttered to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t it a little risky taking a political stance? Particularly an unpopular one on this block?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget stood up and brushed off the dust from his shirt and pants. He glanced at me before heading back to his side of the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to think about my young customers,” he said. “I don’t "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_146",
      "title": "146"
    }
  }, [_vm._v("want them to grow up thinking they can’t say what they really think. I don’t want them to be scared to speak up for what they believe in. That’s what America’s about.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s not what Chinatown’s about,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it’s what Chinatown "), _c('i', [_vm._v("could")]), _vm._v(" be about. I’ll even go so far as to say that it’s what Chinatown "), _c('i', [_vm._v("should")]), _vm._v(" be about.” He disappeared and then popped back up with a pair of pliers. He snapped them a few times and grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way, man. Conflict is in our blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Conflicts don’t have to be taken so personally,” said the midget as he made his way back to the desk project. “Civilized people talk out their differences and make a better world for the next generation. They don’t have kids just to carry on the same grudges they had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t stop the way people raise their kids with your toys and free-speech propaganda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I’m not going to have nearly as big a role as American schools and television. These kids don’t even speak Chinese!” He pointed at the three kids who came in with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I said to the boy in English. “You don’t speak Chinese?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put on a sad little face and said, “No, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the midget I said, “This is ridiculous. I grew up speaking Chinese, so it can’t be that hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went under the desk and slammed something with the pliers. “You were such a good little boy, Robert. I guarantee you something. Your kids aren’t going to speak Chinese. They won’t even like Chinese food.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They won’t like it, but they’ll eat it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How I wish you were my dad.” The midget pulled himself out from under the desk. He took a deep breath and grabbed the drawer and pulled it out. “Success! Yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not that hard to get a drawer open.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_147",
      "title": "147"
    }
  }, [_vm._v("He slammed the drawer shut. I heard some springs snap back. “Give it a shot, pal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked over and stuck my hand under the drawer. “Aw, I get it. There are a few different switches you can pull. Only five, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many combinations are there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Five. No, wait. Ten?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kids,” the midget called in English. “Something funny!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I struggled with the drawer. The wood looked as delicate as a graham cracker but there were metal reinforcements in it that held it strong. I kept jerking the drawer hard. The kids came over and laughed at me for not being able to open it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyone ever tell you that you have a very expressive face, Robert?” asked the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the combination?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One and four,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was just about to try that one, anyway.” The drawer slid open smoothly. The kids gave me a round of applause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You like that?” asked the midget. “It’s an old cash register I found in the storage space. Pretty ingenious, isn’t it? Have to admire those Chinese people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me this, though. What good is this fancy combination lock if someone has a gun to your head?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Feel those little leather loops down there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s where you keep a knife or a pistol.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("F")]), _vm._v("or a break, the midget and I went to a cramped dumpling house that had opened in the arcade that connected Elizabeth with the Bowery in the middle of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a shame about Mr. Chen, isn’t it?” asked the midget. The whole thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_148",
      "title": "148"
    }
  }, [_vm._v("“Yes, it is,” I said. “I was actually contributing to the investigation when The Brow warned me—all of us, actually—to stay away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still, it’s a pressing matter, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s embarrassing for the U.S. that we haven’t apprehended the suspect yet. The only reason why it’s not an ugly international incident is that the People’s Republic has decided not to make it an issue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t want to make it an issue! They want the U.S. to speed up the process of establishing formal diplomatic relations. They start complaining about it, then the resentment against China starts setting in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, I’m sure the mainland was not the biggest supporter of Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to know something? They probably wanted something bad to happen to him as a lesson to the folks at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What a sad and strange thing to have happened. Remember what happened to Lin Piao? He was the guy who tried to overthrow Mao. The plot hits a snag so he jumps into a plane and tries to flee to the Soviet Union. Then, pow! Lin’s plane crashes into a mountain. Sometimes it seems like the Communists can make bad things happen by just wishing for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The North Vietnamese got their wish. Now they have all of Vietnam.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s interesting isn’t it?” asked the midget, his eyes trying to read something in the hot-sauce streaks on his plate. “With the mainland as a permanent member of the United Nations’ Security Council, I don’t think the rest of the world can delay membership for Vietnam for too long.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what the problem with that is? North Korea is going to take that as a cue that if they overrun South Korea and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_149",
      "title": "149"
    }
  }, [_vm._v("unite that whole peninsula, then they, too, can be a legitimate state.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“China would never allow that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It allowed the Vietnam War.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s completely different. If you haven’t noticed, China and Vietnam aren’t buddies. China and North Korea are as close as lips and teeth, as they say, and China needs Korea to remain divided and in a state of uncertainty to have an edge over the U.S.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that doesn’t make any sense. Uncertainty cuts both ways. How is China more secure with it than the U.S.?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who has more people who know the Korean language and culture, the U.S. government or the Chinese government?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget wove his fingers together, pushed his hands away from his body, and cracked his knuckles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, how’s Lonnie holding up?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hanging in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a strong woman. She’ll be fine in the end. As long as you do your part.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jesus, I’m trying as hard as I can! You think it’s easy finding a murderer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Looks easy on TV.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One problem is that there are so many motivations to kill Mr. Chen. It could be seen as a pro-Communist move or an anti-Communist move.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It could also be a pro-feminist move, taking out this older man who is in a position of power.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re forgetting that he was acting on behalf of Li Na, who is a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Li Na also represents her father, Mao Tse-tung. That’s one reason why she was purged from the Communist party.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_150",
      "title": "150"
    }
  }, [_vm._v("“There was another reason?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her mother was Jiang Qing. You know her, right? Mao’s last wife and also the leader of the Gang of Four? If your mother was branded as a leader of a counterrevolutionary clique, then you probably don’t have much of a political future.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That poor kid,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Li Na? She’s not a poor kid. She’ll live out her life in a gilded cage. Lonnie is the poor kid!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("zzy called me at home. “The Brow had his shitfit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry about that, but I was being as careful as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It wasn’t you, you know? It was those idiots drinking in the car. The Brow tailed Pizza Man and Bad Boy. Saw you come up to the car later, but he knew you weren’t a member of the party.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So my cover wasn’t blown. I can still look into Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I was thinking. The best thing is that when you meet up with Chinese people, you can say it’s personal, not business.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("arbara called me at the station and told me that a Mr. Wilson Yi of the New York outpost of the Republic of China’s embassy wanted to talk to me about the murder of Mr. Chen. I was wary of how the KMT diplomat would try to spin me politically, but decided to go anyway because it couldn’t hurt and also because it would make Barbara look good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had already helped me with an old classmate in addition to finding Paul an internship and Lonnie her job, so I owed Barbara two or three favors. But she had also dumped me a while ago, so that cut into the favors-owed column.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The R.O.C. embassy was inside a skyscraper close to Rockefeller Center. Ten Taiwan flags stood on floor bases on either side of the passageway to the elevators, representing the 10-10 of the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_151",
      "title": "151"
    }
  }, [_vm._v("October 10 anniversary date of the founding of the Kuomintang Party.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I got to the right floor Barbara and another woman were waiting for me outside the embassy entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Robert,” said Barbara in Mandarin, “this is Mr. Yi’s secretary, Ms. Kung.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello,” I said to the short woman. She was about five feet tall and on the heavier side. She had a sweet face behind her horn-rimmed black glasses, though.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow, you look American! You’re so big!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Yi is very anxious to see you.” With that, she led us into the offices. She took us around the corner and past a section of furiously loud typists to a giant rosewood desk, presumably Ms. Kung’s. She bent over her desk awkwardly and tried to reach the intercom button. Ms. Kung had to climb up the side a little bit, like a pug climbing onto a bed. I chuckled a little and Barbara punched me in the arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ms. Kung finally reached the button and screeched, “They’re here!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wooden double doors in the wall swung open and a man stepped out. He was in his late thirties, about five foot five, and his black hair was in permed curls. Like a lot of men who had grown up in Taiwan under the tropical sun, he had dark brown skin. The girls would avoid the sun so they wouldn’t be confused with the lower classes who had to work outdoors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please come in!” Mr. Yi called in perfect English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a seat facing Mr. Yi across his modest table while Barbara sat on the right wing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you so much for taking the time to see me,” Mr. Yi told me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad to visit, as long as there is useful information you "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_152",
      "title": "152"
    }
  }, [_vm._v("have for me. If Barbara says it’s important, it’s good enough for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ms. Kung waddled in with a cheap bamboo tray that held a clay teapot and three cups. She set it down on Mr. Yi’s desk and pushed it to an area equidistant from and just slightly inconvenient for each of us. She left quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbara reached for the teapot, but Mr. Yi waved her off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a little bit longer,” he said, smiling. “You have to give the tea leaves a chance to unfold.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had the feeling this wasn’t going to be restaurant tea,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have my own personal favorite,” said Mr. Yi. “It’s not very expensive, but the taste is so subtle, it’s precious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d still take coffee over tea any day,” said Barbara.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When I was young I drank mostly coffee, too. When I got older, I learned to appreciate the, ah, "), _c('i', [_vm._v("ambiguity")]), _vm._v(" the better teas have.” Turning to me, Mr. Yi said, “Well, I’ve known Barbara for some time now, but you and I don’t know each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gee, where should I start?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you’ve misunderstood! Barbara has told me all about you already. Let me tell you about myself!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My family has been in Taiwan since the 1700s. They came over from Fujian province. I’m one of the highest-ranking native Taiwanese in the KMT, maybe "), _c('i', [_vm._v("the")]), _vm._v(" highest. For the most part, the KMT is run by Chinese who fled the mainland after losing the civil war in 1949.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought the KMT’s platform represented something most native Taiwanese don’t go for.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That Taiwan is a part of China? I’ll tell you, my father sure didn’t like it at first. He was very conflicted about joining the KMT, even though as the oldest son of a family that owned plastics factories, he would have been forced to join the party or lose "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_153",
      "title": "153"
    }
  }, [_vm._v("his business. If he wanted to, he could have fought the KMT tooth and nail. But he went to a temple to ask for guidance and a monk told him to go through our family’s records.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He came upon an old journal from the early 1800s that said something to the effect that the family longed to return to China after the ‘barbarians’ were eliminated. That journal was referring to the Manchus who rode in and toppled the Ming Dynasty and established the Qing Dynasty, but my father took it as a sign, since the KMT referred to the Communists as ‘barbarians.’ So he joined.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Yi, what is your personal story?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to know why I speak English so well, huh? I grew up with private tutors and came here to the States for college, undergrad at Stanford and Ph.D. from Harvard. That’s where I met Barbara.” Mr. Yi stood up and reached awkwardly for the teapot. He gathered the three teacups to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t tell me you knew each other from school,” I told Barbara.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, everybody knew who Barbara was,” he said, chuckling. Mr. Yi poured out tea for Barbara and me, and pushed the teacups as far as he could to us. He then poured his own tea. “Such an attractive woman is more famous on campus than the best-known professors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbara sniffed the steam from her tea while shaking her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you study, Mr. Yi?” I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chemistry. I don’t recommend it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess you were being groomed for the family business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate plastics. I hate the way they smell. I can’t even use a plastic umbrella. There’s no future in plastics. Not for me, anyway. My father was pretty disappointed, to say the least, but he had the connections to hear of a vacancy in this office and once "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_154",
      "title": "154"
    }
  }, [_vm._v("they heard ‘Harvard Ph.D.,’ I was in. I enjoy what I do, but it was rather unfortunate how I got this job.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s no shame in using family connections,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, the position was vacant because my predecessor left. When the People’s Republic took the Republic of China’s U.N. seat, he saw the writing on the wall and flew back to Taiwan. After he got home he hanged himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drank some tea. “That’s awful,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is a perceived diminished value to this office as well. The American diplomat to the Republic of China, Leonard Unger, was in New York a few months ago. We had set up a dinner banquet for him in Midtown—not some crappy Jade Palace joint. Mr. Unger sent an assistant in his place. He didn’t even have the courtesy to call to tell us in advance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at Mr. Yi’s phone. It seemed that the only important call he would get would be to come home because it was all over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we get to the matter at hand?” asked Barbara. “I don’t mean to rush you, Mr. Yi, but I have to stick to my schedule.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, yes, of course. Well, Robert, I wanted to discuss a sensitive matter about poor Mr. Chen with you. There are fringe elements, the extreme right wing of the KMT, who are outraged by his murder. They believed that Mr. Chen was killed because he and Li Na were embarrassing the mainland. Mao’s daughter could never be assassinated, so Mr. Chen became the scapegoat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s very problematic is that these KMT extremists are convinced that Communist elements in Chinatown are responsible for killing Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s possible,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Yi took a big swig of tea. “The extremists have criminal connections. In the past, a number of critics of the KMT and Chiang Kai-shek have been killed all around the world. I would "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_155",
      "title": "155"
    }
  }, [_vm._v("think that the same fate would befall anyone suspected of having a part in killing Mr. Chen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see. These men are pretty ruthless, I take it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, they are. Mainly though, I wanted to tell you that they often disguise themselves with R.O.C. diplomatic IDs and license plates. If you are ever approached by people claiming to be from this office, and if I didn’t tell you they were coming, they are not to be trusted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Won’t I be able to tell from their IDs? I can spot fake documents.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t use fake documents. Everything they use is authentic. There are high-ranking KMT officers who lean to the far right and provide the necessary materials for these squads to work with.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew exactly whom Mr. Yi was referring to. There were branches of the KMT that didn’t go to Taiwan after the civil war. They instead withdrew into the jungles of Thailand and established militarized bases financed with drugs. It was like printing money. They apparently had roving death squads in Asia that killed high-ranking Communists in the surrounding countries, along with critics of Chiang Kai-shek and the KMT.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But they hadn’t carried out assassinations in the United States. Yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t quite know what to say, Mr. Yi.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t give out any information to anyone claiming to be from agencies of the R.O.C. Lives may depend upon it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You understand that my girlfriend is implicated in the investigation of Mr. Chen’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, but she couldn’t have done it. Any fool can see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The problem is, I’m having trouble finding the responsible parties.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So are these squads.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_156",
      "title": "156"
    }
  }, [_vm._v("“I don’t even have jurisdiction here. Manhattan South is handling the case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yet you’re still making inquiries, so I imagine that you are involved in some capacity with the investigation. Even unofficially. Honestly, Robert, if that was my girlfriend, I’d be doing my damnedest to find the real killer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I’m not the only one looking, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you’re not the only one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Yi, I understand that it was private Taiwanese citizens who helped Mr. Chen fly into New York.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is true, although they didn’t work alone. A number of Hong Kong businessmen were involved, too. The whole thing was an incredibly naïve operation, that’s for sure. It’s a nice idea that Mr. Chen is an advocate for Li Na, but surely, wouldn’t such a powerful man also harbor his own intentions and push for his own interests?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hen we were done, Mr. Yi buzzed in Ms. Kung, who showed us the way to the elevators. I was a little shaken up, imagining that gunmen were walking the same streets, looking for the same man as me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tipping me off was pretty risky and I had to give Mr. Yi credit. He seemed like an all-right guy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we waited at the elevator bank, I asked Barbara if she ever dated Mr. Yi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, please, he’s like ten years older than me!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t ask you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No! He’s been married since he was twenty. He already has two kids, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t know he was a family man! Still seems pretty happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Having a family doesn’t mean you’re going to be unhappy.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_157",
      "title": "157"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("avid Ong came into the squad room and found me. I looked up and saw he was worried, maybe scared.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, I think I saw some people with outstanding warrants.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m pretty sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By ‘people,’ do you mean gang kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, older.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mid-twenties.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re in the tunnels under Doyers Street. I think they were shaking down a merchant for money. I know them because I’ve been looking through the mug books regularly. I mean, the ones of prior convicts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared at him hard. “Listen, David. We "), _c('i', [_vm._v("only")]), _vm._v(" have mug books of prior convicts. Understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, that’s what we have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You just saw them now?” asked Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I just ran back here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne and I shook on our coats. “Next time,” said Vandyne, “use your radio and call it in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The goddamn thing wouldn’t work underground.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Welcome to the job,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("oyers Street has a bad reputation that is well deserved. In the 1800s, it was the favorite site of the so-called hatchet men to waylay enemies of their tong. You could probably hide a football team in the shadow of the elbow of the sharp turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the turn of the century, shoot-outs with pistols were "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_158",
      "title": "158"
    }
  }, [_vm._v("common in the “bloody angle.” I have met old men who, as kids, used to collect the round little bullets and play with them like marbles.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later on someone cleaned out the grain storage areas that were beneath Doyers, because the entire street itself used to be the private drive of a long-gone farmhouse. An entire underground chamber now ran roughly along Doyers, connecting Bowery, Mott, and Pell. It was far bigger than the tunnel Mr. Chen used to get into Jade Palace, and it was filled with twists and turns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not surprisingly, as space never goes to waste in Chinatown, it also was the home to many mom-and-pop stores and restaurants. The stupid gang kids would be especially bold when hitting the underground businesses for money because they felt emboldened hidden from the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their cockiness was somewhat justified. If they were minors, there wasn’t really much we could do to them if they were apprehended. They wouldn’t even get a tough talking-to from the judge. But once they turned eighteen, they could be tried as adults, and the protection racket was a game for kids.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('b', [_vm._v("W")])]), _vm._v("hen we got close to Pell Street, Vandyne said, “We’re going to come at them from different directions. Are you sure you’re up for this, David?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am. This is the first real action I’m going to be a part of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Watch yourself, David,” I said. “Rounding up these assholes is not a dinner party. They have lousy aim, but they’ll make up for it in shots fired.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David nodded. “So we split up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s meet up in the food court on the second level. I’m gonna take the Bowery entrance,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll take Pell,” said Vandyne. “David, you’re all right with Mott?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_159",
      "title": "159"
    }
  }, [_vm._v("He put his hands on his belt and nodded. I quickly cut across Pell and made a right on Bowery. I entered the bank on the corner and took the stairs down to the underground area.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fluorescent lighting through discolored plastic shades gave everybody and everything a pus-colored glow. The fish struggling in the gloomy water in the aquarium store came off the worst. I heard some shouting from around a turn, but it was only a woman with a baby trying to get her money back for a toy that broke after less than a week. I thought I recognized the woman, so I turned my head until I was safely past the store.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lifted a low-hanging towel in front of a housewares store and eased by battery-operated toy cars driving around in circles on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything seemed to be normal, if a little chaotic. Those guys David had seen were probably long gone. The older ones liked to work through the young recruits, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went down to the second level and it was more of the same. The air was humid thanks to the numerous stands boiling dumplings and noodles. I went around a wonderfully smelly fried-dough joint with half a mind to get a stick. It didn’t seem safe to have an open flame in this area. I wondered how it had passed safety inspections. But then I realized this little underground world probably wasn’t even on the radar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I passed the sticky-rice stand, I saw Vandyne across the way giving me a meaningful look. He tipped his head to the northeast. I slowly looked over and saw the three scumbags sitting at the only spot they could find free. It was a kids-sized folding table and they were all on plastic step stools with their knees up at their shoulders. They looked like they had crashed a little girl’s tea party.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw this guy Marcus who liked wearing paisley shirts. He had missed a court date a few months ago for robbery. I don’t say “alleged,” because Vandyne had caught him in the act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_160",
      "title": "160"
    }
  }, [_vm._v("Another guy had a face like a cat with a small nose and eyes that were too close together. I called him Catwoman, and he had also missed a court date, for assault and battery on a store owner.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third guy I wasn’t too sure about until I saw a big red blotch on his left arm when he raised his rice bowl. It was Sherman, who had been mixed up in heroin. He had grown out his hair but there was no getting rid of that ugly birthmark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert,” whispered David, who was crouching by my right elbow. “That’s them!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” I said without turning my head. “So you stay back here while—” He sauntered in front of me and strolled down to the three assholes. “Aw, fuck.” I followed close behind. I was sure Vandyne was behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right, freeze!” David yelled at the three, gun drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus ignored the command and threw more noodles into his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, you fucking asshole, I’m talking to you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was impressed to hear that harsh voice and tone coming out of David. Problem was, it was the wrong language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When you confront someone, you need to establish authority quickly. Sometimes you can do it by acting loud and mean, sometimes quietly. A white or black cop would almost automatically have the upper hand on a Chinese suspect because those cops would already represent a sort of status quo authority figure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But an Asian guy speaking English would be seen as a lightweight, some jackass who didn’t even know what he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So I shouldn’t have been surprised when Marcus calmly put down his chopsticks and reached under his seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get your hands up, asshole!” I yelled in Cantonese at Marcus. He stared at the barrel of my gun and let his hands float to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_161",
      "title": "161"
    }
  }, [_vm._v("the ceiling. Quietly, other diners picked up their bowls and stepped out of the line of fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne said behind me, “Stand up slowly, all you motherfuckers, and get up against the wall!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I kicked their legs out and frisked them all. None of them had anything on them, apart from Sherman, who had a paring knife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s for fruit, man!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should have used your fingernails, Sherm,” I said. I didn’t know if the concealed weapon thing would stick with him. Unlike the other two, there wasn’t a warrant out for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Vandyne and I had them all cuffed, I said, “David, go over and see what Marcus had under his seat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a bag,” David said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look in the bag but don’t touch anything. What do you see?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A small gun. And a book.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bring it over here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a cheap-shit .25 caliber gun that we called a Saturday night special. “Hey, Marcus, how come you’re still using the same gun you had when you were twelve?” He spat on the ground. “David, these are good collars. You did a real good job. David?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His face was falling apart. Tears and snot were all over the place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“David, c’mon, man! It’s all right!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne called out, “Dave, we’ve got it all together now. We’re going home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was going to shoot me,” he gasped. “I had my gun drawn. He was going to shoot me anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus snickered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Watch your step, Marcus,” I said, dragging him to the right. “I’d hate it if you slipped and hit the ground with your "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_162",
      "title": "162"
    }
  }, [_vm._v("face a few times.” In English, I said to David, “You have to stop that, now. You want them to start calling you ‘Ong Kong Boo Hooey’?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m just kinda shook up,” he said, wiping off his face with the backs of his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s book these guys. I’m giving you primary credit, too. The Brow is going to love you for this.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he Brow had me in his office and as these things usually go, he was yelling at me as soon as I stepped into the room. It was to be expected. There were only two reasons why you’d be in there. You were either in trouble or you were in big trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why the hell have you put my boy in harm’s way?” he yelled. I closed the door behind me and took two steps toward his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir, David Ong came to me after spotting suspects with warrants out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How the hell would he know them on sight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir, he looks through our mug books in the squad room. It’s good that he did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who the hell told him to look through the blasted mug books?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir, probably someone at the academy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chow, did you know that Mr. Ong was very nearly shot dead yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir, John Vandyne and I were both there. We were looking out for David.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why couldn’t you and the fine Mr. Vandyne have handled it yourselves?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir, there are three exits to the Doyers underground complex. There’s no way to cover it with only two people. If you would read the report—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve read the entire bloody report! I almost went blind be"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_163",
      "title": "163"
    }
  }, [_vm._v("cause the typing was barely legible! Did you type that report?” Vandyne had typed it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir, and I apologize for the typing job. I’ll do better next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could have taken along anybody else besides Mr. Ong. Anybody! Even Peepshow Geller! If you ever use Mr. Ong again on any dangerous case, I’ll send you to the goddamn firing squad!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Understood, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s my golden boy, and you don’t get to cloud his mind!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time he dismissed me my ears were ringing, but I shook it off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor Peepshow. He was a guy who was going to walk a beat his entire career. If you get branded as incompetent early on, your career is pretty much dead. Sure, you’ll get the union-mandated raises and cost-of-living increases, but promotions? Forget about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no way Peepshow was ever going to pass the sergeant’s exam to go up the supervisor track.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he had wanted to become a detective, it was even tougher because it was discretionary. Someone higher up would have had to take a liking to him and toss him some investigative work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But nobody was ever going to hand Peepshow an assignment, much less a cup of coffee. He was going to be forever the overweight and goofy white guy whose only pair of jeans had a rip in the lower-ass area. The ultimate insult was that not even the C.O. would use his real first name anymore. In fact, everyone had forgotten it.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("V")]), _vm._v("andyne came over to have dinner with Paul and me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That fucking Brow,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cheer up, man. It’s guys’ night,” said Vandyne. “I know I shouldn’t have, but I went ahead and splurged.” He held up a box from Dunkin’ Donuts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_164",
      "title": "164"
    }
  }, [_vm._v("“Did you get any éclairs?” asked Paul.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey!” I said. “The first words I want to hear out of your mouth are ‘Thank you’!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” said Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s all right, Paul,” said Vandyne. “It wasn’t much trouble at all and, hell, I even used a coupon! Actually, I should be thanking you, little man, because I know Chow didn’t have much of a hand in cooking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re wrong there, partner,” I said. “I stirred in the tomato sauce and I added in a secret ingredient.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul and I had prepared Sloppy Joe filling from the package directions, but it didn’t have enough taste, so I put in some crushed red pepper—not a lot. It was definitely a meal for guys. The sides came out of chip bags and we drank soda out of the cans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is what Saturday night has come down to, Chow,” said Vandyne. “Sloppy Joe night with Paul.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you having a bad time?” asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no no no! I’m worried we’re boring "), _c('i', [_vm._v("you")]), _vm._v("! You’re still in the prime of your life with a great future ahead. It’s a shame you have to spend a weekend night with two crazy vets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One more doesn’t make a difference.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We all laughed at that. Paul was growing up into a pretty decent ballbuster. Vandyne pushed his chair over to the window and cracked it open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You guys don’t mind if I smoke, do you?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go ahead,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne touched a lit match to his cigarette. He blew out the flame, dropped the match in his empty soda can, and said, “Paul, don’t you ever dare start smoking. It’s a dirty and disgusting habit and the industry that backs it is racist against men of color. All colors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_165",
      "title": "165"
    }
  }, [_vm._v("“I’ve already tried smoking,” said Paul. “I didn’t like it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t ever start again,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And don’t ever drink, Paul,” I added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, don’t smoke and don’t drink,” said Paul. “Anything else I should remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Study hard and get into a decent school,” I said. Suddenly I noticed that I had a Sloppy Joe blotch on the arm of my shirt. I stuck it in my mouth and sucked on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow tells me you have a shot at Columbia,” Vandyne said to Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I work there now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do a lot of things. I help catalog sea-floor sample cores and do some computer-card programming. I’m starting to build a database that will take years to finish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s smart,” I said. “You fix it so that you’re the only one who understands how to use it and then they have to keep you around to work on it. I’m thinking this will make you a shoo-in for college at Columbia when it’s time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul shrugged. “What I do isn’t that hard. They could probably train someone else to work on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s why you have to develop some sort of filing system that no one else can figure out,” said Vandyne. “Then no one else can learn it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But the value of the core database is so that anyone can use it. What’s the point of collecting information if only a few people know what’s going on? You guys read newspapers. How would you like it if they held back on the news they were giving you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me something, Paul,” said Vandyne. “What sort of application is there to knowing the sea cores?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are a few. We can determine climate conditions in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_166",
      "title": "166"
    }
  }, [_vm._v("the past, evolution of marine life, and we can also determine stratification. That’s important for oil discoveries.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now "), _c('i', [_vm._v("that’s")]), _vm._v(" where the money is,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!” said Vandyne. “That is the kind of information worth keeping from others! You could get rich from that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul sighed. “The main thing, though, isn’t where the oil deposits are, of course. A lot of them are known. The big problem is getting the oil out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You just stick a straw in there,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great,” said Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could study that when you get to college,” suggested Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I could,” said Paul. “Say, Mr. Vandyne?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please call me John.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“John, you play guitar, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne exhaled heavily and dropped his cigarette into his soda can. “From time to time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw you play at that ceremony for Robert a few months ago. You’re really good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think you could teach me how to play?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a second,” I cut in. “Aren’t you busy enough with school and work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to learn how to play for fun. I’m allowed to have some fun, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In all honesty,” said Vandyne, “if you’re just looking to mess around for fun, you’re not going to get far on the guitar. It’s a serious instrument that men and women have signed away their souls to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You looked like you were having fun playing,” said Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve been playing for fifteen years, Paul. I’m just starting to have fun now. My mother forced me to learn it to keep me off the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_167",
      "title": "167"
    }
  }, [_vm._v("streets. I only had about a week to learn each song and she didn’t know how to play guitar. I had to teach myself so maybe I wouldn’t be a good teacher.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you get that guitar?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was my father’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne looked like he was going to reach for another cigarette when Paul said, “Do you want to hear the Ramones?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve heard of them, but I haven’t heard them. Do you like them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Paul,” I said, “Vandyne doesn’t have time to listen to that crap. That stuff is for degenerates.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Nazis called art degenerate, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not a Nazi. Look at this album. They dress like degenerates and name their songs ‘Now I Wanna Sniff Some Glue’? There’s no socially redeeming value to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what?” asked Vandyne. “I think I "), _c('i', [_vm._v("do")]), _vm._v(" want to hear it. A little bit, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re in for a treat,” I said. “Paul got this record from some wacko college liberal coworker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got it from my boss,” he said. “She’s a doctoral candidate in environmental engineering.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The opening chords blasted out of the speakers and Vandyne flinched. But he was tapping his foot during the second song. Paul studied his face, but there wasn’t much to read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Had enough?” I asked Vandyne. “I think I have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For now, that’s enough,” he said. “You know, Chow, it’s not great but it’s not as bad as you think it is. Comes across something like Chuck Berry without the guitar solos or leads. A lot of chords packed in there—a lot of the same ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to play like that,” said Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you don’t,” I said. “That’s not even playing a guitar. That’s just sliding a cheese grater across the strings.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_168",
      "title": "168"
    }
  }, [_vm._v("“I could hear a blues progression,” said Vandyne. “It’s not that hard to learn to play. Do you have a guitar, Paul?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul took a padded guitar bag out of the closet, laid it flat on the ground, and unzipped it. Inside was an acoustic guitar that was a little scraped up but still in decent shape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where the hell did you get that from?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My boss said she didn’t need this one anymore. She has three more and this one is a beginner model.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne picked up the guitar and looked it over. He strummed it a little and frowned. “It’s missing two strings and the ones left need to be tuned, but that’s not a big deal at all. Neck is straight and all the tuning pegs are still there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you going to pay for it?” I asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She gave it to me. She was going to give it to one of the Goodwill stores, but I said I would take it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This thing is only worth about fifteen bucks,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s still money,” I said. “Paul, you have to give your boss something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I pick up groceries for her in Chinatown so I’m helping her out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have extra strings at home that would work on this,” said Vandyne. “I could get this thing back into good shape.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have time to teach Paul how to play?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne smiled. “Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Paul, when you play, I don’t want to hear chainsaws going off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s an acoustic guitar, Robert. It’s not that loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It won’t be bad, Chow,” added Vandyne. “Paul won’t be anywhere near as loud as that record.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So then this is good news to me,” I said. “But Paul, if your "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_169",
      "title": "169"
    }
  }, [_vm._v("grades or your work start to suffer, you’re going to give this thing up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me handle it, Robert!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jesus, this better not start you off on a path of smoking dope and then dropping out of school before you get to college.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne said, “I’ll make sure he only plays the clean-cut notes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Worst comes to worst,” said Paul, “I’ll just be a cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s it,” I said. “Vandyne, you get his legs!” I pinned Paul’s arms behind his back and he yelled like he was at summer camp.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met my mother in a small teahouse on Baxter. A booth that sold ching-chong crap near the entrance was obnoxious enough to practically block the teahouse door with a stack of fake hair queues attached to skullcaps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A middle-aged hostess with her hair in a bun seated us in a booth near the back and dealt us menus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pardon me,” I told her. “You should tell the guy out front to move his stand back a few feet. That old buzzard’s hurting your business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s my father!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He looks good,” I said. The hostess glared at me and then slowly slipped away from our table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother kicked me under the table. I knew what she was going to say, but I was going to have to wait a while before hearing it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother lived by herself in a brownstone apartment past Bay Ridge in Brooklyn in a suburban Little Italy. She moved out there from Chinatown not too long after my father died by falling from a roof to the street. He had been drinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother never drank, and studied whenever she could. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_170",
      "title": "170"
    }
  }, [_vm._v("Because she had learned English so well, she had gotten a job sorting eighty-column cards in Midtown while my father was still waiting tables. Now she supervised the department.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took off her huge shades and unwrapped her scarf. Mom kept trying for that Jackie O look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her face was calm as she scanned the menu, but she was good at covering up how she felt. In fact her face was as smooth as a scoop of Breyers vanilla, and her skin was about the same color with fewer black flecks. My mother was in her late forties and the only time wrinkles appeared on her face was when she was telling me what I was doing wrong with my life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You insulted that woman,” she said under her breath and without looking at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I knew you were going to say that. But I insulted her father, not her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you insult her father, it’s an insult to her, too! If someone insulted you, it would also be an insult to me!” She looked at me directly. Her brown eyes were on fire, but they had lost quite a few flames after I had discovered a rather uncomfortable fact or two about my family a few months ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I forgot,” I said. “We’re all the same person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still nearly whispering, my mother said, “I heard that Lonnie was the last person to see Mr. Chen. Everybody I know read that interview, but I don’t dare to tell my friends I know her or that she is my son’s fiancée.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Girlfriend!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever you call it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Neither of us is ready to get married, Mom.” I was annoyed at myself for also speaking softly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re never going to be ready to marry a murderer!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s not a murderer!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know she didn’t kill that man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_171",
      "title": "171"
    }
  }, [_vm._v("“Because I know her!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These girls from Hong Kong. You don’t know what they’re like!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She came over when she was six!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That doesn’t mean anything. Look at how she was raised. Look at the parents. Her father divorced his wife! What a shame that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So her parents got divorced. That makes her a killer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All criminals come from bad families! You know how many people in jail had divorced parents?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re in America, Mom! Every other marriage ends in divorce.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see? That’s why there’s so much crime in this country.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat back in my seat and noticed that a waitress had sidled up to us. I didn’t know how long she had been there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should I come back?” she asked. The uniform here was a dark blue polo and slacks, and it looked good on her. The girl would be attractive when she was older and all the acne cleared up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re ready,” I said. We got a pot of decent black tea, sandwiches, and coconut-covered toast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe it’s time to find someone else,” my mother continued in her hushed voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re talking crazy, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you understand? Her parents are divorced!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think they should have stayed together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course! If you want your children to turn out okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would have never divorced Dad? You two weren’t happy together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We would have stayed together to the end. That’s the duty of parents. Sometimes, I think . . .” She stopped and her eyes began to water. “I think if he were still here you would have turned out better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_172",
      "title": "172"
    }
  }, [_vm._v("I took in a deep breath and let it out. “Mom, he didn’t die until I was already an adult. The war was what really screwed me up and, honestly, all my drinking.” I thought a little bit. “You didn’t do anything wrong,” I lied.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The waitress came back holding our teapot and cups in one hand while the other carried against her waist a beat-up metal tray with our food. She put down the teapot with an awkward thud and shakily transferred each dish to the table from her tray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The teahouse’s training program was clearly slipping. Actually, they probably didn’t have a training program and they probably weren’t paying this girl shit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” I said. She did a micro-curtsy with her head down and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think she’s good enough for you?” my mother asked, her voice a little closer to normal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s not the greatest server, but maybe, in time, we could grow to love each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not the waitress! Lonnie! Don’t you think you could find someone better?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did find someone better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I cut the coconut toast in half and glanced at my mother to catch her annoyed face, which suddenly turned into a look of alarm. I looked where she was looking and I saw that the guy who ran the souvenir booth was standing next to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you doing, sir?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard you had some comments about my business.” When he was done talking, he jutted out his jaw and wrapped his bottom lip over it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was just saying that it was a shame that a man of your stature had to work such long hours in the cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not what I heard you said!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honestly, that is what I think!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_173",
      "title": "173"
    }
  }, [_vm._v("“You young people have no manners. You think you can say anything you want without consequences. I’m going to remember your little insult and so will my entire family!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It helps to know that saying “sorry” is useless in Chinese culture. Forgiveness isn’t seen as a value. We pray for good luck, money, long life, and happiness, but we don’t pray for those who have caused us injury. No way. We’re not even dumb enough to pray that others forgive us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t even think that Chinese Christians believe in forgiveness. They probably think the expression “turn the other cheek” means “try to hit your enemy with your cheek.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Chinese people forgave each other, it would shatter the plot of every kung-fu movie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite knowing all of this, I said, “I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just you wait,” the old man muttered before leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never think about your reputation, do you, Robert?” asked my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("My")]), _vm._v(" reputation? He was insulting you, as well!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can never come back here. Not until this place closes and someone else takes over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at the pimply waitress serving another table as if the ground were moving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It might not be long, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" walked by a dark brown Buick Regal sedan parked on the west side of Bowery. It was in front of a fire hydrant but what really got my attention were the Bicentennial diplomatic plates from Washington, D.C. That meant Taiwan because they were from the Republic of China embassy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the diplomatic plates were New York, that would have indicated the United Nations mission of the People’s Republic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The windows were tinted and the only things I could see "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_174",
      "title": "174"
    }
  }, [_vm._v("through the right rear passenger’s window were what looked like a tissue box on the backseat and a suit bag hung over the other rear passenger’s door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was after eleven at night. All the places that serve decent food had closed hours ago. What was left open was unfit for even the lowest-ranked foreign official.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came around and looked through the driver’s window at the seat. I wasn’t able to glean much more except that the steering wheel was sheathed in leather. Why couldn’t people place their identification on their seats when they left their cars?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me, sir,” asked a woman’s voice in Mandarin. I stepped back from the car and saw in the window a reflection of an attractive woman in a camel-hair coat. I turned to look at her and realized that the glass had distorted the woman’s face. She was ordinary looking, in her mid-sixties, with shiny coal eyes and a dull red mouth with smudges along the bottom lip. It was tough to tell what her hair looked like but it must have been on the short side to fit up inside her beaten brown leather cap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I just wanted to tell you something.” No man had probably ever spoken to her roughly before. She pouted a little. “But I want to know first if you are a policeman or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am a policeman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here’s what I have to tell you. I was coming down the block when I saw two men looking at you. One of them said to the other that you were a cop and they ducked into an establishment near the intersection with Pell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An establishment?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. I believe it’s a gambling parlor. So maybe you want to go over there and look for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, so that’s the pitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s a pitch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_175",
      "title": "175"
    }
  }, [_vm._v("“Let’s go back a little. As you were coming out of the gambling parlor, you noticed two guys who were looking at me and talking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her face flushed. “I wasn’t gambling.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not here to bust you or anything. Tell me more about these two guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They both were holding little leather bags, like what doctors used to carry. It seemed a little suspicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And they ducked into New Tang Dynasty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She crossed her arms. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did these guys look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were both tall. Taller than you. Both of them were sort of built. Dark-skinned army guys. You know what I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were either Taiwanese or ethnic Chinese from the Golden Triangle in Thailand loyal to the KMT government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taiwan had a mandatory two-year military service for all men and you had to do it before you could get your college degree. Most of them served out their time on one of two offshore islands held by the KMT that were close to the mainland. If the People’s Republic wanted to launch a takeover of Taiwan, those two islands would be invaded first. Such an operation didn’t seem imminent but that didn’t stop China from pounding the islands with mortar shells for the hell of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the woman’s description was right, these guys could be a hit squad sent here to find Mr. Chen’s murderer. I sure hoped they were from Taiwan, because if they were from Thailand they were probably a lot more ruthless and wouldn’t hesitate to shoot a cop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crouched to get a good up-close look at the car’s rear license plate. It seemed to be real, and as I recalled from my talk with Mr. Yi, it likely was real.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_176",
      "title": "176"
    }
  }, [_vm._v("If I went into the gambling parlor, I’d be taking a big risk. We’d been warned to stay out of illegal gambling sites not only because it would implicate us as taking bribes, but it would also jeopardize any sting operations in place.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If I waited by the car, those two men could slip away for good, leaving the car, which could be driven away later by a Taiwanese official with no penalty. Not even Peepshow was dumb enough to ticket a car with diplomatic plates.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to go into New Tang Dynasty,” I told the woman. “I think you should go home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to hide inside this doorway in case they double-back and come out before you,” she said. “I love the detective shows.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you’re going to stick around, then stay out of sight. Seriously.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I won’t even move,” she promised.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("ew Tang Dynasty, like all illegal establishments in Chinatown, was sweating it out in a huge way. In the November election, New Jersey was going to vote on whether or not to allow Atlantic City to open gaming casinos and hotels in a bid to revive the area. As I understood it, the town was in such crappy shape, a couple blocks of pawn shops would improve the city center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Chinatown underworld fought back by improving the gambling experience. New furniture and carpeting was brought in, along with better booze and free packs of cigarettes for big-time losers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The street-level outer entrance was open, but just down the hall two skinny guys stood on either side of the main entrance to New Tang Dynasty. I walked down to the end, the too-bright fluorescent lighting buzzing like a swarm of flies over my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_177",
      "title": "177"
    }
  }, [_vm._v("The skinny guys looked me over and the one with spiky hair touched the one with a crew cut and said, “He’s a fucking cop!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Relax, guys,” I said. I recognized the one who spoke as one of the guards who had stood outside of Together Chinese a week ago. “I’m here for pleasure, not for business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t take your gun in,” said Spiky Hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was told it wouldn’t be a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s bullshit,” said Crew Cut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait,” said Spiky Hair. “He knows Mr. Song.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who’s Mr. Song?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The big Commie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what?” said Crew Cut. “Maybe we should we ask Little Uncle?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go get him. I’ll tell him how extremely disrespectful the both of you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, don’t be annoyed.” said Spiky Hair. “We weren’t told of any special guests tonight.” Still, he wasn’t sure what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I opened my wallet and took out two fives. “One for each of you,” I said. “Buy something to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s all right,” said Crew Cut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is,” said Spiky Hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say, did you two happen to notice a pair of guys who came in here probably five minutes ago?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did they look like?” asked Crew Cut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up,” said Spiky Hair. “We don’t see anybody. We don’t even see this cop coming in. Understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They opened the door for me. What idiots. No wonder these stupid kids shot each other all the time over nothing. I wished I had my camera to take their pictures for “Happy Memories.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_178",
      "title": "178"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" found a waiting area with a small bar and three couches. Somewhere deeper inside were the gambling tables, accessible only if you checked out all right, and there’s no way I would.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heavy curtains covered the three walls. One man flailed his way through a part to my left and entered the room. There was a door back there, but to what? Pai Gow, chuck-a-luck tables, blackjack? A blackjack to the head?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I should have remembered that entering the gambling parlor would likely put me in close contact with alcohol. Here it was, right in my face. About a dozen men of all ages, including under eighteen, sat or stood around, nursing drinks. None of them had the disciplined look of soldiers. They were on the way out and judging by the lack of conversation, they were all losers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The smell of the cheap liquor made the roots of my hair sizzle and I could feel my scalp begin to sweat. Microscopic droplets of watered-down whiskey drifted through the air every time an old man let out an uncovered cough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lost track of my thoughts. I tried to breathe through my mouth and leaned against the side of the bar to give my knees a chance to steady themselves. I leaned over and gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you all right?” asked the bartender, the only authority figure in the room. He looked like a nice guy. He was in his mid-forties, and stood at about five feet three with kind eyes that offered sympathy and gratitude to the gambler for keeping the boss fat and rich. “How about a drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” I barked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, take it easy. I know you had it rough, but luck don’t come to negative thinkers. I was gonna offer you one on the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two dark-skinned men, soldier types.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_179",
      "title": "179"
    }
  }, [_vm._v("“Have you seen two men? With dark skin. Could be soldiers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged. “Sounds like it could be anybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They would have just come through. Right before me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Buddy, I don’t know. I don’t have a good mind for details.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Over there, where that guy came in . . . what does that door go to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about I go over there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s locked. You need to be buzzed in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then buzz me in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put his elbows up against the counter. I could see the bottom of the tattoo of something on the top of his right wrist slide out from under his shirtsleeves. “Buddy, we’re not going to have a misunderstanding, are we? You don’t go through that door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I marched straight for it. I heard a chirp of white noise from a walkie-talkie behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached the wall and tore the curtain aside. The wall was made of cinder blocks encrusted with cement. The metal door was solid steel with only a handle on it. I pulled on it but it was like trying to tug a battleship onto dry land. I gave it all I had and I felt something in my back come apart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bartender was on me with his right hand on my shoulder. I could tell that he’d been working on his grip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow, is it?” he asked me. “Do you want to walk out on your own or do you want a booster kick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another idea had entered my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That woman outside was their lookout! She had gotten rid of me so that they could hop in their car unseen and get away!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And who said there were two men? There could have been four or just one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_180",
      "title": "180"
    }
  }, [_vm._v("I broke away from the bartender’s grip and stomped through the door I had come in from.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good night, boys,” I said to Spiky Hair and Crew Cut on the way out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come again,” said Spiky Hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the street, I saw that I had been right. The car was gone and so was the woman. I walked up to the spot by the hydrant where it had been and cursed myself for not writing down the plate number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard some sobbing from the shadows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I followed the sound to a stairwell leading to a below-the-sidewalk store entrance and saw a homeless person curled up at the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the middle-aged woman who had spoken with me earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They pushed me down here!” she wailed. “They kicked me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I helped her up the stairs. She wasn’t hurt badly but was extremely shaken up. There wasn’t even any blood and she was more dirty than bruised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They told me to mind my own business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me take you to the precinct,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No no no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At least let me get you to a hospital so they can check you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No hospital. I need to go home. I’ve learned my lesson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There were two men?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There was nobody. I didn’t see anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched her scurry away. It was an unsettling sight. Now I knew I could be dealing with men who wouldn’t hesitate to rough up an old lady.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_181",
      "title": "181"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("avid Ong had tipped me off that Mr. Yi, the Taiwanese official in New York, was going to be at a dinner banquet thrown by the Greater China Association. I ambushed Mr. Yi by the escalators to the Ocean Harmony restaurant and I rode up backward and slouched to get face-to-face with him. Other members of his staff leaned on either side from behind him to get a look at me. It was a long ride for an escalator, three flights.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Yi, I think we had visitors from Taiwan two nights ago,” I said. “They had diplomatic license plates from Washington.” I acknowledged one frowning face behind Mr. Yi. “Hello, Ms. Kung. How are you? See, I’m Robert Chow, not some maniac. Well, Mr. Yi, what do you have to say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know anything about any car from D.C. coming in,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These guys roughed up an old lady for just being a bystander.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry to hear that. She should report it to the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They scared her off that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first floor, crowded with loud parents and running children, slowly slipped by. In any other restaurant or building, this would be the second floor, but then that would make the top floor the fourth floor, and four was a bad number for Chinese people. So the fourth floor was Ocean Harmony’s third, and the ground floor didn’t have a name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert,” said Mr. Yi, “I don’t know what to say. If she didn’t report it, then how did you know about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was there and I talked to her about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you witness the assault?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt my face flush up. “No, I didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then we’re talking about something that’s theoretical in nature and unsubstantiated.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_182",
      "title": "182"
    }
  }, [_vm._v("“Try this on for a theory: You could tell your man in Washington that there could be a situation in which he and his island country are extremely embarrassed. Say, a Chinatown shoot-out in which bad men carrying Republic of China identities are killed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t tell Washington anything, all right? I can’t warn them or advise them on what to do. It’s a one-way communication line and I’m the one taking orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second floor, which was either rehearsing or staging a wedding, drifted by.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you heard anything about Republic of China agents driving around Chinatown?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re the first one to tell me, but I’m not surprised.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Apparently, they were spending some time gambling.” Mr. Yi shook his head sadly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The most rational and efficient people, unfazed by guns or torture, lose their minds and get sloppy when you dangle cards and chips in front of their faces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We hit the third floor, and I stepped aside. Mr. Yi slipped around to continue our private conversation and signaled his entourage to stay back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, they don’t even tell me the full details of the dinners that I go to. In that sense, I’m in the same boat that you used to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Barbara told you about those days, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’ve also seen your face and your expressions in pictures in the Chinese newspapers. They help me to remember to keep a big smile on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I did some good after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen. If it does come down to a shoot-out, I hope you get those guys. It would be for the best. For the future.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Yi left me and rejoined his group. Before he entered the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_183",
      "title": "183"
    }
  }, [_vm._v("dining room, I saw him bow three times to a portrait of Sun Yat-sen, the claimed father of both the People’s Republic and the Republic of China.")])]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he Confucius Plaza complex is a gigantic housing complex that sits at the intersection of three different gangs’ turfs. When the project was being built several years ago there were massive protests organized by college-educated Asian Americans to force the contractor to hire Asians. The contractor caved and the plaza was built.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The buildings of the complex sat on a triangular plot of land bounded by Bowery, Division Street, and the Manhattan Bridge approach, while Pell Street ran into Bowery from the west and pointed right at the entrance to Confucius Plaza.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bowery, which ran northeast and southwest, had a lot of restaurants, the dirtiest of which were open twenty-four hours a day to cater to Chinese cabbies and everyone else who worked night shifts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Division, which ran east and west, was crowded during the day with mobile stands of fruits and vegetables and the odd clothing hawker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pell Street, just to the north of Division, was home to businesses including travel agencies, insurance brokers, barbershops, and some more restaurants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bowery had a number of tourists walking up and down it because it had a wide sidewalk and was marked as being the eastern end of Chinatown in the woefully outdated tourist maps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only white people who were lost walked down Pell, with its forebodingly dark, narrow, and slanted walkways, or Division, with its crowds of noisy open-mouth-chewing Chinese people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which was fine for the gangs who considered Pell, west of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_184",
      "title": "184"
    }
  }, [_vm._v("Bowery, and Division, east of Bowery, as fighting grounds for territory.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Retailers on the ground level had to choose the association they wanted to be affiliated with while the kids who grew up in Confucius Plaza had to choose what gang they wanted to be affiliated with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kids were typically recruited by being jumped and beaten into submission. Parents were no help to kids because they were probably working sixteen-hour days and were too tired to do anything but eat and sleep. Teachers and principals were no help because they’d tell the kids to try “talking” to the “bullies.” The police were no help because the police were no help. Believe me, by the time a kid resorts to asking a cop for help, he’s been beaten up by a gang because he belonged to a rival gang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The girls only held the guns for the boys, but they could fight better hand-to-hand. It was true that girls couldn’t throw baseballs, but they could throw punches and land them hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The joint-precinct Asian gang task force that was supposed to launch was put on the back burner for some bullshit administrative reason. I think the adjoining Seventh Precinct needed to replace some copier machines and some squad cars. Holding a press conference to announce that we would form a task force was deemed to be enough to address the problem for now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t think I’d ever be put in the position of saving a kid from the gangs again, but here I was. I had been waiting to hear something, anything about the Mr. Chen case, but nothing seemed to break. Those guns from the apartment mailbox weren’t ready to talk to me, either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So when the midget called and told me that Drew Bai had come into work at the toy store with a black eye and his face all puffy, it was something I felt I could address right away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Drew lived in Confucius Plaza and had to cross Bowery near "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_185",
      "title": "185"
    }
  }, [_vm._v("Pell to get to the midget’s store. But he got jumped and was told to join the gang or next time he would get his face cut. He was talking about maybe making a list for me of all the kids who had assaulted him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, in the minutes it took for me to get to the store, he decided there wasn’t a problem after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to be all right,” Drew said. “Don’t worry about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going to be all right,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you really want to know the names of the kids?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, that would be pretty useless because not only are they minors, but we’d have to establish that they were present.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So it’s a useless situation, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just stay prepared and be smart about where you go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The next time they come, I’m going to have some help with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of help?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of weapon are you going to carry?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m gonna have a gun!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s great. Even if you managed to shoot someone, don’t you think they’ll come at you with two guns?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I’ll join a rival gang.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And then you’ll end up jumping another kid to try to force him to join your gang!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else can I do? I’m not going to be scared to walk around Chinatown. This is my home. At least when you’re in a gang you have some protection. Somebody is watching your back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You remind me of a young man who thought he had no other option than being another stupid gang kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, yeah, I know about Paul. He lives with you now and he’s going to go to Columbia and everything. But you can only help one kid at a time, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_186",
      "title": "186"
    }
  }, [_vm._v("“That’s right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So tell me what I’m supposed to do. I can’t just fade into the background. I can’t move in with relatives in California.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at the midget. He was leaning against the front display case, his jaw set hard. We both knew the answer to the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drew,” I said, “you can’t work here anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t even cross Bowery after school unless you have friends with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need this job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re a smart kid, you’ll find something else. There’s a lot of opportunity right now for a hard worker like you. Maybe you could work at school or work at a place within Confucius Plaza.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was quiet because he knew I was right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, when you go to college, you’re going to have the last laugh because these gang kids are going to be in jail, or in the hospital, or maybe dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take it from Robert,” said the midget. “He was in a gang as a kid and he saw what a lousy life it was. Look at him now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not so sure I’m a good example,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, you’re sort of like the dented can in the supermarket, but you’re all I’ve got right now to show the kid,” said the midget. We chuckled a little bit. “Seriously, Drew, it seems like you don’t have a lot of options right now, but if you play it smart, you’ll see that you really can do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Drew said, “They might come back at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They might,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was thinking about the guy from China who was killed: Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why were you thinking about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was probably ambushed like I was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_187",
      "title": "187"
    }
  }, [_vm._v("“I’m not so sure about that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m pretty certain about one thing, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If he had a gun, he’d still be alive or at least have a better chance of being alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, he wouldn’t. He’d still be dead and there would be one more unlicensed firearm in the hands of criminals. Where would you get a gun from, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard about a guy who sells weapons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He works in this after-school program.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who?!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want to tell you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want another black eye, wise ass?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert!” said the midget. “Enough!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" threw open the door to the BDC After-School Program. The alarm went off again. I couldn’t hear anything but I saw Lincoln at the far side of the room, looking over something on a conference table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t see Sunny Chu, who pushed a flat hand against my gut. For a middle-aged woman, she was tough. I pushed against her and Sunny began to shake from the effort of holding me back. Lincoln managed to cut the alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as it was quiet, Sunny asked me, “What do you mean by busting in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, excuse me,” I said. “I was just going to test the constitutional limits on free speech and the use of excessive force on Lincoln.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did I do?” asked Lincoln.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t listen to him,” Sunny told him. Then to me she said, “Get out! I’m filing a complaint about you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_188",
      "title": "188"
    }
  }, [_vm._v("“You enjoy working that much with someone who sells guns to kids?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He sells what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You heard me. Your cute little thing over there peddles firearms to children. You probably stash them in the apartment mailboxes up and down the street.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a big misunderstanding,” said Lincoln.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What am I not understanding?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tell the kids I sell weapons. When they come see me, I give them this.” He reached inside his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Slowly,” I warned him. He pulled out a red plastic box and held it out to me. I didn’t reach for it, so he turned it over. It was Mao’s little red book. In English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Knowledge is a weapon,” Lincoln said triumphantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("“You’re giving this to kids?” I asked. All I needed to read was the opening page.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("WORKERS OF ALL COUNTRIES, UNITE!")]), _vm._v(" "), _c('p', {
    staticClass: "indent_top"
  }, [_vm._v("“How the hell is this supposed to prepare our youth for today’s job marketplace?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Once they are armed with the words of the Great Helmsman, nobody can stand in their way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not even Mr. Chen, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. He kind of got what he deserved. A traitor of the Revolution.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why are you sitting in this crappy office with your crappy quasi-governmental job? Aren’t you a fully indoctrinated Maoist? You haven’t done shit with your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m working on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you’re working on it. That’s why I’m going to sic some people on your ass. You won’t know what hit you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_189",
      "title": "189"
    }
  }, [_vm._v("“When "), _c('i', [_vm._v("our")]), _vm._v(" time comes, Robert, you’ll be one of the first to know. You and all the running dogs of capitalism.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He actually made me laugh. “I’m a running dog of capitalism? I’m in a union, jackass. You’re a manager. You’re the big boss man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I’m not!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course you are. You work with kids because you like to boss them around and tell them what to think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He yanked back his book. “You don’t get to have one of these.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Too bad you can’t read Chinese,” I said. “The book really loses a lot in translation.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("V")]), _vm._v("andyne and I were sitting in a plain sedan across the street from Lincoln’s apartment. I pulled the tab off a can of Coke. The fizzing sound of the soda broke the silence between us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re kind of quiet tonight,” Vandyne said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My goddamn back,” I said. “I pulled something that night in the gambling parlor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t ever tell anybody you were there. It will be your ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re the only one I told.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne, I was just thinking. Right now, we’re doing the same thing to Lincoln that those Manhattan South guys are doing to Lonnie. Sitting tight, waiting for them to do something to let us build a case against them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a difference, though. Lonnie is innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course she is. As much as Lincoln is dirty. But I can’t help but think that, maybe, he didn’t murder Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not your job! Leave that for the Justice Department to weigh in with their reasonable doubt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I played with the soda tab a little bit in my right hand and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_190",
      "title": "190"
    }
  }, [_vm._v("patted the roof of the car with my left. “Is this it, man? I mean, is this really what being a detective is like? Being trapped all night in this coffin?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to suffer for your art, don’t you know that, Chow?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m no artist.” I turned to Vandyne. “But you are. I mean you could be one. You’re a guitar player and you’re really good!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you for the compliment, but I’m just an all-right guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I punched him in the arm. “C’mon! I’ve heard you play, man!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In all honesty, I don’t practice enough. The other cats who play for a living, they would eat me alive. You have to play every day, or else you just backslide. Just like what you said about learning to read Chinese.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true. You skip a day and everything starts going gray. But wouldn’t you rather be playing guitar than doing this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s too late to do anything else, partner! When they put a gun in my hand, it ruined me for almost anything else. I guess, except for being on the other side of the law.” He pointed his hand like a gun and said, “Pow! Pow! Pow!” as he picked off imaginary targets in the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laughed. “I know what you mean. I’m not going to teach kids how to sing or become, you know, a productive member of society.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So now you’re a part of the freaky fringe protecting decent folk from the sickos and crazies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I played with the soda tab some more. “They should draft people to go through bullshit like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw,” said Vandyne. “I like being here, spending time with you.” He sniffed. “Guess I’m not good enough company for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never said that.” I flipped the tab onto the floor mat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” chided Vandyne. “You’re littering! You know, other people have to use this car. We’re not the only ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_191",
      "title": "191"
    }
  }, [_vm._v("“You polluted the air and the whole insides of the car,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but at least I put the cigarette out in the ashtray. I didn’t throw it on the floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just wait until Jimmy Carter takes office. He’ll put an end to your smoking with his new clean-air laws. Oh, wait, you don’t want him to win.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He could win. Actually, after that stupidity of President Ford with Vernon Jordan, I can’t back him anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In some ads placed in black publications, Gerald Ford was pictured standing next to Jordan, the head of the National Urban League, and other black leaders. Jordan had demanded that the ad be removed, as it seemed like he was endorsing Ford when in reality he was backing Carter. The White House at first denied planting the ads, but later admitted it and put an end to them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne said, “The second I saw that ad, with that opportunist Jesse Jackson in it, I knew it couldn’t be genuine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the guy from Operation PUSH, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know about PUSH? It’s based in Chicago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why is he in New York all the time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly. Jackson does good things, but he’s in it partly for the publicity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A light went off in Lincoln’s apartment. Even though neither of us had been looking directly at the window, we immediately shut up and focused on the building door, waiting for someone to come downstairs and pop out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln came out, shivering in a surplus field coat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That motherfucker,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dressing like he was in Nam,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Lincoln was farther down the block, Vandyne started up the engine and we rolled slowly toward him. Lincoln didn’t go far. Soon, he was back in his favorite restaurant, sitting at a table with his pals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_192",
      "title": "192"
    }
  }, [_vm._v("“This is too much excitement for me for one night,” I said. “I think I’d rather see an empty street than watch people sitting around.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They have to break it up sooner or later, though,” said Vandyne. “When they leave, we can split up and follow the top guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hope that happens soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re all guys. How long can they sit around and talk?” Vandyne eased back his seat. “You’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two hours later, after both of us each had used our own empty Thermos bottle, Lincoln and his friends were still at it. One guy would write something on a piece of paper and pass it around, leading to a round of arguing. Then the guy would cross out what he’d written with exaggerated annoyance and write something else. That led to more arguing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is like watching the drafting committee of the Declaration of Independence,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then they should charge people to watch them and take advantage of the bicentennial year,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These guys are Commies. They wouldn’t go for touristy stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just make them live up to ‘All men are created equal.’ Then I don’t have any problem with it.” He paused. “Now that I think about it, that phrase does have a Communist ring to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We may all start in the same place, but we all take different roads. Some people get handed the maps where everything is marked out and labeled.” Hearing no reaction, I turned to face Vandyne directly. “You know, the map is already marked where all the good and bad stuff is, so you know where to go and what to avoid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne turned to me. “I’m hungry,” he said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me, too. What should we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve got to tough this one out. I didn’t think this would last long, but here we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_193",
      "title": "193"
    }
  }, [_vm._v("“You never hear about cops going hungry. Usually it’s the other extreme.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, you don’t need to tell me. It’s not like you and me need it. We’re in the best shape in the whole squad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see the one with the mean face?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, with the wrinkled forehead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve seen him at the livery-cab office, but I know him from somewhere else, too. I couldn’t find him in our, uh, vacation photo albums.” I hunched my shoulders and leaned forward to get a better look. I saw someone pull on a jacket. “Looks like it’s breaking up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In silence we watched the five men exit the restaurant. The mean-faced guy was a beacon with his orange knit cap on. He went in the opposite direction of Lincoln, who for some reason was headed away from home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mean Face,” said Vandyne, and pointed to himself. I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they were all far away enough, Vandyne and I exited the car and closed our door with clicks quiet enough to have come from ballpoint pens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked north as Vandyne headed west.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln walked quickly, sometimes hopping on his heels. When he reached a dark spot on the sidewalk between two dim streetlights he stopped and turned to the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Should’ve gone back at the restaurant, pal, I thought. I could write you up now for public urination, but I want to save you. I want to see you swing for killing Mr. Chen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He zipped himself up and kept going. His breath in the air looked like an empty thought bubble over his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I followed him as he stepped off the sidewalk onto the street.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_194",
      "title": "194"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" was searching my right pants pocket for a stick of gum when I felt someone tap me on the shoulder. I glanced back quickly and saw Teresa.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You like watching guys pee?” she asked in bad Cantonese. I guess that’s not fair to say because Cantonese, slangy by nature, disregards formal rules of grammar the same way that pedestrians ignore crossing lights in New York.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s my job too,” I said. We didn’t stop walking but we kept our voices low. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m following Lincoln. I think he’s seeing someone else. Why are you following him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who says I am?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want me to call out to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think he killed that Chinese official, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln turned a corner and Teresa and I both picked up the pace so we wouldn’t lose him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He couldn’t have killed Mr. Chen,” she insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where was he that night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honestly, I don’t know. He could have been with someone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m trying to find out now!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then how do you know he isn’t a murderer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He doesn’t have the guts. He only knows how to boss women around. Lincoln talks about socialism and equality, but he’s a chauvinist. If he met the real Communists, they’d execute him with a firing squad of girls!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s keep it down, huh?” We watched Lincoln enter an apartment building on Canal Street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_195",
      "title": "195"
    }
  }, [_vm._v("“I guess that’s what those two extra keys are for,” said Teresa with a sigh.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stopped and fished again for my gum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why are you stopping?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to wait for him to come out,” I said, putting the gum into my mouth. I rolled the wrapping paper between my fingers before tossing it into the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be damned if I’m stopping here!” She marched off to the building. I followed. I might not find a killer, but at the very least I could prevent a domestic assault.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa was stronger than I thought. She ran up the building’s front steps like she was storming a castle. When she reached the door she quickly pressed every apartment button in order two times through before someone got annoyed enough to buzz her in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She held the door for me. “Are you coming?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am,” I said. “You’re not carrying, are you? I don’t want this to get messy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Carrying?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A weapon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just on the remote chance that this was some kind of setup, I made sure always to keep Teresa in front of me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The foyer was a typical Chinatown example, meaning that it probably didn’t meet fire-safety codes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ceramic-tile floor was mostly pulverized, as if people worked out with free weights here and dropped them at the end of each set. Paint was peeling off the wallpaper that was peeling off the tin-sheet wall that was peeling off. At some point a chandelier had been hanging from the ceiling, but now only three curled wires were left, looking like the fingers of a dead witch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_196",
      "title": "196"
    }
  }, [_vm._v("“Where did he go?” Teresa asked as she looked up the stairs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sound like a cop,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That got to her. She took the stairs two steps at a time. The first door had a baby crying behind it. The second door was slightly open to create a breeze to help ventilate the apartment as someone cooked. Sounds of a news broadcast in Cantonese from the KMT-biased radio station came from the third door. The volume was turned up high, so it must have been elderly people listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Try the next floor,” I suggested. Again, I let Teresa take the lead. The heels of her cheap black shoes thundered in the stairwell. I felt a little bad for Lincoln.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first door on this floor sounded like people were playing a game of air hockey. Someone was operating a sewing machine behind the second door. Soft jazz came out of the third door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa turned to me with a questioning expression on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s only one thing soft jazz is good for,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She moved to the third door and the doorknob turned in her hand. Teresa swung open the door. The music was coming from the bedroom. We tripped over some shoes in the hallway and we could hear people laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa yanked open the bedroom door. A wave of smoke came out and the smell brought me back to Nam. It was pot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lights were down low but we could make out four guys all circled around an impressive bong shaped like a standing Buddha.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What the fuck is this?!” cried Teresa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are "), _c('i', [_vm._v("you")]), _vm._v(" doing here?!” countered an indignant Lincoln. He knew it wasn’t going to work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I work two jobs and you use my money to buy drugs!” She pointed at the other four Chinese men. “Do all of you work for a "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_197",
      "title": "197"
    }
  }, [_vm._v("living? Or are you all gigolos and pimps, too?” She was met mostly with snickers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a job!” Lincoln declared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not a job! You play with kids all day! You don’t know what real work is like!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get paid for it, Teresa, so it must be a job!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why are you always asking me for money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get in a tight spot sometimes.” He was backing off. You can’t corner a man about his cash-flow problems in front of his friends without making him feel like a naked little boy. “Let’s talk about this at home,” Lincoln concluded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going home! This policeman is here to arrest you all for drug abuse!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, guys,” I said, stepping out from behind Teresa. “Actually, the charge is drug possession, not abuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, what are "), _c('i', [_vm._v("you")]), _vm._v(" doing here?” asked Lincoln, now even more embarrassed. The only thing worse than getting a dress-down in front of your homeboys was getting dressed down in front of a man you don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m here to save your neck. Now let’s break it up here. The party’s over.” I went to the stereo and switched it off. It was a nice amplifier. A lot nicer than mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The men stood up and groaned and grumbled. “Don’t push me,” I said. “If you don’t want to leave on your own, I can call in escorts.” I turned to Lincoln. “Whose place is this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s our place. We all split the rent on it. We keep the apartment to house friends who come in from out of town. Also, none of us wanted to keep the bong at our own apartments.” With a sheepish look at me, he added, “We didn’t want to get busted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re lucky that I can’t make a case out of this. I’m sure there are all sorts of privacy rights I’m violating by being here right now and I’m not going to try to fight it. But I’m putting you "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_198",
      "title": "198"
    }
  }, [_vm._v("on notice. You work with kids. If I ever see you with drugs again, I won’t rest until you’re fired.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa stepped in. “Get him fired from that stupid job so he can make some real money and be a real man!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not helping things,” I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see,” Lincoln told Teresa, “even he’s on my side!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not on anyone’s side!” I said. I eyed two stragglers in the hallway. “Let’s go, let’s go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When everyone had finally exited the apartment, I set the lock on the door and closed it behind me. I wasn’t thankful for much that night, but I was glad they left the building quietly. Even Teresa and Lincoln walked quickly away, side by side. What was Teresa’s problem?")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met up again with Vandyne at our usual rendezvous point—the stoop of the Fifth Precinct.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not supposed to be sitting on the stoop of the House,” said Vandyne as he walked up to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. It looks bad. Cops loitering past midnight,” I said. I stood up. Vandyne put one foot on the bottom step and looked up at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t want The Brow to find out about this. He’s ready to pounce on you for anything right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He can pounce on this right here,” I said. Vandyne laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a long time, before I started investigative assignments, I was sort of The Brow’s little soldier boy. I used to go to all the community functions to represent the precinct and show that the NYPD really cared about restaurant openings, school graduations, and stupid association banquets. When Izzy went over his head to land me a spot in the detectives’ squad room, The Brow took it as a personal offense that my career had advanced. But now he had a replacement for me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_199",
      "title": "199"
    }
  }, [_vm._v("“How long you think David Ong’s gonna last?” asked Vandyne.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean Ong Kong Phooey?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t make fun of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s making fun of your own people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is not one of my people, and besides, it is a good name for him. Crying on the job and then I’m the one who takes shit from The Brow for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe he is the right guy for that job with that timid personality.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next time someone reaches for something under their seat at one of those banquets, David’s going to pull out his gun and start shooting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We shared a good laugh; then we got back to business. I told him about the Lincoln-and-Teresa adventure. Vandyne told me about how Mean Face simply went home—and also why he looked familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There had been a group affiliated with the Communists that had been protesting the tour buses that came in and dropped off tourists so they could act like ugly Americans in their own country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These tourists would do obnoxious things such as sticking cameras into people’s faces and taking flash shots. They also felt they had the right to touch the hair of little girls as if there was a sign hanging from the lampposts that read: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MOTT STREET PETTING ZOO.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The KMT-affiliated tour company that operated the buses was incensed that the protest group would greet arriving buses with signs that read: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GO BACK TO EUROPE!")]), _vm._v(" Naturally, these tourists were herded to patronize KMT-affiliated restaurants and gift shops, and if they felt unsafe, they wouldn’t spend as much or come back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_200",
      "title": "200"
    }
  }, [_vm._v("The next time the Communists showed up to protest the buses, a pick-up group of KMT youths stormed in and a street fistfight broke out. In the confusion, one Communist kid was hit by a bus that was trying to back up. That kid was Mean Face.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne, did he get broken or bruised ribs?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember, either. But the bus driver wasn’t charged.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we should call him ‘Baby Bad Ribs.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s funny, but I like ‘Mean Face’ better. It’s more to the point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should we eat, man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne patted his stomach. “I still got it pretty bad. Let’s make it quick. I want to get the paperwork done and hit the sack. I got a big day tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s going on tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rose finally agreed to meet me for lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow, that’s great news,” I said, not inquiring further.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met Mr. Song at the ground-floor conference room at Together Chinese Kinship’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you have to tell me?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was just thinking,” I said. “Are there any fringe Communist groups that would want Mr. Chen’s killer dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn, you just come right out and say what’s on your mind, don’t you?” He shook his head. “I’d be lying if I said a great many Communists weren’t relieved Mr. Chen is dead. There are a few who are very unhappy about it, but I doubt they would take any action.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m as sure as I could be, which is to say about ninety-five percent sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Five percent is a pretty big margin of error.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, Robert, the Communist Party is asking for your help in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_201",
      "title": "201"
    }
  }, [_vm._v("clearing their name in the murder. Why would they use their other hand to invalidate that work? If the Communists were implicated in killing the murderer, it would look like they were covering their tracks. We need that man brought in alive!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are there Communist agents in Chinatown now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song gave me a sour look. “And what constitutes a Communist "), _c('i', [_vm._v("agent")]), _vm._v(", Senator McCarthy? We prefer the term ‘comrade.’ We have many comrades in Chinatown. Our numbers are less than those loyal to the KMT, but in a way we regard them as comrades as well. All Chinese are involved in class struggle, whether they know it or not. Even you, Robert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, I’m asking you about fringe groups because I know the other side has radicalized elements that are looking for someone’s head. They regard Mr. Chen and Li Na as heroes for challenging the mainland.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song tugged a handkerchief from his pants pocket and blew his nose. He folded the handkerchief and left it on the tabletop. “Let me tell you about heroes, Robert. When privileged individuals in China worry that they will lose their status and seek to set themselves up in America, with a protected position, these people are not heroes. They are bandits. They are no different from the KMT soldiers who looted treasures from the museums of China as they made their cowardly retreat to Taiwan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re forgetting that Li Na is the daughter of Mao.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is the daughter of evil Jiang Qing, too! She holds none of the Great Helmsman’s cultured qualities. A mere blood relation to a great man has elevated her status for years. But now that Mao has passed away, a reckoning is on the way, and it will not be kind to Li Na.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It wasn’t kind to Mr. Chen, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chen has benefited from his ties to the Li Na clique. He "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_202",
      "title": "202"
    }
  }, [_vm._v("would have also been reevaluated had he not had the misadventure of coming here.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But make no mistake. He was not killed by a Communist. We are not brutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you would have tortured him and sent him to a labor camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Reeducation camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What could he possibly learn there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Song smiled and stuffed his handkerchief back into his pocket. “The bitterness of life that we sometimes forget.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("R")]), _vm._v("obert, are you stupid?” the midget asked for a second time. We were crowded into his toy store’s stockroom. He was halfway up a shelf on a ladder, so we were eye-level with each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I already said that I wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why the hell do you continue to visit Mr. Song?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m just looking for clues.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going to find any there! I also know you saw Mr. Yi at the Taiwanese office in Midtown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have sources all over. From running this store, I know all Chinese people who have kids. And all Chinese people have kids. But listen, if I could find out where you’ve been, almost anybody could.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No you’re not! There are some ruthless people out there and they wouldn’t think twice about killing a cop, especially a stupid one!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop calling me ‘stupid’!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then stop acting stupidly! Every time you step into and out of Together Chinese Kinship or the Taiwan office, you’re telling "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_203",
      "title": "203"
    }
  }, [_vm._v("the world, ‘Hey, I support this political stance!’ A Chinese cop on the wrong side would be worth more dead than alive in this propaganda war. Particularly now. You could be killed just to send a message, Robert.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Both the Communists and the KMT are desperate. The Commies want that official diplomatic relationship with the U.S. and want Taiwan out right goddamned now. The KMT has threatened to join the Soviet Bloc if America severs ties and recognizes Beijing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way in hell would that ever happen,” I said. “Chiang Kai-shek founded the International Anti-Communist League!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know your history, Robert! The KMT’s early advisers included Russian revolutionaries. Chiang’s own son lived there for many years and even married a Russian woman. Although the KMT did break ties with the Soviets, there is no one else apart from the U.S. who could feasibly offer Taiwan protection should the mainland attack.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I still can’t see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course "), _c('i', [_vm._v("you")]), _vm._v(" can’t,” grumbled the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you give me a break? My Lonnie’s neck is on the line here. I would pray to both Mao "), _c('i', [_vm._v("and")]), _vm._v(" Chiang if I thought it would help me with the case. But before it comes to that, if you could offer any thoughts, I would really appreciate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget came off the ladder and slapped his hands clean on his slacks. “This is what I think,” he said. “I think whoever killed Mr. Chen is reckless. This was not a planned killing. You don’t plan to murder somebody by bashing him in the head. Blood gets all over your clothes. If you really wanted to take somebody out, you use a gun from a distance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wasn’t that part of the message, though? That Mr. Chen wasn’t even worth the cost of a bullet to kill?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I seriously doubt it. If the intention is to kill, there’s no surer "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_204",
      "title": "204"
    }
  }, [_vm._v("way. You don’t know how hard heads are. You could pound somebody as hard as you could with a baseball bat and he might be able to run away, screaming bloody murder.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if your victim was restrained?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Mr. Chen wasn’t, was he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I figured.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Could his own guards have killed him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were contractors with the U.S. government. I seriously doubt they had the motives or initiative do so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This was not a professional hit. It was a personal or political act. Maybe both. So keep an eye out on extremist groups and extremist people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The only one I’ve met so far is that guy Lincoln from the Union of the Three Armies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That stupid group? You know they’ve been recruiting kids to spray-paint their name all around Chinatown?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Could they be responsible for murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do kids know how to swing a bat?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("S")]), _vm._v("trangely, Paul looked distraught when I came home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where were you?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was at Great Adventure. They have this really cool water ride they only open up after midnight, and it’s for cops only.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you done?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw. I’ll probably go tomorrow night, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul stared at me, frowning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, stop it,” I said. “You’re killing me with that face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie wanted to talk with you. She’s having a hard time at work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_205",
      "title": "205"
    }
  }, [_vm._v("“Her editor is rejecting more of her stories. She used to write four or five short wire stories daily. Now she hasn’t had a byline in two days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I called Lonnie and she answered on the first ring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, I think I’m going to lose my job! Instead of firing me directly, they can keep rejecting my stories so my editor can say I haven’t been productive enough. I’m not a part of the union yet, so I don’t have any support.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those motherfuckers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you found something out yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I sort of have a lead, I think. I’m trying as hard as I can. You know, I’m trying to top Manhattan South’s best detectives and it’s tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw the Chinese U.N. representative in the hallway and he ran away to avoid me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a political issue, Lonnie. The People’s Republic has a news blackout on Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie sighed into the receiver. “I should go back to the bakery to work. Maybe the harassment would stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you can’t do that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess I was never meant to leave Chinatown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You stay at the U.N., Lonnie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know what it feels like, Robert! I’m writing and rewriting stories all day that aren’t published. I feel completely useless!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I promise you, I’m going to help put an end to this. I’m going to sic the detectives on this other guy instead of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You already found a suspect?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have this guy in mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think he did it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_206",
      "title": "206"
    }
  }, [_vm._v("“I don’t know. But he’s a more likely suspect than you. He was protesting Mr. Chen at Jade Palace and he also said that he got what he deserved.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a terrible thing to say. Mr. Chen was not a bad man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This suspect I have in mind—apart from being a loudmouth, he treats his girlfriend lousy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think he did it, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He could have done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want you to switch the suspicion on to someone else who’s innocent. I know how it feels and it’s awful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d rather they focus on anybody else but you. Even me. But it won’t be me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to find the killer, Robert. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul walked into the bedroom as soon as we were done talking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Paul, were you listening in or did you want advice on what to wear for Halloween?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t do that stuff anymore. Besides, Halloween is on a Sunday. That’s a study night.” He crossed his arms. “I’m worried about Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything’s going to be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re just saying that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not just saying it. I believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("ord had gotten to us that the American Civil Liberties Union was preparing a lawsuit over our practice of taking Polaroids of suspected gang kids.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The detective squad hid the cameras in the highest kitchen-supply cabinets. We stashed the photo albums in our bottom drawers, pretending they were our personal photos. I realized that I didn’t have many genuine pictures at all. I couldn’t even fill up a single album.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_207",
      "title": "207"
    }
  }, [_vm._v("Of course, I would be the most suspicious out of all of us for having these albums in my desk. A Chinese guy taking tour pictures in Chinatown? No way. Maybe the Upper East Side or Central Park.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the cameras gone and access to the photo albums now shut down to the rest of the precinct, we had to readjust our operations to keep tabs on suspicious characters. The new methods were going to test our limits. English fished out a thesaurus from Lumpy’s desk and gave it to me before we went out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because Vandyne was helping me out with tailing Lincoln, I backed him up on the latest crap assignment, which was writing down detailed descriptions of youths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sat on adjacent benches at Chatham Square, where Bowery, East Broadway, Worth, Division, and Mott all met up. Neither of us wore gloves so we could write with our bare hands. We each had a cup of hot coffee to pass between our fingers to keep warm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Kimlau Memorial Arch towered above the square. The arch itself didn’t say what had happened to Lt. Benjamin Ralph Kimlau, a Chinese American who had fought in World War II, but I knew that the Japanese had shot him down. I’d be mad at Japanese people but I knew a lot of Americans of Japanese descent had also fought bravely in the war. Paul told me that groups of Japanese Americans were rounded up into internment camps for the duration of the war, but I didn’t believe him entirely because I had never read about them anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chatham Square was a good place to get a look at the kids walking around because it was close to Drew’s home, Confucius Plaza, the biggest subsidized housing project in Chinatown. The project itself was to the north on Bowery above Division.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the square we were close to the active gang boundaries near Confucius Plaza. On top of that, Bowery was the unofficial border "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_208",
      "title": "208"
    }
  }, [_vm._v("between KMT-affiliated Chinatown, to the west, and Communist-affiliated Chinatown, to the east. More tourists were on the west side, but the growth was on the east side, where the liberal-minded and college-educated youth bought up Mao badges from the Cultural Revolution to wear to their comparative-literature classes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was usually a lot of action in this border zone. The Pagoda Theater nearby on Catherine saw shootings as regularly as the weekend matinee was changed. I also thought about poor Drew’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The guy in the blue ski jacket,” said Vandyne. “Would you say he has a skinny face?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a second,” I said, as I paged through the thesaurus. “I would actually use the word ‘lean.’ That seems like the right word. Chinese people have extra fat in their cheeks so I would never say that one had a ‘skinny’ face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne measured up his guy against markings on a nearby streetlamp pole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Vandyne’s suggestion we used pieces of duct tape to mark out heights of four, five, and six feet on poles, signposts, and building corners. Now we could get good approximations of height to go with our otherwise abysmal descriptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s Mean Face,” I said, tipping my head in his direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There he is,” said Vandyne. We watched him push up his knit wool cap and scratch his forehead. “If anybody ever says a guy with a mean look on his face did something, we’re going to swing by and pick him up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He drives a car, so we should call and make him pick us up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly. Why should we waste the gas? Goddamn sixty-five cents a gallon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa! I’m glad I don’t have a car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_209",
      "title": "209"
    }
  }, [_vm._v("“If you did, then you could take Lonnie out for a weekend trip.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A trip where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, there are some really nice gardens to go see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gardens?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Out in Pennsylvania, the guy who founded DuPont set up a huge garden that covers his estate. It’s open to the public and it’s a nice place to take a girl. I’m only mentioning it because I’m going to be taking Rose there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was so happy I nearly fell off my bench. “That’s great, Vandyne. I guess lunch went pretty well?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, it did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you guys are figuring on getting back together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe, man, maybe. We’re just going to take it really slow. I think getting out of the city will help give us perspective.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. The last time I saw Rose it was a few months ago in a Chock Full o’Nuts and she was crying to me that she and Vandyne never talked anymore. Not too long after, she left Vandyne in Elmhurst, Queens, for her sister’s home in Manhattan, a four-story brownstone with a view of the Hudson. The sister was married to a Chinese-American doctor who probably went to Midtown for Chinese food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You guys have already met up a few times in the city, right?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Few times. I think the best time was going to see Labelle in concert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That must have been great. I’ve heard those three girls go crazy onstage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should have seen the outfits they had on, it was nuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I noticed that Lincoln was walking toward us from East Broadway. When he saw us, he picked up the pace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_210",
      "title": "210"
    }
  }, [_vm._v("“Aw, shit. This guy’s gonna give us away,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey you guys,” said Lincoln. “Thanks for following me around and harassing me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re harassing you?” I asked. “You came running up to us. We’re sitting here by ourselves minding our own business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what you’re doing. You’re taking pictures of kids. You’ve already convicted them in your minds just like how you’re trying to set me up for the murder of Mr. Chen!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m also gonna pin a few more murders on you, Lincoln. All the cases I can’t solve.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There must be a lot of those.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go back to your bong, Lincoln.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pointed to the thesaurus in my hands. “Reading on the job, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a thesaurus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find a synonym for ‘pig.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne spoke up. “Listen, Lincoln. For your information, I want you to know that it’s probably best not to give us grief. I’m a fairly rational person but my partner here can be provoked pretty easily.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re threatening me? We’re both people of color being oppressed in a capitalist prison run by whites. You need to see things as they are, brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you ‘brother’ me!” snapped Vandyne. “Chow’s my brother, not you!” Lincoln shook his head and walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hearing Vandyne say that made me feel good. I hoped as hard as I could that things would work out with Rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sipped my coffee and looked for stupid gang kids that I could write lean descriptions of.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_211",
      "title": "211"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" think I’m going to have to find a new job, Robert,” said Paul. We were at the Chatham Square Library. I was reading through back issues of Chinese-language newspapers to see if there was something I had missed that could be crucial to Mr. Chen’s case.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would you have to find a new job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Think about it. If Carter wins, then there’s going to be a big push into alternative energy. Solar energy, wind energy, and geothermal energy. We’re going to cut way back on fossil fuels, and that means less money for oil exploration. That’s going to zap the research funds for my department at the geological observatory.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be ridiculous. This country is always going to need oil like it needs doctors and lawyers. Your friendly local oilman isn’t going to cut back on research. He’s looking out for the next big oil patch.” I felt something hit my foot. It was a toy car. I kicked it away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They won’t stop their own internal research, but they’ll cut the public research they fund. For the sake of public appearances, they’ll reallocate those funds into solar-panel research and wind turbines. The oil companies will even take out big advertisements saying how they’re actively researching renewable energy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re paranoid, Paul. Nobody is ever going to think a big oil company is seriously looking into something that will make it extinct.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If the political tide turns against your company or your entire business sector, you don’t have to change what you do if you can change the public’s perception of your company.” He looked thoughtful. “Maybe I should be studying communications.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you should be communicating less so that I can read in silence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made a face and opened another book. I wondered about "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_212",
      "title": "212"
    }
  }, [_vm._v("Paul’s generation. He and his friends could speak Cantonese fairly fluently, but I didn’t know anybody his age who could read Chinese characters. In fact, I was the youngest person I knew who could. That meant that I was among the last of the Chinese Americans who could read the language of his ancestors.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I guess I could try to help Paul learn it, but I had been a lousy student and that probably made me an even worse teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I read through several days’ worth of the KMT-backed newspaper and got almost nothing new. The Communist-backed paper continued its blackout on Mr. Chen’s death. The Hong Kong–backed newspaper had news only about celebrities and businessmen, and Mr. Chen had been neither.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t was early morning and I was on my way to the precinct when I saw Mean Face a few yards ahead of me. It was too good a chance to pass up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I followed him down to the corner and then came around to the exit of a three-level garage where the dispatch-car companies kept their Lincolns Continentals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried not to smile. This was where my gang used to prowl, one of the best places to hack off “Continental” emblems. That was how we got our name, and collecting emblems was a way to solidify our collective identity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were all U.S.-born kids and when the immigration laws changed in the early 1960s, all these other kids came in from Hong Kong and tried to push us around. There was nothing like beating someone up and leaving a Continental emblem shoved in their belt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Hong Kong kids weren’t stupid, though. They got in good with the associations and pretty soon they had nice clothes, nice hair, and guns. The Continentals faded away because we knew, as native English speakers, that we weren’t going to be "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_213",
      "title": "213"
    }
  }, [_vm._v("trapped in Chinatown the rest of our lives. These streets weren’t worth a fight to the death for us.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t want to kill anybody until I was in Nam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I ducked into the parking garage and looked around. The stairwell was where I remembered it. My eyes fell upon Mean Face, who was sitting on a concrete bumper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I said. “Don’t I know you from somewhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t have to pretend, Officer Chow. I know who you are. You know who I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know who you are but I don’t know your name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Call me Lee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right, Lee. Are you loitering here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to play that game?” he asked, rising to his feet. “Fine with me. I won’t tell you what I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I don’t know where the guy with the mole is, the driver you’re looking for, but I do know someone you might be looking for even more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I know who killed that diplomat guy from China.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who killed him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve been following him around! I’m surprised you haven’t been able to shake it out of him. It’s Lincoln!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know? You were there with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee shifted his weight and crossed his arms. “You keep pushing me like this, I can stop right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, I only said that because you’re his second-in-command, aren’t you? You play backup at the Union of the Three Armies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He narrowed his eyes. “We’re co-leaders of the group. Equals.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Except you never killed anybody, right? The worst you ever did was throw snapper pops at tourists.” Those were the Chinatown novelty toys, crystals wrapped in paper, that made "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_214",
      "title": "214"
    }
  }, [_vm._v("loud popping sounds when they hit the ground. A tourist would think someone was firing a gun at their feet, trying to make them dance. “You drew an assault charge from that, didn’t you, Lee?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was dropped in exchange for an apology!” He crossed his arms. “After that, I stopped protesting the tourist buses and got a real job, driving cars.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wish more of our shiftless young men followed your example. So what were you going to tell me about Lincoln?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it’s just that after the killing, a few of the guys in the group were sort of wondering about Lincoln. Where he was that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wasn’t with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We were waiting at the usual spot. OK Noodle. You know, where you were watching us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You saw me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw, I didn’t. Teresa told me about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you guys were all sitting around, eating and waiting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, mostly waiting because it was his turn to treat. Luckily we’re regulars there, so they let us put it on a tab, but still . . .” Lee shook his head and dug his hands up into his armpits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You don’t screw over Chinese people when it comes to food or money, and certainly not both. You’ll hear about it every day for the rest of your life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So Lincoln was AWOL,” I said. “Then what did you guys do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everyone went home, but I was worried. This was probably two in the morning at this point. I stopped by his apartment and he wasn’t there. Teresa said he hadn’t been in all night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I waited with Teresa because she was so worried. She was freaking out, man. And that motherfucker never came back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_215",
      "title": "215"
    }
  }, [_vm._v("“When was the next time you saw him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not until the next day, in the afternoon. He came to the food cart where I always get my lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Division and Bowery. The old woman who runs it has Hakka food like pork and fermented tofu.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yuck. Why do you want to eat Hakka food?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee gave me a hard look. “Because I’m Hakka.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And so is Lincoln, even though he can’t speak Hakka.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Hakkas have a long and proud history. You people are really hard workers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hakkas were originally a migratory tribe in central China that later settled in the southeast and in Taiwan. Of course, the people already living in the areas that the Hakkas settled in regarded them as barbarians who only happened to know how to bathe and clothe themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hakkas seemed to have a knack for being at the forefront of political change. Sun Yat-sen and Madame Chiang Kai-shek were Hakkas. So was Mr. Chen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The funny thing is that the casual Cantonese observer can’t tell if someone is Hakka by appearance or even surname. Hakkas maintain their identity through their unique culture, which includes the Hakka dialect and their food. It is hidden like a secret power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what the problem is with Hakka food?” I said. “It’s way too salty. That’s bad for your health.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s salty because Hakkas were always manual laborers and you Cantonese forced us to live on the land that was hardest to farm on. We used to sweat so much we needed to eat salt to get it back into our system.” Lee looked me in the face. “You "), _c('i', [_vm._v("are")]), _vm._v(" Cantonese, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_216",
      "title": "216"
    }
  }, [_vm._v("“I consider myself Chinese American. But let’s get back to your Hakka friend, Lincoln. You saw him at the salty food cart and then what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I asked him if he had heard about Mr. Chen. By then, it was all over the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did he react?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, even before I asked him, he was looking terrible. His eyes were bloodshot and he was acting all jumpy. I asked him why he didn’t come to the restaurant and he told me to tell everyone that he was sick and spent the night at my place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you tell him that you were over at his place? With Teresa?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told him I stopped by. Let’s get something straight right now. I would never mess around with Teresa.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because she’s not Hakka?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. A good Communist respects personal relationships. We don’t sleep around like Chiang Kai-shek and other dissolute KMT officials.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought about all the rumors of Mao and illiterate peasant girls but I decided not to bring it up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” I asked, “what makes you think he killed Mr. Chen? Just because he didn’t make it home doesn’t mean he’s a murderer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He has been saying over and over that Mr. Chen should be executed for being a traitor to the Communist cause.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Talk’s cheap.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When I saw him he was wearing an outfit he kept at our little clubhouse. He must’ve changed clothes there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Teresa said her rolling pin was missing. Lincoln must have taken it. And used it. You should search our clubhouse. You might find some bloody clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_217",
      "title": "217"
    }
  }, [_vm._v("“I’m not sure I believe you. If I check with Teresa, is she going to say the same exact things as you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She might not want to talk to you at all.” Lee rubbed his hands. “You have a bad reputation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wouldn’t think cops would be too popular among you revolutionary youths.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know that Teresa works at a restaurant, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t, but thanks for the information.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was a server at those big community banquets for a lot of years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh,” I said. I stuck my hands in my coat pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She said that you barely seemed conscious, and your breath was practically flammable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was a long time ago. I’m not that way anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, she did say that when you dropped in on Lincoln you seemed like a new person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to check in on Teresa. Thanks for ratting on your friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m betraying a man but I’m true to the cause. I draw the line at violence.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t was almost noon when Vandyne and I got to Teresa and Lincoln’s apartment. She answered on the first ring and buzzed us up. When she opened the door, she said, “Oh! There are two of you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you alone?” I asked. I used English because her Cantonese was as bad as my Mandarin. Also, I wanted Vandyne in on the act, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lincoln is at work,” she said, spitting out the words like they were candy gone bad. “Lee told me you would be coming over, but I thought you’d be alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_218",
      "title": "218"
    }
  }, [_vm._v("“We have a few questions about Lincoln,” said Vandyne.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You talked to Lee, also?” she asked Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow did,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never thought Lincoln was cheating on you at all,” I said. “You think he murdered Mr. Chen. But I can’t figure out if you were really checking up on Lincoln or following me to warn him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you think?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just told you what I thought!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. I did not think Lincoln killed Mr. Chen. Until Lee told me his story. Lincoln and his Hakka friends are out of control! They all think they are Sun Yat-sen, but they are really a bunch of irresponsible jerks!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even Lee?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lee is the least bad. At least he is in a job with some future. Someday he is going to own the car he drives and then the real money will come in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something I wonder about you, Teresa.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your English is really good, especially for someone who just works in a restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take that as a compliment,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I work hard,” said Teresa. “I practiced English two hours every day when I got here. I listened to language tapes from the library instead of music.” To Vandyne, she added, “I really like black music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of black music?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The dancing kind!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Teresa,” I interjected, “why didn’t you come to us before? Lincoln wasn’t in that night and your rolling pin was missing, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is still missing!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_219",
      "title": "219"
    }
  }, [_vm._v("“How come you didn’t tell me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was not sure! I wanted to make sure!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How were you going to make sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was going to make Lincoln confess!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne cleared his throat. “What if he tried to keep you quiet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody keeps me quiet!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I mean, dead quiet,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. He could not do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" then did something I should have done even before seeing Teresa. I checked up with the Department of Motor Vehicles to see what kind of guy Lee was. After a confusing phone call, I hung up and looked at Pete, who was sitting at his desk cleaning out one of his ears with the eraser end of his pencil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Pizza Man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A funny thing happened when I called the DMV to check up on someone’s driving record.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They told me to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. Who was it about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This Chinatown livery-cab driver named Lee. He has a number of outstanding parkers and movers—enough violations to lose his license, apparently.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I gotta keep that guy driving, Chow. He gives me a lot of good info.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was the last thing he tipped you off about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mainly tells me about suspicious people he picks up and where he takes them to. I busted a smuggling operation that was sneaking in dried fungus and animal parts because of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember that thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_220",
      "title": "220"
    }
  }, [_vm._v("“Of course you do. Probably the first time ever that a dried tiger penis was shown at a press conference. Now, why are you looking into Lee?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, he told me something. I wanted to see what his record was like. I only knew about him protesting buses and harassing tourists.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got news for you. Back then he was one of my guys, too.” Pete narrowed his eyes and tilted his head. “He told you something, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. You know his pal Lincoln? They’re both in the Union of the Three Armies, that fringe Commie group.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve heard of the group, of course, and I think I know who Lincoln is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lee seems to think that Lincoln killed Mr. Chen. He told me some bloody clothes might have been stashed in the group’s apartment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete pushed his seat back and stood up. “Let’s go get him now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t have a warrant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t need one because he’s going to open the door and show us around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess he’s never given you bad info.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He picked up his coat from the back of his chair and punched his arms through the sleeves. “Only one time, and then I showed him not to fuck with Pizza Man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete told Lee on the phone to meet us at Bowery and Canal by the Manhattan Bridge on-ramp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee brought Pete, me, and Vandyne back up to the apartment where I had met Lincoln and his bong buddies. I spoke some Cantonese with him, but because we were in mixed company, I told Lee to switch to half-decent English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Second time you come here, huh?” Lee asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_221",
      "title": "221"
    }
  }, [_vm._v("“Second time’s the charm,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why were you here before?” Pete asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I saved Lincoln’s life that night. His girlfriend was ready to kill him. She thought he was stepping out on her. Turns out she never knew about the little boys’ club they have here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne went in first. “You don’t still have marijuana in this apartment, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no no no,” insisted Lee. “Never have, never have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I snorted. “Where are the bloody clothes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know where he hide. Somewhere inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We split into three teams. I took the kitchen. There was little but bottles of spices and beer in the refrigerator. Vandyne took the tiny bathroom and the hallway closet. Pete searched the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We met up again in the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got nothing,” said Pizza Man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Same here,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I threw up my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That means it has to be in the living room,” said Pizza Man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s nowhere to hide anything here,” I said. “There aren’t even any cabinets or drawers around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The room held only a couch, a TV, a coffee table, and four befuddled men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He must hide in apartment,” said Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know where they are, do you?” Pizza Man asked him. Lee shook his head. “If you do, you’re an accessory to murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne walked over to the couch and picked up a seat cushion. “This has a foldaway bed in it, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” said Lee. “Maybe he hide there!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we had the couch open, we unfolded the first section "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_222",
      "title": "222"
    }
  }, [_vm._v("and there was nothing. The second section also yielded nothing. Vandyne and I were folding the mattress back in when Pete spoke up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, there’s something down there!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We pulled the couch away from the wall, revealing a cardboard box that had been shoved between the back of the couch and the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete grabbed the box and opened it. It was stiff with dried blood. A rolling pin caked with blood fell to the floor with a thump. A watch was wound around it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You got him!” said Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete closed in on him. “How do we know Lincoln hid them there and not you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t hide! Lincoln hide!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then we need you to testify in court to this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No! You say I don’t go to court.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m only kidding, buddy! This is real good work you did for us today. Let me ask you one more question. How come you went to Chow and not me with this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why did you tell Robert Chow and not tell me to my face what was going on, my little sheep?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete punched Lee hard in the stomach, knocking him to the ground. “I told you that you only talk to me, you little fuck! Get it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, now!” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, nothing! Don’t take it personally, Chow. It’s just that I’ve been cultivating this guy for years; I need for him to keep me in on the loop on things like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it helps at all, I was the one leaning on him for info,” I said. Lee rose to his hands and knees and I wanted to give him "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_223",
      "title": "223"
    }
  }, [_vm._v("more time before he could reasonably defend himself or run away.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bullshit, you pushed him! I’ll let it go this time, Lee, but remember, ‘When Lee see or hear something, he come to Pizza Man.’ Get it?” Lee nodded. “Still, I might need you to testify in court. Then again, maybe I don’t need you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete got on his radio and notified Manhattan South of the situation. They were over in about fifteen minutes. I read the watch inscription for forensics. It was only a few hours later that they had a warrant to arrest Lincoln and they picked him up right off the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard that that punk acted like he had no idea what was going on.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he recovery of Mr. Chen’s watch, Lincoln’s bloody clothes, and an unspecified weapon caused a sensation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("NYPD Commissioner Michael Codd held a press conference to say that a suspect had been apprehended in the murder of the Chinese official. The NYPD press office issued a correction the next day to say that Mr. Chen had come to the United States as a private citizen and was not an official of the People’s Republic, nor was he acting in an official capacity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I read that Lincoln had been arrested but had been allowed to post bail, I got worried. Teresa had a restraining order on him, so he holed up at his co-manager Sunny Chu’s apartment in Brooklyn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t find out where that was exactly. I showed up at the BDC After-School Program office and told Sunny that Lincoln would be safer in jail, but she only gave me two stink eyes. I thought she didn’t like him, but maybe she was one of those women who had a thing for murderers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She complained to the Fifth Precinct, so I got another "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_224",
      "title": "224"
    }
  }, [_vm._v("earwax-clearing lecture from The Brow about harassing the people we were supposed to be serving. I stared at nothing on the opposite wall and wondered if maybe Lincoln would be smart enough never to leave the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln must have known he was in trouble, too, because when they found him on the sidewalk, he had two layers of metal from bean-curd buckets wrapped around his chest and back. That would have worked fine against the crappy Saturday night specials that gang kids had, but it did nothing to stop the three .44 magnums that tore through him, probably fired from a rifle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His improvised protective vest was probably worse than nothing because it meant more metal shards ripping through his organs. In any case, he wouldn’t have survived, with or without it. His unknown assailants must have wanted to get him badly because they had gone all the way to Brooklyn to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How the assassins found him, I wasn’t sure. But bad guys get more and better info than police because they pay people to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t’s not a priority case when something unfortunate happens to a guy who has basically been convicted in the press. Put the cellophane wrap on that one because it’s headed for the cold-case file. The murder of a murderer in Brooklyn? Yeah, they’ll get right on it, ha-ha. The guy wasn’t even good-looking, for crying out loud, and his girlfriend had that restraining order on him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re sure he’s the one who did it?” Lonnie asked me. We were sitting in a coffee shop at the United Nations eating warm and damp croissants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Based on what I know,” I said, “Lincoln seems to have been our man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you didn’t have any witnesses to the murder!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure some people would have come forward after seeing his picture in the news. Anyway, I don’t want you to worry one "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_225",
      "title": "225"
    }
  }, [_vm._v("more second about this crap. It’s over and you’re cleared. Just get back to work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I wanted to cover his trial for the newswire!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look at all the important work you have to do here!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another press conference about another pointless meeting where another useless agreement was or wasn’t reached.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t put down your work,” I said, saying the words firmly so that I believed it as well. “Your job is important and there are people counting on you. What seems stupid to you could mean a lot to someone reading what you write.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, I know, I should appreciate what I have.” Lonnie wisely decided not to finish her lousy croissant and chose instead to tear it into pieces as she talked. “I could still be back at the bakery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s my girl,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met the midget for dinner at a Buddhist food restaurant. Essentially the restaurant’s clientele was composed of practicing Buddhists and regular people in mourning. Also, there were a few diners who had gone to a temple for help and were told to avoid eating meat for a week and to make a donation to the temple to make the prayers more effective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The restaurant used tofu, wheat gluten, and other shudder-inducing ingredients to fashion meat substitutes. Mock ham fried rice. Mock beef chow fun. Mock duck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wasn’t Mock Duck one of the old Chinatown gangsters?” I asked the midget. “When I was a kid, there was a ghost story that you could hear his chain mail armor rattling around Doyers Street at midnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet he was a real hero to you when you were in a gang, Robert.” The midget paused to sip some tea and grimace. “Jesus, even the tea tastes fake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_226",
      "title": "226"
    }
  }, [_vm._v("“Why did you want to eat here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like a change of pace every now and then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From good food?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to eat here, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I guess you do.” The midget said nothing. “Seriously, can’t you tell me what’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midget dismissed me with a wave of his hand, but the waiter thought this meant we were ready and came to our table. He was wearing a plaid vest over a dirty Tshirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you, my friend,” he asked the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m healthy. Maybe too healthy to have to eat here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m assuming you’ll want the usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The usual?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gluten spare ribs and bean-curd fish, with brown rice,” said the waiter, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why is he eating here?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have the best food. He’s been coming in once a week. Oh, and what will you have?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll have the same,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll be sorry,” muttered the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The waiter smiled as his eyebrows shifted into a worried look. “May I suggest something else so that you can try a wider variety of the menu and share dishes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I want the same thing as him,” I said. The waiter nodded and left. “Tell me why you’ve been coming here! You obviously don’t like the food. Is there a cute waitress or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I sort of lost a game,” he said to the floor. This was big news. No one had ever beaten him at anything ever. The midget was the master at chess—both American and Chinese, checkers, board games, and, hell, even pinball, I’d bet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You goddamned lost at something!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_227",
      "title": "227"
    }
  }, [_vm._v("“No. I said, ‘Sort of.’ This kid who is actually a pretty good toy customer was bragging that he could beat me at Connect Four. I said he couldn’t. So then he bet me a free dinner at his parents’ restaurant every week for a month if I won. I said he could have a twenty-dollar gift certificate if he beat me. Really, I only agreed to play a game with him to get the boy away from the display case he was blocking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should’ve asked him what restaurant his parents owned.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I was planning on just saying, ‘Forget it,’ you know? So after I won, I said, ‘Forget it.’ The kid was crying his eyes out. He had no idea he was going to lose. But he also said that a bet was a bet and if I didn’t take him up on it, the win didn’t count.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had to go with the spoils of the win, the kid was right. But now that I think about it, he had the inside angle all along. He knows the food sucks here. He’s always got beef-jerky breath.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our food swung in quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” I said. “You don’t have to actually eat it, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not one to try to weasel my way out of life’s tougher lessons. In any case this will probably prepare me for necessary humility the day when I really lose a game.” He picked up a fork and began to flake up the bean curd that was shaped like a fish fillet. We both began to take tentative bites.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The guy who was shot in Brooklyn,” said the midget. “Did he kill Mr. Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have the best kind of evidence—circumstantial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Humph. Seems pretty awkward to kill someone with a rolling pin. Especially out in the street.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_228",
      "title": "228"
    }
  }, [_vm._v("“It might not have happened in the open.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who knows? We haven’t found the actual scene of the crime yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know who killed Lincoln?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. John Wilkes Booth.” For the first time that night I saw the midget’s familiar smirk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re so funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you’re the funny one. You think that because you now got Lonnie off the hook everything is fine. There are still a lot of unanswered questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Chinese government doesn’t care. The Taiwanese government doesn’t, either. Both the Chinatown KMT community leaders and the Communist groups are happy with Lincoln dead. In my mind, this means that the case is closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if Lincoln was innocent?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t even get to go to trial. You have no idea what would come out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s better that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if it was Lonnie, Robert? What if she had been formally named as the murderer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wasn’t because she was innocent and the accusation was going to come out in the wash, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not everyone has a cop boyfriend. That makes it easier to pull strings and get some residual benefits. You did an awful lot of investigating that you had no business doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I acted out of concern for the wasting of taxpayer money. I didn’t even draw any overtime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean you saved your girlfriend’s neck for no charge? Wow!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_229",
      "title": "229"
    }
  }, [_vm._v("“Let’s put a leash on it. This meal’s already bad enough.” I looked out at the street and noticed a boy who was about eight years old staring at us through the window.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn kid even spies on me to make sure I hold up my end of the bet,” muttered the midget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should take him home. I think he likes you.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("ater, back at my apartment, it was Paul’s turn to hit me up with questions about the case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something really bothers me,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’m sure you thought about it, but how did Mr. Chen even get to Chinatown?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He probably had someone on his security detail call him a cab.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, he didn’t tell any of them where he was going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then he probably took the subway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t know any English. How would he know how to buy a token and where to transfer and where to get out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter how he got to Chinatown from Midtown. Hell, maybe he took a brisk seventy-block walk. It’s the murder we’re focused on, not his transportation choices.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beyond that, why did Mr. Chen come to Chinatown so late?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what I honestly think? He was probably trying to find some girly action.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He could have just stayed in his hotel room for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chen probably would have wanted "), _c('i', [_vm._v("Chinese")]), _vm._v(" girly action.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul crossed his arms. “You know they send women up to Midtown, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right. I don’t know exactly how or why Mr. Chen came down to Chinatown. All I know is Lincoln runs into him on the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_230",
      "title": "230"
    }
  }, [_vm._v("street at random, something in his head snaps, and Lincoln beats Mr. Chen to death with a rolling pin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A rolling pin?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, dammit, forget I said that! It wasn’t disclosed to the public.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would a guy walk around with a rolling pin?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He probably felt more comfortable having some protection on him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A rolling pin?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The details of the case clearly weren’t coming together. Things seemed even more confusing now. But it was over already, right? Who cared if the pieces didn’t fit correctly? Lonnie was in the clear now, so I had no more personal interest in the case, which, for all intents and purposes, was closed now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This city has more than four murders a day. I’ll bet more than half of them are of criminals who may or may not have been previously caught. The public thinks so, too. The victims reap what they sow, so to hell with most of them. To hell with Lincoln, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was annoying, though, was Lincoln’s street address that I had written so long ago on the back of my left hand still hadn’t come off yet. I used up the squad bathroom’s Lava soap trying to get it off. Seeing the faded yet legible letters made me think of those heated discussions I had had with the guy and I couldn’t help feeling bad for him. It was true that I didn’t like him, but it was a horrible way for him to go, and he was young.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pro-KMT newspaper tracked down his parents in Northern Jersey. They said it wasn’t fair that someone of his scholarly lineage should have to die like a dog in the street. They told Lincoln to come home after posting bail but he had refused. He had such a good heart, he wanted to stay in New York and continue reaching out to the lowly Cantonese youth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_231",
      "title": "231"
    }
  }, [_vm._v("His mother added that Lincoln couldn’t have killed Mr. Chen. The hands that played piano and the violin so well for so many years couldn’t be capable of murder.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The parents were photographed sitting at their kitchen table, holding Lincoln’s framed bachelor’s and master’s degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("n my day off, I asked Izzy if I could have a look through Mr. Chen’s effects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s nothing useful in there,” he said. “But you can have first bid on it when we auction it off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want to buy it. I just want to see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you looking for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At this point, why the hell not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Chen’s belongings were crammed into a stiff, medium-sized black-leather suitcase devoid of characteristic marks. It seemed like something a Communist would have. I knew they had had someone fluent in Chinese go through it already, but I had to see for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The property clerk was a snide skinny guy with a spotty mustache. “Something in this thing smells funny,” he said. “Well, maybe not to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And why not to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because you’re probably accustomed to it. Are you not Chinese?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grunted and he handed me the clipboard to sign out the suitcase. “Aren’t we going to open this thing up and go through everything for inventory?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, it doesn’t matter at this point. Maybe you should just take it. I won’t tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The suitcase was on the heavier side. He had packed only two changes of clothing and only one pair of shoes, but Mr. Chen "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_232",
      "title": "232"
    }
  }, [_vm._v("had jammed in as many books as he could fit. He might have been apprehensive about the long plane ride and being trapped with nothing to do. I understood because people get the same way about the subway. Platform newsstands that also sell books do very well.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything reeked of the camphor and menthol from Tiger Balm or a rip-off of Tiger Balm. It’s a well-known panacea among Chinese people all over the world. When labeled for the U.S. market, the packaging states that it relieves sore muscles. But Chinese people use it for all sorts of things—including hemorrhoids and swallowing something to treat sore throats—that would repulse the Singapore-based company that made the official Tiger Balm. Americans are shocked when they see it for sale because they think it’s made out of endangered tiger bones, but it’s not. Anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lifted out a stack of paperback books that particularly stank and found a smashed glass container of Tiger Balm underneath. The books were boring Communist reports of overly optimistic urban planning and overly optimistic harvest reports. In the next stack of books, I found something odd. It was a New York Chinese telephone book. Mr. Chen couldn’t have brought this book over from China. It was printed in New York and was thinner and smaller than what a cop would expect of a phone book. A non-cop Chinese interpreter might have missed it as a clue. Whoever packed up Mr. Chen’s belongings from the hotel room probably glanced at the Chinese characters and thought it was just another one of his books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thumbed through the phone book and tried to look up Lincoln Chin. The listings included the entire three- or four-character Chinese name, by surname, along with the English name that the person went by, if any, and the street address.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are a couple of characters that could be “Chin” as a fam"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_233",
      "title": "233"
    }
  }, [_vm._v("ily name. The most popular one was a compound character that has the entire character for “east” incorporated on the right side, and this compound character was the same as “Chen” in Mandarin, as in Mr. Chen. The second most popular was the character for “gold.” Lincoln wasn’t listed for either character. I was about to try yet another variant of “Chin” when I realized something.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln was a loafer. He probably didn’t take care of the phone bill. Teresa did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked up Teresa Lee, whose surname was a tree character on top of a child character. It’s a popular name. One story says the very first Lee was born under a tree, surprise-surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa was listed in the book and her name was underlined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Chen had known Teresa!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I patiently flipped through the thirty pages of the residential section and no other names were underlined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Chen hadn’t placed any calls from his hotel room because he didn’t want to leave a record. He had to have left his room to call from a public pay phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at Lincoln and Teresa’s street address on the back of my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now there was an explanation for Mr. Chen’s missing index finger. He had written down Teresa’s phone number on it. Maybe her address, too. Teresa had wanted to destroy the evidence that literally fingered her as the killer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My next stop was The Plaza Hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I packed everything back into the suitcase and zipped it up. The property clerk looked dismayed when I handed it back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re bringing that stinky thing back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I sure am,” I said. “Take deep breaths. Tiger Balm’s good for opening up your nasal passages.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_234",
      "title": "234"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" took the subway to The Plaza at the southeast corner off Central Park.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the front desk I showed my shield to a mousy white girl who looked like she was still in high school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked her, “Do you have a Chinese phone book here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, we do,” she said, stepping back. She fingered a button on her uniform and then crouched down, holding on to the edge of the desk for balance. I watched the flesh under her fingernails pulse white and pink. “That’s funny,” she called out. “It’s not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought it might be missing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She popped back up and straightened out a skirt I couldn’t see. “Why would anybody steal it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It hasn’t been stolen. It was borrowed and then mistakenly collected as evidence. Say, Mr. Chen—the Chinese official who was murdered—he didn’t make any outgoing calls, did he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes widened for a second. “No, he didn’t. That was one of the first things that you people—the police—asked. No calls were placed from his room over the three nights of his stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you’ve turned over the surveillance tapes of the lobby, as well?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That last night, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I meant his first and second nights, too!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t believe we have, but I also don’t believe the police have asked for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have a pay phone in the lobby?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, we don’t. We try to keep people traffic to a minimum for the convenience of our guests.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May I use your desk phone, please? This is official police business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She brought me to the end of the counter and handed over a handset to me. I gave her the number to call, all the while sus"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_235",
      "title": "235"
    }
  }, [_vm._v("pecting that she wouldn’t let me dial it myself because she thought I’d try calling Asia.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?” said a gruff voice at the end of the line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Izzy. It’s Robert Chow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m bringing more lobby tapes from the hotel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What! We already saw what we needed to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you haven’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" practically ran into the audio/visual room of Manhattan South to get to the videotape machine. It took a while for me to get used to the controls, but when I was able to find what I was looking for, I called up to Izzy’s office and told him to come down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought he was under twenty-four-hour guard,” said Izzy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were in the next room with a panic-button setup,” I said. “If he buzzed them, they’d kick the door in. But he didn’t. It was meant to protect his privacy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Weren’t the guards FBI?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were contractors. Mr. Chen was a private citizen of a country that the U.S. doesn’t officially believe exists.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We watched the playback of Mr. Chen calmly stepping out of The Plaza the first night close to midnight and returning half an hour later. The second night he did the same. It was creepy watching the image of a dead man walking around like everything was fine.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" went back to The Plaza at about midnight and circled the block. I wanted to see what Mr. Chen would have seen. Amazingly, or not, none of the street pay phones worked. The surrounding businesses across the street were upscale but had closed hours ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I noticed that the southwest corner, Fifty-eighth Street "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_236",
      "title": "236"
    }
  }, [_vm._v("and Sixth Avenue, was a little scruffy. I saw a cheap newsstand on the diagonal corner and a little farther down the block was a diner.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were too many mirrors and lights in the diner and as I walked in I had to shield my eyes from the glare. It was on the smaller side, with only about ten tables and a short counter. Only a few people were there. A family of tourists who were underdressed for the fall weather and a cabbie doing a crossword puzzle. I saw a wooden New York Telephone booth in the back and headed straight for it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You wanna seat for one?” the counterman asked me. He had on a wrinkled but clean white uniform with a T-shirt collar visible at his neck. He was about forty and some gray had crept into his crew cut black hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not gonna stay,” I said. I got in the booth and shut the door, triggering a dim overhead light and a chugging fan. I couldn’t see too well, but the phone number in the center of the dial was scratched off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I picked up the handset and didn’t hear a dial tone. I played with the cradle but it didn’t help any. If the phone worked I could have easily asked the operator what number I was calling from.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The phone looked in good shape but who knew why it wasn’t working.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swung open the door and stepped out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s broken. Broke this morning,” said the counterman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could have told me before I went in there,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The right side of his mouth curled up. “I could’ve.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slid on to a stool at the counter. “Can I ask you a favor, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sure can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is the phone number to that booth?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sighed and reached for my wallet. I opened it up and laid it "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_237",
      "title": "237"
    }
  }, [_vm._v("flat on the counter. I tapped on my shield and said, “Remember now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The counterman lost his smile. “The numbers kid doesn’t come around here anymore, I swear to God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not investigating bookies. I only want to know the phone number.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I really don’t remember. Previous owner warned me never to pick up that phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess I can get the number later. One more pain-in-the-ass thing for me to do. Are you usually here this time of night, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Call me Walt. I’m here sixteen hours a day, rain or shine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Robert. Nice to meet you, Walt. You remember seeing an older Chinese guy using that phone around midnight for a couple nights?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In his late fifties, but probably looks younger than that to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can always tell, buddy,” he said. “I got magic eyes. Yeah, some guy was using the phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you heard on the news about a guy from China who was killed in Chinatown? He was named Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did hear something about it. I guess I missed most of the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think that was Mr. Chen who was using the phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have a look at this picture. Was this the guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He opened his mouth and licked his bottom lip. “I think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or did he look like this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, more like the first one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, how about this one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn. I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure? Use your magic eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s either the first one or the third.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_238",
      "title": "238"
    }
  }, [_vm._v("“That’s not going to do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which one is right, though?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The right one was the first one. That’s Mr. Chen. The second is a random government Chinese official. The third is an American World War Two veteran.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You people fought in World War Two?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We sure did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaned on the counter and whistled. This was mind-blowing for him. “That’s great. Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, about Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did feel good about the first picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good enough to swear it was him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Chinese guy that you did see, was he alone or was there anyone with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, he was definitely alone. He came in three times. The first two times, he used the phone and left, and the third, he sat alone in a booth and all he had was a cup of tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You remember anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When it’s not too busy, I like to imagine stories about the customers. If someone looks sad, I’ll make up some hard-luck story. That sort of stuff. Your guy sat there with a sort of blank look, trying not to look conspicuous. His eyes were excited, though, that third time, darting back and forth and everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I came up with a story about him. I know now that he’s Chinese, but I imagined that he was a Japanese soldier, one of those who refused to surrender and stayed in the jungle for two decades. Then he comes out and becomes a cabbie in New York. One day this young Japanese guy gets in the cab and stares at him. The ex-soldier looks up in his rearview mirror and stares back. Then the young guy says, ‘Dad?’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have a mind for making movies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_239",
      "title": "239"
    }
  }, [_vm._v("“You like the rearview mirror thing? It’s less confrontational than two people staring at each other. I took that from the mirrors in here. You wouldn’t believe what people do when they don’t think anyone’s looking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to tell me,” I said, standing up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure I don’t! You’ve seen ’em all!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you make up a story about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to put you in the story I told you. You’re the young Japanese passenger in the cab.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Chinese, too. It wouldn’t work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, it’s moviemaking. We could pull it off with the right director.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n the early afternoon I came to Vandyne in the squad room with the information I had from the diner the night before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you probably want to get the phone number of the pay phone in the diner,” he said. “That’s easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, that part is,” I said. “But I also need a record of the outgoing calls from it. In a way that will stick in an affidavit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How sure are you that Mr. Chen used that phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m fifty-fifty. Maybe a little less.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” asked English, immediately on alert. He was on the phone and I had my back to him. “Do I want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned my head slightly to him and said, “No, you don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bad Boy could help you on this,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are we talking about using tools out of the black bag?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was referring to the extra-legal measures the old cops used to resort to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s like dynamite,” said Vandyne. “If you’re careful with it, then everything will be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_240",
      "title": "240"
    }
  }, [_vm._v("I crossed my arms and looked up at nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This doesn’t make you a dirty cop or anything,” said Vandyne. “You’re not doing this for money. You’re doing this to cut red tape. If you find out Mr. Chen didn’t use that phone, you just drop it. No harm done. But if it works, we are only helping along a happy coincidence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” I said. “Where’s Bad Boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Try Happy’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" walked into Happy’s on Baxter Street, one of the few non-Chinese restaurants south of Canal. It was run by Happy himself, a grossly overweight man who took little pleasure in anything, not in the food his restaurant served and certainly not in the company of others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Happy would “greet” you with a sad little clown smile and talk about how he was going to die soon and nothing would fucking matter, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a little less jovial when he saw me, which meant that he looked thoroughly depressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m looking for Bad Boy,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Happy swept an arm back and pointed to a corner near the back. Then he disappeared as if he were swept out to sea. The place was crowded with elderly patrons who had been eating here since the block was a part of Little Italy. Coughing was louder than the conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I eased my way to the back brick wall and through an arch to a small alcove that held a private booth. The curtain was usually closed, but Bad Boy wanted the smell of his cigar to waft out into the dining room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glanced up and tapped the cigar into his empty soup bowl. “Chow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_241",
      "title": "241"
    }
  }, [_vm._v("“Have a seat. I know you don’t drink. Guess you want a steak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t thank me. It’s on the house and so is anything else you want to drink. You know that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw. I’m not hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will be, though. Better eat now while the kitchen’s open.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll eat when I get hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a novel idea.” Bad Boy smiled and puffed on his cigar. “So what’s on your mind, kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m trying to get the outside numbers called on a pay phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But even if I could get them, I don’t think I have enough to make it stick in an affidavit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s enough of a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What condition was the phone in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was broken.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smashed up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, it’s a phone booth inside a diner in Midtown. It looks fine except the line is down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t look fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go back there and pry off the dial. The phone’s been vandalized. Destruction of public property. You have to trace outgoing calls to help determine who could have committed such a crime. You can go through me to speed up the number retrieval. But don’t let anyone in the Midtown precinct know. They might come after your ass for destruction of public property.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do things like this regularly?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No no no! This is kids’ stuff, Chow. You get the bobcat "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_242",
      "title": "242"
    }
  }, [_vm._v("badge for this one. You can even give me the phone number now so I can get a head start on it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know the number, but the diner’s on the corner of Fifty-eighth and Sixth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He scratched his chin. “Funny. I think I know that place. A bookie was working that line, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I heard. But I’m not after the bookie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, stay away from them. Could know a lot of people higher up, and a young guy like you hasn’t got much cover. So are you looking for any particular number?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just one over three nights. The murdered Chinese guy was using the phone, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mouth tightened. “Aw, fuck. Not that. Are you good with Izzy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay. You scared me for a second. So. What am I going to get out of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re going to get to give me a bobcat badge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad Boy smiled. “I like you. I mean that. So, really, no steak for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was actually pretty hungry. It would have been so easy to sit down and put a napkin in my lap.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t took me a while to get back to the diner because the train schedules were all messed up due to a track fire. I ate a Hostess apple pie while waiting on the subway platform, but it only made me a little hungrier and thirsty on top of that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was worried that the counter guy would want to chat again, but luckily, a guy I didn’t know was behind the counter talking to two goofy girls in short skirts and big heels. In the phone booth, the dial came off surprisingly easy with just a cheap screwdriver. I shoved the dial in my jacket pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_243",
      "title": "243"
    }
  }, [_vm._v("I left and the guy didn’t notice. I could’ve walked in with a flamethrower and he wouldn’t have looked away from the girls.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad Boy had the list of calls for me the next morning; there was Teresa’s number twice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gave what I had over to Izzy. I told him I was going to bring in a witness who could place Mr. Chen at the diner. Izzy looked at me and said I was going to get credit for working on the case. I said I wanted Vandyne on it, too, and he agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" didn’t think you had any white friends!” Vandyne said. He almost had to yell even though he was sitting next to me on a wooden bench against a wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyone who will voluntarily take the time to head over to Manhattan South and make a statement is a friend of mine,” I said. “Walt from the diner helped make us part of the investigation. Looked good for the affidavit, too. That arrest warrant should be here any second.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now you’re going to officially get credit for your hard work!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This wasn’t about work for me, man! It was personal!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We looked around the room. Manhattan South’s homicide bureau was as loud as a carnival that served booze. Phones were ringing everywhere. Down the hall, suspects who were locked up in temporary cells were screaming and banging themselves against the metal bars. The bureau was staffed with people who were hired based on how loud they could slam drawers and their ability to scream through layers of sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t know how anyone could take it. My ears were ringing after about an hour. We had to wait for a warrant that could come any minute, hopefully before my hearing went.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy stopped by and we huddled. “Everything cool, you two?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne nodded and I gave a thumbs-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_244",
      "title": "244"
    }
  }, [_vm._v("“That was good work, Chow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was a lot of guesswork that paid off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Won’t be long now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any idea?” asked Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ask Chow to guess.” Izzy peeled off and did a cannonball into the teeming masses. Waves of people rippled away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get it.” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is what it’s about. Being a detective. Having a gold shield. I used to think it would be just something for me, you know, what "), _c('i', [_vm._v("I")]), _vm._v(" would get out of it. Really, though, it’s about being part of a larger organism.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s see how you feel when you’re figuring out your pension and you’re not getting enough overtime in your last year to pad it out!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne, there aren’t going to be pension funds left by the time we retire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled. “There’s going to be pensions. Or there’s going to be tensions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pounded the bench to show my approval. “Vandyne, I was wondering something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shoot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What have you done that was out of the black bag?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell you. Someone broke a window in the backseat of a car and anonymously reported it to the police. I happened to be in the area so I responded. As I investigated the incident, I found an unregistered and loaded gun in the glove compartment. I arrested the car owner and that was the start of that heroin ring bust about a year ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought the midget had fed you some tips for that case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He did, but it wasn’t enough.” Vandyne turned to me. “You can’t tell me what I did was wrong. That was nothing compared "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_245",
      "title": "245"
    }
  }, [_vm._v("with the shit you and I were doing in Nam and nobody stopped us there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. Among other things, we had also each killed a little boy out there. Mine was holding a ball and wouldn’t stop walking up to me. Vandyne’s was inside a hollowed-out tree, shooting up a camp from inside the trunk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt my kill was worse because the boy had nothing on him, but I never told Vandyne that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That case set you up for a gold shield, right?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, it did. If everything breaks the way it should in this case, it could do the same for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was that gun already in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was there when I found it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you put it there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did someone else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, someone else did. The suspect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I wasn’t, I wouldn’t have been able to type up that report.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t type anyway, partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “Let’s make a rule right now. Just you and me, Vandyne.” I looked around. “We don’t pull out the black bag for money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Otherwise we’re no different from those scumbags Serpico wrote about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re dead right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We reached out to each other and shook hands. After making the promise I felt a little better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, tell me how Paul is doing with the guitar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s terrible!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_246",
      "title": "246"
    }
  }, [_vm._v("“Really?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think this could be the first thing he’s having trouble learning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think it’s that. You have to suck at it for years until one day your experience pays off and you reach a point where you know what you’re doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s like anything else, then, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other side of the room, Izzy held up a folded piece of paper that cut through the crowd like a shark fin headed for us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Looks like we’ve got action,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" gently pressed my finger to the apartment button. A wave of static shot back and the front door buzzed open. I looked back at Izzy and he nodded. We both went up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we got to Teresa’s door, she looked shocked that we were there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Teresa. Have you met Izzy? He’s one of the top guys at Manhattan South.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, what are you guys doing here?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Surprised?” asked Izzy. He pushed his way in and I followed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” said Teresa. “I mean no. Have you found out more about who killed Lincoln?” She closed the door behind her and stepped into the living room. Teresa was wearing slacks and a blouse and no shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The thing is, Teresa,” I said, “did you happen to speak to Mr. Chen at any time on the phone?” As I was talking, Izzy slowly walked along the walls of the rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me? Why would I talk to Mr. Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It seems that he had called here a couple times.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He did?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_247",
      "title": "247"
    }
  }, [_vm._v("“Yeah, seemed pretty late at night, too. I think you would have been in, as you are now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you know he called here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I talked to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You talked to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bodies always talk, don’t you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Izzy stepped in from the kitchen. “Nice apartment,” he said. “By the way, how did that blood splatter get on the wall? They never seem to come out completely, do they? I have the same problem in my house. Anyway, I think we can match some of your prints on the bloody rolling pin we’ve got.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why did you kill Mr. Chen?” I asked Teresa quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly she was a blur. Teresa rushed out the door and ran up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re covered, right?” asked Izzy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah.” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two minutes later, Vandyne brought Teresa down in handcuffs with a Manhattan South detective behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do people run up to the roof?” Vandyne growled. “Her feet are all cut up now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wanted to say hi to Santa Claus,” I said. We all laughed at her and her stupid bloody legs.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he story came out that Mr. Chen had been calling Teresa from a pay phone. He could have called from his room, but he didn’t want anyone to know that he was trying to reach his illegitimate daughter who had fled China years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lobby tapes had shown that Mr. Chen left the hotel temporarily the first two nights, coinciding with the phone calls at the pay-phone booth in the diner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa had grown up in near poverty with her mother, and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_248",
      "title": "248"
    }
  }, [_vm._v("Mr. Chen had sent them money only rarely. She saw his picture in the newspaper from time to time but didn’t believe that he was her father until he visited very late at night on her tenth birthday. At the time, she had picked up a kitchen mallet and hit him on his arm as hard as she could with it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He should have known not to come looking for her fifteen years later, after she had taken a train south and snuck into Hong Kong and then entered the United States through a sponsor family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa admitted that she had talked to Mr. Chen on the phone and even told him the cross streets of where she lived. He had come over and they were simply going to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then he had asked her if she could help bring his family over to America. After all, they were her family, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She thought about all those years of struggling with her mother while Mr. Chen and his wife and kids lived in luxury in condominiums built for provincial officials.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her hands moved on their own and she hit him with whatever was handy. Repeatedly. When she saw her phone number and address on his finger, she took a Chinese kitchen knife and hacked it off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teresa insisted again and again that she acted absolutely alone and that Lee had been trying to cover for her with his story.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met Vandyne next to where Mr. Chen’s body was found in the park.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned the lapels up on his leather jacket and said, “If you’re comfortable with Teresa being the murderer, then maybe this isn’t necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not. You know, Lonnie says that if I don’t think a woman has the strength to carry a man, then I don’t know how strong a woman can be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_249",
      "title": "249"
    }
  }, [_vm._v("“Teresa is a strong woman. I could tell she had a lot of upper-body strength when I was cuffing her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We stepped over the tape and walked around. There could be something to tie Lee in with the murder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still, though,” I said. “I find it hard to believe that she could have dragged or carried a body six or seven blocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that Chinese hardly ever call anything in, but a woman pulling a body in a shower curtain would have attracted some attention, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The guy with the mole is the key. He was actually the last person who spoke with Mr. Chen, not Lonnie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They probably put the body in his car and then dumped it off here,” said Vandyne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But how do we find mole-man? Can’t very well look through Heavenly Horse’s employment records. They don’t record the physical features of their drivers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about the voucher Lonnie signed? Can’t you track her driver from it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The drivers are paid in cash when they turn in their vouchers and then they’re alphabetized by the customer’s last name. The desk clerk makes sure that the customer has signed but not that the slip is filled out completely. The driver’s name was left blank, and that might be standard operating procedure in a largely cash business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne nodded. “Looks like they pulled all the cigarette butts, soda cans, and needles from this area already.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. So all this paper trash you see here is new. What makes people want to litter at a crime scene?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think the wind could’ve blown all this into the area. Do you seriously think someone would have walked here to throw away a wig?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_250",
      "title": "250"
    }
  }, [_vm._v("“Where?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right there, man. I thought it was a dead squirrel at first.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne’s discovery made me think of something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if there is no man with a mole?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if that driver doesn’t exist?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t Lonnie say a man with a mole picked her up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That means he’s real, partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The man is real, but the mole isn’t!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" saw Bad Boy standing near the top of the stoop of the Fifth Precinct. He stood perfectly still while trying to read the minds of passersby. I went up the steps and stood on the opposite side of the door as him. Neither of us looked at each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve been thinking about something,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Trying something new, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s something that could get Pete mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean ‘mad’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I mean this involves one of his guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. He’s gonna be pissed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should I tell him what I think I got?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How bad is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something to hang for.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You better tell him now. His mood’s only getting worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I ran into Pete in the squad room’s kitchenette. He was sitting at the table. A paper plate in front of him held the skeletal crusts of what used to be three pizza slices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you weren’t working as the pizza man anymore,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_251",
      "title": "251"
    }
  }, [_vm._v("“Go fuck yourself, Chow!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What the hell’s your problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This fucking scumbag reported me to the Civilian Complaint Review Board and they want to ask me some questions. He said I sprained his arm and neck. Motherfucker was resisting arrest!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s got all these bullshit medical bills and he’s saying he missed work for a few months. Yeah, he missed standing on the corner and pushing junk on kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he go to jail?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Suspended sentence. The trial was a complete sham. They brought up his traumatic childhood and lousy parents. Like that’s an excuse. It only proves that it runs in the fucking family, if you ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought about Paul. If he had stayed with his abusive father, where would he be now? I couldn’t rule out selling drugs and getting arrested by a volatile cop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And anyway,” said Pete, “this was two years ago, so fuck it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing’s going to happen. The CCRB’s got no teeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know, Chow. These things are so goddamn arbitrary. Yeah, most people, nothing happens to them. But if there’s a cop they want to make an example out of, they stick it to him. I don’t care if they go through my record with an infrared scanner. I’ve got nothing to hide.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of which, I think someone’s been holding back on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think there’s something about Lee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is this still about the Chen murder thing? We got our man already. Uh, woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_252",
      "title": "252"
    }
  }, [_vm._v("I told him what I suspected and what made sense to me. Pete didn’t say anything or even interrupt to ask questions. When I was done, he rolled his head on his shoulders to crack his neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s get a plain car and go for a little ride,” he said. “Get Bad Boy, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right now?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, right fucking now. I’ll see you downstairs. There are some things I want to get first.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("ad Boy drove us out just east of Seward Park. I sat in the front passenger seat. Pete was in the back. He held up a small, old cushion that probably used to top a bar stool. It was thinned out by age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember this?” Pete asked Bad Boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could I forget the hot seat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll get to see it in action,” said Pete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re in the Seventh Precinct,” I said. “Is this going to be a problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naw,” said Bad Boy. “They know he’s our guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We found Lee outside a day-care center on Clinton Street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete popped out of the door and walked up to him. “We gotta talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My cousin’s daughter—” started Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, I know. Now, this part is for your own good.” Pete gave him a rough frisking, then pulled Lee’s arms around and cuffed him in the back. “I don’t want it to look like you’re an informant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee nodded. There wasn’t much else he could do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete opened the other back door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee shifted nervously. He bent down and looked at us. “Hello,” he said to me in Cantonese. “Do I have to get in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_253",
      "title": "253"
    }
  }, [_vm._v("“We want to have some words with you,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Talking only, right? I can’t leave here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not going anywhere.” In English, I asked Pete and Bad Boy, “We’re just going to talk to Lee in the car. We’re not going to drive him somewhere, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re staying right here,” said Bad Boy. “We’re going to keep him safe right in the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See, look at this,” said Pete. “I got this nice cushion for you to sit on because I don’t want you to get hurt. I’m always looking out for you.” Pete pushed Lee in, slammed the door, and came around to the other side. Bad Boy couldn’t stifle a giggle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as Pete was in, Bad Boy tore the car away from the curb and did a U-turn against the one-way direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we roared away, Lee cried out, “Robert, you said we weren’t going anywhere!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, well,” I said. “You can’t blame me. I’m only a passenger like you.” It was true. I had no idea where we were going.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is going on here? Is something the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “I was just thinking that it was good that we’ve picked up Teresa for the murder of Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a real shame.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sure is. But it made me wonder why you told me that bullshit story about you waiting with Teresa at her apartment the night Mr. Chen was murdered.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe I made some sort of mistake,” Lee said. Chinese people are good at smiling hard while talking. “I confused that night with another night that I couldn’t find Lincoln. There were a lot of nights that he was missing, if you have to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So it was all one big mistake, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something like that.” He shifted uncomfortably in his seat. Pete watched Lee like a snake about to strike at a mouse but Bad Boy kept chuckling and glancing at the rearview mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_254",
      "title": "254"
    }
  }, [_vm._v("“Let me ask you about something else, Lee,” I said. “There sure are a lot of drivers with moles on their faces, aren’t there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite a few, I guess. It’s a natural thing. A lot of people have them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So how do you keep your mole from falling off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mole? I don’t know what you’re talking about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you put on that fake mole, how do you keep it from falling off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re crazy, man!” At this point, Lee tried to lift his butt from the cushion, but with his hands cuffed behind his back it was impossible for his bent legs to sustain his weight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We got a wild bronco, here,” said Pete. He put his arm around Lee’s shoulders and forced him to stay still on the cushion. “Chow, I think you’re saying something to upset this guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seat is a fire!” said Lee in English. He was so distraught, he stopped speaking Cantonese.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen to this guy,” said Pete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The guy who drove Lonnie home had a mole and a hat pulled down low. Sounds like a disguise for a guy who was up to no good,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee said, “Help me! He hurting me! Hot! Hot!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t get Pete excited. If you just confess what you did, he won’t get any madder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me out!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were in the office when Lonnie came in and arranged for the car service back home from Midtown, right? She let it slip that she was doing an important interview. You figured out right away that she was going to see Mr. Chen. You grabbed that ticket as fast as you could but you didn’t know yet how you would get to Mr. Chen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe I only want to fucking your girl,” said Lee. I reached "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_255",
      "title": "255"
    }
  }, [_vm._v("back and punched him in the ribs. Pete took the cue and dove into Lee with an elbow.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bad Boy, you gotta watch those sharp turns!” he called out. “I almost took this guy’s head off!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, you know how rough these streets get,” said Bad Boy. “I might have to hit some curbs, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get lawyer. Sue you. Police brutality,” Lee managed to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “You’re going to need a lawyer when you explain in court how you decided to combine Teresa’s motive to kill Mr. Chen with your idea to frame Lincoln for the crime. You wanted to be the sole leader of the Union of the Three Armies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You came to pick up Lonnie in disguise, hoping to find some way that you could get closer to Mr. Chen. You probably hoped that you could figure out some way that you could talk to one of his guards and convince them to let you take Mr. Chen for a ride to the airport or somewhere else in the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When he came out with Lonnie and talked to you, you couldn’t believe your luck. He asked you, probably in Mandarin, how to hire one of your cars and you replied in Hakka that you would come back to pick him up! You whipped out the Hakka dialect because you knew Mr. Chen would instantly trust a fellow Hakka.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonnie doesn’t know Mandarin that well and almost no Hakka, so she thought you guys might have been speaking some dialect of Mandarin the entire time! She had no idea what you guys were saying—and you counted on that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee stared at the back of Bad Boy’s head and didn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You told Mr. Chen to wait in the diner for you to come back. Then, after you dropped off Lonnie, you changed the ticket to say there were two passengers. It was easy: you simply added another line to the character for ‘one.’ You figured that it would cause more confusion. You also alerted Teresa to get ready because "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_256",
      "title": "256"
    }
  }, [_vm._v("you were going to be dropping off some fresh meat. You also probably got a shower curtain from your apartment and threw it in your trunk. You went back to pick up Mr. Chen and you pretended to need the address he was going to. You knew where he wanted to go, all right: Teresa’s apartment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad Boy eased the car into the entrance of a below-the-sidewalk garage and took us down two levels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know when you went up to Teresa’s apartment, before or after she killed Mr. Chen, but I’ll bet you helped mash around Lincoln’s shirt in Mr. Chen’s blood. Then you wrapped up his body in the shower curtain and dumped it as Teresa cleaned up all the blood as best as she could.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were idling in the shadows and the only things I could hear were my breathing and Lee’s handcuffs clinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How does it sound, Lee?” I asked. “Feel free to add in any extra details that I missed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was in tears from pain but he managed to chuckle a little and said, “You have nothing. Teresa say nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s so brave of you to let this woman take the entire rap by herself. You’re such a man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am survivor. You don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt the front door slam. Bad Boy had gotten out and left the engine running.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, where are you going?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to swing by to pick up some dry cleaning,” he said. “It’s just a few blocks from here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pete still had his arm around Lee’s shoulders. Lee looked like he’d been through twenty rounds of boxing, fully panting and soaked in sweat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not looking too good,” I told him. “I think a confession will help get this weight off your chest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_257",
      "title": "257"
    }
  }, [_vm._v("“I don’t think he’s up for confessing,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think we can do something about that,” said Pete. “I know the guy who runs this garage. He’ll swear none of us were around today when he’s found on the third level.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is found?” asked Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get it,” said Pete. “You understand a lot more English than you let on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me explain, Lee. When you get down to that level, your ears play tricks on you. You might think you hear screaming, but you’re really only hearing noisy brakes and tire squeals.” Pete reached down around his feet and came up with a crowbar. He rubbed the curved side of the hook across Lee’s lips. “The teeth should be the first thing to go. Just to make sure they can’t match up the dental records. You haven’t missed any checkups lately, have you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chow, I think you might need to give Bad Boy a hand with his dry cleaning. Make sure he doesn’t strain himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” said Lee. “He’s going to kill me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I got out of the car and walked to the entrance. Bad Boy was leaning against a wall, drinking a cup of coffee from across the street. Nobody was around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it going to be rough for Lee?” I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With Pete? Naw, Pete never really hurts anybody. The hot seat is the only thing he uses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is the hot seat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s got Mace sprayed on it. When someone sits on it, the body temperature activates the Mace. Burns up your asshole and your balls.” He chuckled. “I can laugh because I’ve been Maced by a suspect before and I know how bad that shit can be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not funny to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What, you feel bad for Lee? He’s a miserable fucking rat. He turns his friends in like poker chips.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_258",
      "title": "258"
    }
  }, [_vm._v("“Oh, you got me wrong. I wouldn’t give a shit if I picked up the paper tomorrow and saw that he’d been severed on railway tracks. This piece of shit fucked over my girlfriend in a big way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then what’s the problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The stuff pulled from the black bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, you got a problem with the hot seat? That is completely harmless compared to what they used to pull.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still. I don’t feel real good about it. Honestly, I feel worse about the phone dial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You got the number you needed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not like that call was "), _c('i', [_vm._v("not")]), _vm._v(" placed from there, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if it wasn’t there, then nobody would have been hurt. Hell, nobody would’ve even noticed. And the hot seat is nothing, too. So there are some burning sensations. Nothing a few showers can’t get rid of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked across the street. Two little boys were throwing a red rubber ball to each other as they walked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look at it this way,” said Bad Boy. “Let’s say there was going to be a soapbox derby. One team is allowed to use only what they have in their garage but the other is allowed to use an entire hardware store. Who has more options? Who do you think would win every time? Sometimes extra tools come in handy. We don’t frame innocent people. We want to make sure the guilty get put away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A soapbox derby? It’s been a lot of years since this was explained to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad Boy smiled. “Anyway, didn’t I see you sneak in a punch on him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just poked him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_259",
      "title": "259"
    }
  }, [_vm._v("“Hey, it doesn’t look that way to the CCRB. That’s assault against a suspect in handcuffs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of which, isn’t Pete worried about this with the CCRB thing coming up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That thing is bullshit and Pete worries way too much about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee broke down. We took him back to the precinct and he made a confession. He could be tried together or separately from Teresa or maybe one could be turned against the other. I didn’t worry about it because that wasn’t my call.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We had Peepshow guard the plain car. We had to leave it on the street with the windows down to air out the piss smell.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("s I was coming up the stairs, I heard Paul playing guitar. It stopped as I walked up to the door. When I came in, I found Paul sitting on the couch, reading a book. The guitar was already zipped up in its bag on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard you playing,” I said. “Why did you stop?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t want to bother you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are those lessons with Vandyne going?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve only had two so far. It takes forever to get to Elmhurst and back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you don’t pay your dues, don’t expect to get good at anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s harder than anything I’ve ever tried. I’m used to learning things in school quickly, but this isn’t going to be one of them. Have you seen John play up close? That guy’s a natural.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not. His mother used to kick his ass if he didn’t play right. You actually have an advantage over him because you have someone showing you how to play. He had to teach himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I asked what kind of things I should listen to and he said to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_260",
      "title": "260"
    }
  }, [_vm._v("get forty-fives and play them at thirty-three revolutions per minute to figure out the guitar parts. He gave me some records to listen to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at a scratched-up Chuck Berry single on the turntable and wondered if it was one of the originals that Vandyne learned to play with. The Ramones album was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see you got rid of that punk-rock record.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I loaned it to John. He said he wanted to listen to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I used to have a high opinion of his taste in music. What do you think of ‘Rock and Roll Music,’ Paul?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s pretty tough. I’m having trouble with the chords.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I meant do you like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like it. You can see how it is an ancestor of what the Ramones do. Even the beat is about the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put the needle on Chuck Berry and listened hard. The surface noise on the record made it sound even closer to the Ramones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn,” I said. “I can hear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you’re okay with the Ramones now, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way. Chuck Berry was rock and roll. Comparing him to the Ramones is like saying La Choy is real Chinese food.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Brilliant as usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you keeping up in school and work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you expand a little bit on that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just wait for my report card to come in. You’ll see I’m doing fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have any tests coming up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you think I’m studying for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So since you have to study, I guess you should go to the bedroom while I watch TV.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul grunted and left the room. I snapped on the television.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_261",
      "title": "261"
    }
  }, [_vm._v("The Communist channel had a program about how much better life was for the people of Tibet province with improved access to education and health care.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Taiwan channel was showing a concert with a squeaky clean, light-skinned man singing about a girl to a neutered version of “Rock and Roll Music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The American channels gave me a choice of "), _c('i', [_vm._v("$25,000 Pyramid, The Bobby Vinton Show")]), _vm._v(", and a repeat episode of "), _c('i', [_vm._v("Adam-12")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought about those goody-goody cops on "), _c('i', [_vm._v("Adam-12.")]), _vm._v(" No wonder they got canceled. They wouldn’t have lasted a minute in New York City. They wouldn’t have pulled out the hot seat, either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t sure how I felt about it now. I didn’t feel bad for Lee, but I wasn’t laughing with Bad Boy, either. I think on the outside of it, I saw myself pushing around and beating Vietnamese to try to get answers out of them. I didn’t feel anything about those memories, so I really shouldn’t have been upset about the hot seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet it bothered me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My eyes drifted to the guitar bag. I pulled it over and unzipped it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guitar had nylon and metal strings on it. I pulled the fattest one and two seconds later Paul yelled out, “Stay away from my guitar!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" looked through the mug books, something I should have been doing on a more regular basis. Then my phone rang and I didn’t recognize the voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Officer Chow?” asked an older man in English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, that’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My name is Byron Su. I’ve met you a few times already, although we never really had formal introductions done. We’ve never had tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_262",
      "title": "262"
    }
  }, [_vm._v("“Where have we met?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, pardon me. I first met you around Columbus Park a while back. I told you about my children. Later on, I met up with you late one night at a broken phone booth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now I remember! How are you, Mr. Su?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Officer Chow, I was wondering if I could come in to see you for a little bit. I have a couple hours left in Chinatown before my daughter will pick me up, so I was wondering if I could come in and talk with you. I know something you may find interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at the mug books on my desk. “Do you know how to get to the precinct?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, over on Elizabeth, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the one. It’s the only one, as a matter of fact. When you get to the desk sergeant, tell him you’re looking for me. He looks scary and his name is Rip, but he’s a really nice guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hung up and went to the kitchenette to wash out two mugs and to fix a pot of coffee. A few minutes later, the old man was in the squad room. I didn’t bother to introduce him and nobody asked who he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you take your coffee?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t. It’s bad for my stomach and my heart. It’s a case of two birds with one stone. My late wife once made me a cup of decaf and it hurt my stomach even more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t mind me drinking mine, do you? If the smell bothers you, I’ll pour it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, for God’s sake, please drink up. You’re a young man. Now is when you should indulge because you can’t later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at him and couldn’t help smiling a little bit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re giving me a pretty wide license there,” I said. “But because of my profession, I can’t fully give in to the permissiveness of the age we’re in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s very true! Moderation is probably the best track. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_263",
      "title": "263"
    }
  }, [_vm._v("The Taoists were right in a way.” He looked down at the mug book open on my desk. “I’m not interrupting you, am I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all. I’m just staying abreast of some of the bad guys out there. This particular book features people who didn’t bother to show up for court. We have warrants out for their arrest on sight. If I see them, I can take them in right off the street. Do you want to have a look?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Su made a sheepish face and said, “Um, do you remember that I had something to tell you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I saw a face in the Chinese newspaper that I recognized. It was the man who was arrested for his role in that awful killing. The Chinese official who had his head beat in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You recognized the photo of Mr. Chen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, the murderer. The driver. Do you know the restaurant that is by the broken phone booth?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I was eating there with my kids late one night. I was in the restroom, brushing my teeth. I noticed that man go into one of the stalls. It was hard to miss—his face has such a tough expression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I brush my teeth for a long time. I’m very thorough—you have to be at my age—so I was still there when he came out. I saw that there was something very different about him.” Mr. Su smiled. “He was now wearing a baseball cap and a mole on his face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about that,” I heard myself say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was a little curious, maybe too curious, but I walked out of the restroom and saw the man get behind the wheel of a livery cab.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t you think that was strange?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure, I did. I was even thinking about going to the police "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_264",
      "title": "264"
    }
  }, [_vm._v("with it, but an old friend from California was about to come and stay with me. I fully intended to tell somebody about it. You in particular because I had your card, Officer Chow. It’s funny how I ran into you at the pay phone. I had wanted to tell you right there.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I also had the thought that there was the slightest chance that reporting it would interfere with my ability to host my visitor properly. We had many events planned out, you know. So I promised myself that I would tell you right after my friend left. And here I am. Coincidentally the man appeared in the newspaper today. So something tells me my timing was just right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why the hell didn’t you tell me when it happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was strange, but I didn’t think it was anything urgent. I didn’t know that he was going to be a murder suspect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you see someone changing their appearance, don’t you think that person is going to be up to no good?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or going to a costume party. Would you mind sitting back a little bit, Officer Chow? You’re spitting right in my face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I curled back into my seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because of you,” I said, “my girlfriend had to go through hell as the default suspect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s all right now, because you’ve got the right man anyway, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pounded my fist into my typewriter keys and the typebars mashed together in a bouquet of steel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By not reporting what you saw, you fucked her and me over, you lousy old man!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never knew I did!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me tell you what’s going to happen now,” I said. “I’m going to fix my typewriter. Then I’m taking your sworn statement down. Then you’re going to be a witness for the prosecution at the trial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, of course I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_265",
      "title": "265"
    }
  }, [_vm._v("I pulled back a few typebars and then I had another idea. Without wiping off my fingers, I dialed Lonnie at work. I handed the handset to Mr. Su.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is my girlfriend, Lonnie. You goddamn apologize to her right now!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took the handset and cradled it to his ear. I looked over at English and Bad Boy. They weren’t looking directly at me but both were smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" met Lonnie for lunch the next day at the crappy U.N. coffee shop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, you didn’t have to make the guy call me,” she said. “He sounded like he was terrified.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was actually racked with remorse. What a mess. You should have seen him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m so ashamed that I was fooled that easily. I should have known that my driver was wearing a disguise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You had no idea that someone would pull off something like that. You had the best intentions, too. You wanted to throw some business to a Chinatown company, so that the money would go to Chinese people. Look what you get.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chinese people aren’t all bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All people are bad, Lonnie. As bad as this roast beef. They should call this ‘roach’ beef.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled and I watched orange soda creep up a straw into her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie didn’t know how close she’d come to getting busted. The murder rap would never have stuck, but just out of spite the detectives would have found something on her. Maybe she had violated some antiquated law still on the book from the Un-American Activities days. They would ruin Lonnie’s journalism career to get back at her for all that wasted time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_266",
      "title": "266"
    }
  }, [_vm._v("Those Manhattan South guys are old, tired, and bitter. I know how they think. I was still pretty new at this but I was so sure that Lincoln was guilty I might have planted something to make certain that he was convicted.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s terrifying that he turned out to be innocent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to smile and finished off my sandwich.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("E")]), _vm._v("nglish called me over to his desk. He opened up a box that had a gold shield wrapped in plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This isn’t the actual one you’re getting,” he said. “But yours is going to look approximately like this. The Brow himself wants to get it to you as fast as possible. We have to figure out when a good time is, though. Like the way it looks?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Want to carry this one now? It’s sort of a sample sale.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll wait until after the ceremony.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was going to play it cool and head for my desk without any fanfare, but English stopped me and shook my hand. Then I turned and shook hands with Bad Boy, Pete, and Vandyne. Pete slapped me hard on the back and said, “Welcome to third grade, motherfucker!”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("arbara was bugging me every day until I agreed to meet with Wilson Yi one more time. He had wanted to congratulate me with a full banquet on the excellent job I had done, but I managed to knock that down to a lunch at the dining room in his office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was only the three of us—Mr. Yi, Barbara, and me—and we did the best job we could with the gigantic meat-only meal of beef, duck, and pork. Our table was lively as they asked me questions about the case, and I tried to be funny with my answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But there were other people eating in the room and the over"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_267",
      "title": "267"
    }
  }, [_vm._v("all mood was quiet and somber. The stationed waiters and the clocks on the wall were silently counting the possible seconds to the inevitable time when the United States was going to switch full diplomatic recognition to Beijing from Taipei. I wondered how anybody in the building could focus on doing serious work at this point.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are your long-range plans?” Mr. Yi asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess to keep doing what I do as well as I can. That’s all a cop can do. For twenty years, at least.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I meant your personal life and when you’re going to start a family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I don’t know. Have to get married first, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbara said, “His girlfriend is very, very pretty. She will make a beautiful mother someday.” She threw me a questioning look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled. “Mr. Yi,” I asked. “What are your plans for the future?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right now my son is at Stanford University. He wants to study film of all things. I guess I didn’t bring him up right. I indulged him with movies, and with my connections he met many famous actors and actresses.” He shook his head but still looked pleased. “Maybe someday the Chinese will have films that are well regarded internationally. Someday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dropping his voice, he added, “My wife and I like this country very much. We are going to try to become American citizens soon.” Barbara and I both nodded. There was no need for him to explain any more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I washed up in the men’s room. I think that once upon a time this had been a Fortune 500 company’s headquarters building and that it would go back to being one. I looked at myself in the mirror. I looked like I needed more sleep. I got worried that I had some gray hairs, but it was only a shiny spot where the light was hitting my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_268",
      "title": "268"
    }
  }, [_vm._v("I wished Mr. Yi the best and walked out with Barbara. The elevator was taking forever to come.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s next for you, Mr. Famous Detective?” she asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing much, hopefully. I need to take it easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Having that gold shield must help, right? Now you’ve reached a point where you can rest on your laurels a little bit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like I told Mr. Yi, a gold shield doesn’t necessarily mean I’m any better. It means I’ve done more time and not much else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The more time you spend investigating, the better you get, though, right?” She put her hand on my shoulder and leaned on me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In theory, but there are still things that puzzle me. Like how Artie’s newspaper went up in flames. We actually thought it might be arson, so Vandyne and I staked it out, waiting for some dirtbag to show up and inspect the job he did. Funny thing is, you were the only one who came.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barbara withdrew from me and pressed the already-lit down button a few more times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“C’mon, dammit!” she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I said it was funny how you were the only one who showed up after the fire, Barbara.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I heard you,” she said. “You know that I never liked Artie. I think he’s a lecherous bastard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you can’t blame me for it. That fire was ruled accidental. A case of bad wiring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what the fire department and the insurance company both said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was lucky he wasn’t in the building,” she said, shrugging. “Now he’s got all that insurance money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was he supposed to be in his office, Barbara?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed. “No one was supposed to be anywhere, okay, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_269",
      "title": "269"
    }
  }, [_vm._v("Robert? Could you not look at me like that? Listen to the things you say! You try to talk people into setting themselves up!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The elevator finally came. It was packed. I let Barbara squeeze in by herself. I waved and watched the doors close over her.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("rtie Yi gave me a tour of a space on Pell Street that he was thinking of renting out as the new office for his English-language newspaper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a tiny space and had most recently been a two-person travel office. The previous tenants had taken off without paying last month’s rent, but they had left two large desks and file cabinets galore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s too bad Lonnie couldn’t make it. I really wanted to show her the space.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is really busy catching up to her story quota.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, the life of a newswire reporter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Artie and I sat on the two desks, facing each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Artie, were you ever threatened by radical Chinese groups?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean like the Red Guard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I mean here. Groups that are far-right and far-left wing. The kind that blow .44 bullets through people they don’t like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure. I’ve been threatened by everyone. I don’t give a shit. I’ve had my office broken into umpteen times, too. You people wouldn’t do shit for me, either, thank you very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing of value was ever stolen, if I’m remembering correctly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right. Nothing of material value is in there. The most expensive thing I have is my typewriter and I carry that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_270",
      "title": "270"
    }
  }, [_vm._v("with me. All my confidential notes with my sources in them are locked in my desk at my regular job.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s never been an attempt on your life, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not that I’m aware of. I mean, I may be doing an Inspector Clouseau sort of thing where I bend down to tie my shoe and a bullet whizzes by my head.” He laughed hard. “But seriously, no. Sanchez, your boss, asked me before if I wanted to maybe think about getting licensed to carry a piece. I said no. There are enough guns in Chinatown already.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure about starting your paper back up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At this point it’s a little up in the air. Landlords don’t like me, but I do have all that insurance money, so I’m a safe bet as a paying tenant. There are always some willing to take a political risk by letting me sign a lease. But my insurance company wants to do a thorough inspection of any new space I rent. That kills my chances for finding a place in most of Chinatown, but I think this office could pass. Concrete everywhere!” He rubbed his hands together. “My paper was pretty damn good, wasn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, it was a hell of a paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate the thought that people will think I’ve given up, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If the midget’s taught me anything, it’s that what you think about yourself is all that matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think people miss my newspaper? I’m going up against everything. People aren’t going to want to read a newspaper when there’s TV news with hot chicks, CB radios, and who knows what else is coming out. Serious news—print news—can’t compete with entertainment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("The New York Times")]), _vm._v(" seems to be holding up pretty well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not the "), _c('i', [_vm._v("Times")]), _vm._v(". For one thing, I’ve got more minorities on staff. How did you feel about Lonnie getting into the news business?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_271",
      "title": "271"
    }
  }, [_vm._v("“I felt good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But she’s got that double handicap. She’s a woman and a minority. No, she’s got a triple handicap. She’s also a foreigner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a U.S. citizen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but they see her as a foreigner because of that accent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t have much of an accent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To me and you she doesn’t because we’re used to hearing English like that. But to News Editor Joe Blow from Peoria, she talks like she’s singing Cantonese opera.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s doing really well at Presswire and they expect great things from her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I be honest with you, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha ha. I wish Lonnie were here, so I could have told her this, but listen. Newswires are for hacks, not professionals. It’s not seen as serious journalism. When newspapers have room left over, they squeeze in AP, UPI, or Presswire stories so they don’t have all that white space on the page.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you’re in the paper, you’re not a hack. Lonnie’s interview with Mr. Chen ran all over the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is the exception, though. The general public won’t see ninety-nine percent of her work. News from the United Nations? Give me a break, nobody reads that stuff, least of all newspaper editors! They put that in the paper so birds and dogs can shit on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me make sure I’ve got this all down, Artie. My girlfriend, Lonnie, is an illiterate foreigner who does hack work for animals to shit on. Are there any more ways you can put her down?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am not putting her down. I’m only saying that news is a tough business and she’s facing all kinds of hurdles. Tell her not to stay too long at Presswire. While she’s working there, she "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_272",
      "title": "272"
    }
  }, [_vm._v("should freelance for as many newspapers as possible, if her editor will let her. Two years is the max she should stay at a newswire. Then stick it on the résumé and check out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Check out to where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some regional newspaper. New York’s not where you climb the ladder. It’s where you come to after you’ve learned the ropes in smaller cities. Lonnie will probably have to spend a few years in the Midwest or down South.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa! Wait, why can’t she stay here in the city? There must be plenty of jobs at the "), _c('i', [_vm._v("Times")]), _vm._v(" or "), _c('i', [_vm._v("Daily News")]), _vm._v(" or "), _c('i', [_vm._v("Post")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course there are plenty of them. But those are all dead ends for someone at Lonnie’s low experience level. If you take one of those positions, you’ll be stuck fact-checking stories and doing research for higher-ranking reporters. Your newspaper will also hire from the outside to fill in higher-paying positions. Being a low-level man or woman at a New York City paper is like being stuck walking a beat for years without a promotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I imagined Peepshow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t want that to happen to Lonnie, do you?” asked Artie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t, but there must be exceptions to the rule.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are. If Daddy owns the paper, you’re on the fast track to promotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sound like you have a lot of personal issues tied into this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe. I know someone who’s been at "), _c('i', [_vm._v("The New York Sun")]), _vm._v(" for more than a decade.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve seen the "), _c('i', [_vm._v("Sun")]), _vm._v(" but I never pick it up. Is that a good place to work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She started there as a researcher with the understanding that they would put her on a reporting track. That never happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_273",
      "title": "273"
    }
  }, [_vm._v("“Is this woman Asian?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s black, and she maintains the clips library, which means she cuts out stories done by reporters and catalogs it. Isn’t that a shitty job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds better than my job, honestly. I’ll bet people don’t call her a fucking asshole to her face or shoot at her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Robert, it’s a shitty job when you thought you were going to write that big Pulitzer Prize–winning series. She doesn’t even get to work in the newsroom. She’s on a different floor, next to the ad sales department.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That doesn’t sound like a bad deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Journalists hate the business side because it’s ideas and idealism that drives them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Artie,” I said. “There’s something I’m wondering.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come you never left New York to get serious about journalism?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had thought about it. If I were entirely serious about being a reporter, I would have. But I knew I didn’t have the guts to, number one, really piss off my parents, and, number two, be willing to live in a small town for years as I built up my clips file.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You already disappointed your parents enough by not going to medical school. Becoming a reporter would have driven a rail spike into their hearts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can hear their voices complaining even now, God rest their souls. Yes, the paper had to be a hobby for me, but I was serious about it to the degree that I covered stories that nobody in the mainstream press did. I did have my fans, though. I would show you the letters I got, but, unfortunately, they were lost in the fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was the hate mail lost, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never kept those. All the negativity was water off my back. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_274",
      "title": "274"
    }
  }, [_vm._v("But I did frame one letter that said I was guilty of sensationalizing all the bad things that happened in Chinatown to sell papers. That was lost in the fire, too, but do you know who sent it to me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Tin! That guy who used to head the Greater China Association. Then the rumors got out that his son was retarded or insane, and he had to resign. The rest of the Greater China board thought that mental problems are hereditary and were wondering what was wrong with Mr. Tin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not just them. Most of the community.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I went to grade school with Don, his son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That makes sense. You guys are the same age.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wasn’t slow or crazy. He needed serious medical attention and Mr. Tin was too afraid to let him go to a doctor. He thought word wouldn’t get out, but it did anyway. I heard they all moved to London.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That seems far enough away.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" came into the squad room with two hot-dog pastries in a bag. I saw Vandyne wearing a white-collared shirt and a dark-blue sports jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa,” I said. “Where’s the job interview?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne nodded. “I’m applying for my old position as partner in a marriage. I’m meeting up with Rose for that trip to Pennsylvania.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I admired the shirt’s smooth look. “You even broke out the iron. That’s dedication.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I took it to the cleaners. I wasn’t taking any chances on my physical appearance. I don’t want her to think I’ve been slipping.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m no expert on women, but don’t you think you should look like you’re in bad shape without her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_275",
      "title": "275"
    }
  }, [_vm._v("“Naw, no way. A woman wants her man to look strong and sharp. Even if he has to fake it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put down the bag on my desk and shook off my wool coat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Getting chilly out there,” I said, “and it’ll probably be even colder out in Pennsylvania. You sure that garden will be open?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’ll be open. They’re even open on Christmas Day. What’s in the bag, Chow? I think I smell hot-dog pastries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t Lonnie forbid you from eating those anymore?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but I figured one wouldn’t hurt. We have to celebrate somehow. I brought one for you, too. I didn’t know you were leaving early.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m cutting out right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want one for the road?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to pass on that. I just got the car all cleaned out and that thing will stink it up.” He held up an oversized dark-green trench coat and did two breaststrokes into it. He twirled a striped green scarf around his neck and popped an olive fedora onto his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vandyne, that is the ugliest scarf I’ve ever seen. No wonder you never wear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He buttoned up his coat. Without looking at me, he said, “It was a present from Rose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I meant was that it doesn’t go well with the rest of the outfit. It clashes with the hat, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vandyne smiled. “I know it’s ugly. But when you love someone, you accept everything about that person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But then you end up looking ugly, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t that the point?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re going to wear that and you won’t eat a hot-dog pastry?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_276",
      "title": "276"
    }
  }, [_vm._v("“I can’t, partner, I can’t. I have to save my appetite.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right. Hey, man, I wish you the best of luck.” I shook his hand hard and clapped his back. “Both of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell Rose you said, ‘Hi.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After he left, I ate both hot-dog pastries by myself. I hadn’t eaten them in months. The first one was great but eating the second was a horrible mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "dl1"
  }, [_c('span', {
    staticClass: "bold_italic"
  }, [_vm._v("November 2, 1976")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("onnie had wanted to stay in the newsroom late to watch the presidential election but I told her she should watch it with me. We watched some of the early coverage together and I found myself getting into it. It looked like it was dead even between Ford and Carter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t feel strongly either way, but I thought Carter would win because the midget never picked losers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We had dinner at a Spanish restaurant in the neighborhood. Chicken, pork, and black beans and yellow rice. We came back and the race was still neck and neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paul was staying with the midget so we were alone in the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was so close for so long, I had to open a bag of potato chips and eat because I was anxious and there wasn’t anything else I could do. Lonnie was even more worked up than me but she wouldn’t eat the chips. She said she didn’t care who won because journalists were supposed to be objective, but I didn’t believe her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At midnight I turned off the TV and Lonnie screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I told her. “Save that for the bedroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_277",
      "title": "277"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("t some point in the night I woke up and saw Lonnie standing at the desk in my bedroom. She was holding something in the soft moonlight from the window.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lonnie was naked. Her hair shone ghostlike in the dark. It was now past her shoulders and even though she’d been talking about having to get it cut, she still hadn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that you’ve got over there?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a telephone dial,” she said. “Why is this on your desk? I don’t remember it being here before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s sort of a keepsake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something I had to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you hurt someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Of course not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you do something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shook my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me what it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s cold, Lonnie. Come back to bed and I will. Wait. Leave that thing on the desk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She got back in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, what did you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come here, let me hold you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was nothing, really, in the end, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was kind of a practical joke with Vandyne.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A joke?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s cop humor. Really inside stuff. You wouldn’t get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it’s part of a little story about a guy who thought that in the struggle against evil he would have to be extremely good. He thought that if he were even a little bad, that meant the bad "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_278",
      "title": "278"
    }
  }, [_vm._v("guys won. But that isn’t true. The good guys win as long as they do everything they can before resorting to being just a little bit bad.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you know what? This guy, our hero, promised he would always be after criminals, not money, and he made the promise with his best friend. That made everything all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s wrong?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Falling asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go to sleep, now, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I traced the edge of her earlobe through her hair with my finger. It felt cold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat up on my right elbow, looked through the torn mesh screen in my dirty window, and admired the quiet of the night.")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample.  Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780062444202',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(100)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(102);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 102 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.f4facebbc628e6c22262.js